// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.mat-ripple {
  overflow: hidden;
  position: relative;
}
.mat-ripple:not(:empty) {
  transform: translateZ(0);
}

.mat-ripple.mat-ripple-unbounded {
  overflow: visible;
}

.mat-ripple-element {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);
  transform: scale3d(0, 0, 0);
}
.cdk-high-contrast-active .mat-ripple-element {
  display: none;
}

.cdk-visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  left: 0;
}
[dir=rtl] .cdk-visually-hidden {
  left: auto;
  right: 0;
}

.cdk-overlay-container, .cdk-global-overlay-wrapper {
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.cdk-overlay-container {
  position: fixed;
  z-index: 1000;
}
.cdk-overlay-container:empty {
  display: none;
}

.cdk-global-overlay-wrapper {
  display: flex;
  position: absolute;
  z-index: 1000;
}

.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
}

.cdk-overlay-backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
}
.cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 1;
}
.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0.6;
}

.cdk-overlay-dark-backdrop {
  background: rgba(0, 0, 0, 0.32);
}

.cdk-overlay-transparent-backdrop {
  transition: visibility 1ms linear, opacity 1ms linear;
  visibility: hidden;
  opacity: 1;
}
.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0;
  visibility: visible;
}

.cdk-overlay-backdrop-noop-animation {
  transition: none;
}

.cdk-overlay-connected-position-bounding-box {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 1px;
  min-height: 1px;
}

.cdk-global-scrollblock {
  position: fixed;
  width: 100%;
  overflow-y: scroll;
}

textarea.cdk-textarea-autosize {
  resize: none;
}

textarea.cdk-textarea-autosize-measuring {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: auto !important;
  overflow: hidden !important;
}

textarea.cdk-textarea-autosize-measuring-firefox {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: 0 !important;
}

@keyframes cdk-text-field-autofill-start { /*!*/ }
@keyframes cdk-text-field-autofill-end { /*!*/ }
.cdk-text-field-autofill-monitored:-webkit-autofill {
  animation: cdk-text-field-autofill-start 0s 1ms;
}

.cdk-text-field-autofill-monitored:not(:-webkit-autofill) {
  animation: cdk-text-field-autofill-end 0s 1ms;
}

.mat-focus-indicator {
  position: relative;
}
.mat-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-focus-indicator-display, none);
  border: var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);
  border-radius: var(--mat-focus-indicator-border-radius, 4px);
}
.mat-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-focus-indicator-display: block;
}

.mat-mdc-focus-indicator {
  position: relative;
}
.mat-mdc-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-mdc-focus-indicator-display, none);
  border: var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);
  border-radius: var(--mat-mdc-focus-indicator-border-radius, 4px);
}
.mat-mdc-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-mdc-focus-indicator-display: block;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
body {
  font-family: "Barlow", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

h1 {
  font-size: 64px;
  line-height: 78px;
}

h2 {
  font-size: 56px;
  line-height: 68px;
}

h3 {
  font-size: 48px;
  line-height: 58px;
}

h4 {
  font-size: 40px;
  line-height: 48px;
}

h5 {
  font-size: 32px;
  line-height: 39px;
}

h6 {
  font-size: 24px;
  line-height: 29px;
}

a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: rgb(174, 15, 10);
  cursor: pointer;
  text-decoration: underline;
}

caption {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

th {
  font-weight: 700;
  cursor: pointer;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pr-0 {
  padding-right: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.m-0 {
  margin: 0px;
}

.mt-0 {
  margin-top: 0px;
}

.mr-0 {
  margin-right: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.ml-0 {
  margin-left: 0px;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.p-1 {
  padding: 8px;
}

.pt-1 {
  padding-top: 8px;
}

.pr-1 {
  padding-right: 8px;
}

.pb-1 {
  padding-bottom: 8px;
}

.pl-1 {
  padding-left: 8px;
}

.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.m-1 {
  margin: 8px;
}

.mt-1 {
  margin-top: 8px;
}

.mr-1 {
  margin-right: 8px;
}

.mb-1 {
  margin-bottom: 8px;
}

.ml-1 {
  margin-left: 8px;
}

.mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}

.my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.p-2 {
  padding: 16px;
}

.pt-2 {
  padding-top: 16px;
}

.pr-2 {
  padding-right: 16px;
}

.pb-2 {
  padding-bottom: 16px;
}

.pl-2 {
  padding-left: 16px;
}

.px-2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-2 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.m-2 {
  margin: 16px;
}

.mt-2 {
  margin-top: 16px;
}

.mr-2 {
  margin-right: 16px;
}

.mb-2 {
  margin-bottom: 16px;
}

.ml-2 {
  margin-left: 16px;
}

.mx-2 {
  margin-left: 16px;
  margin-right: 16px;
}

.my-2 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.p-3 {
  padding: 24px;
}

.pt-3 {
  padding-top: 24px;
}

.pr-3 {
  padding-right: 24px;
}

.pb-3 {
  padding-bottom: 24px;
}

.pl-3 {
  padding-left: 24px;
}

.px-3 {
  padding-left: 24px;
  padding-right: 24px;
}

.py-3 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.m-3 {
  margin: 24px;
}

.mt-3 {
  margin-top: 24px;
}

.mr-3 {
  margin-right: 24px;
}

.mb-3 {
  margin-bottom: 24px;
}

.ml-3 {
  margin-left: 24px;
}

.mx-3 {
  margin-left: 24px;
  margin-right: 24px;
}

.my-3 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.p-4 {
  padding: 32px;
}

.pt-4 {
  padding-top: 32px;
}

.pr-4 {
  padding-right: 32px;
}

.pb-4 {
  padding-bottom: 32px;
}

.pl-4 {
  padding-left: 32px;
}

.px-4 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-4 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.m-4 {
  margin: 32px;
}

.mt-4 {
  margin-top: 32px;
}

.mr-4 {
  margin-right: 32px;
}

.mb-4 {
  margin-bottom: 32px;
}

.ml-4 {
  margin-left: 32px;
}

.mx-4 {
  margin-left: 32px;
  margin-right: 32px;
}

.my-4 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.p-5 {
  padding: 40px;
}

.pt-5 {
  padding-top: 40px;
}

.pr-5 {
  padding-right: 40px;
}

.pb-5 {
  padding-bottom: 40px;
}

.pl-5 {
  padding-left: 40px;
}

.px-5 {
  padding-left: 40px;
  padding-right: 40px;
}

.py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.m-5 {
  margin: 40px;
}

.mt-5 {
  margin-top: 40px;
}

.mr-5 {
  margin-right: 40px;
}

.mb-5 {
  margin-bottom: 40px;
}

.ml-5 {
  margin-left: 40px;
}

.mx-5 {
  margin-left: 40px;
  margin-right: 40px;
}

.my-5 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.p-6 {
  padding: 48px;
}

.pt-6 {
  padding-top: 48px;
}

.pr-6 {
  padding-right: 48px;
}

.pb-6 {
  padding-bottom: 48px;
}

.pl-6 {
  padding-left: 48px;
}

.px-6 {
  padding-left: 48px;
  padding-right: 48px;
}

.py-6 {
  padding-top: 48px;
  padding-bottom: 48px;
}

.m-6 {
  margin: 48px;
}

.mt-6 {
  margin-top: 48px;
}

.mr-6 {
  margin-right: 48px;
}

.mb-6 {
  margin-bottom: 48px;
}

.ml-6 {
  margin-left: 48px;
}

.mx-6 {
  margin-left: 48px;
  margin-right: 48px;
}

.my-6 {
  margin-top: 48px;
  margin-bottom: 48px;
}

.p-7 {
  padding: 56px;
}

.pt-7 {
  padding-top: 56px;
}

.pr-7 {
  padding-right: 56px;
}

.pb-7 {
  padding-bottom: 56px;
}

.pl-7 {
  padding-left: 56px;
}

.px-7 {
  padding-left: 56px;
  padding-right: 56px;
}

.py-7 {
  padding-top: 56px;
  padding-bottom: 56px;
}

.m-7 {
  margin: 56px;
}

.mt-7 {
  margin-top: 56px;
}

.mr-7 {
  margin-right: 56px;
}

.mb-7 {
  margin-bottom: 56px;
}

.ml-7 {
  margin-left: 56px;
}

.mx-7 {
  margin-left: 56px;
  margin-right: 56px;
}

.my-7 {
  margin-top: 56px;
  margin-bottom: 56px;
}

.p-8 {
  padding: 64px;
}

.pt-8 {
  padding-top: 64px;
}

.pr-8 {
  padding-right: 64px;
}

.pb-8 {
  padding-bottom: 64px;
}

.pl-8 {
  padding-left: 64px;
}

.px-8 {
  padding-left: 64px;
  padding-right: 64px;
}

.py-8 {
  padding-top: 64px;
  padding-bottom: 64px;
}

.m-8 {
  margin: 64px;
}

.mt-8 {
  margin-top: 64px;
}

.mr-8 {
  margin-right: 64px;
}

.mb-8 {
  margin-bottom: 64px;
}

.ml-8 {
  margin-left: 64px;
}

.mx-8 {
  margin-left: 64px;
  margin-right: 64px;
}

.my-8 {
  margin-top: 64px;
  margin-bottom: 64px;
}

.p-9 {
  padding: 72px;
}

.pt-9 {
  padding-top: 72px;
}

.pr-9 {
  padding-right: 72px;
}

.pb-9 {
  padding-bottom: 72px;
}

.pl-9 {
  padding-left: 72px;
}

.px-9 {
  padding-left: 72px;
  padding-right: 72px;
}

.py-9 {
  padding-top: 72px;
  padding-bottom: 72px;
}

.m-9 {
  margin: 72px;
}

.mt-9 {
  margin-top: 72px;
}

.mr-9 {
  margin-right: 72px;
}

.mb-9 {
  margin-bottom: 72px;
}

.ml-9 {
  margin-left: 72px;
}

.mx-9 {
  margin-left: 72px;
  margin-right: 72px;
}

.my-9 {
  margin-top: 72px;
  margin-bottom: 72px;
}

.p-10 {
  padding: 80px;
}

.pt-10 {
  padding-top: 80px;
}

.pr-10 {
  padding-right: 80px;
}

.pb-10 {
  padding-bottom: 80px;
}

.pl-10 {
  padding-left: 80px;
}

.px-10 {
  padding-left: 80px;
  padding-right: 80px;
}

.py-10 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.m-10 {
  margin: 80px;
}

.mt-10 {
  margin-top: 80px;
}

.mr-10 {
  margin-right: 80px;
}

.mb-10 {
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 80px;
}

.mx-10 {
  margin-left: 80px;
  margin-right: 80px;
}

.my-10 {
  margin-top: 80px;
  margin-bottom: 80px;
}

html {
  --mdc-outlined-text-field-focus-outline-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mdc-outlined-text-field-focus-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-option-selected-state-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-datepicker-toggle-active-state-icon-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mdc-filled-text-field-focus-active-indicator-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-sidenav-content-background-color: white !important;
}

/* You can add global styles to this file, and also import other style files */
/* Angular 15 adds grey background on mat form components */
/* below removes that background color */
/* Manipulate initial background color*/
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

/*Manipulate background color on hover and focus*/
.mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  width: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted span {
  display: none;
}

/* Pagination menu */
.g-bubble-container {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.g-bubble {
  background-color: rgb(245, 246, 249);
  border-radius: 4px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(34, 36, 40) !important;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

.g-bubble:hover {
  background-color: rgb(189, 188, 188);
  color: rgb(245, 246, 249);
}

.g-bubble__active {
  background-color: rgb(227, 6, 19);
  color: rgb(227, 227, 227) !important;
  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12), 0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
}

mat-paginator {
  background: transparent !important;
}

.mat-mdc-paginator-range-actions {
  margin-right: 12px !important;
}

.mat-mdc-paginator-container {
  justify-content: center !important;
}

.mat-mdc-paginator-navigation-next,
.mat-mdc-paginator-navigation-previous {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgb(34, 36, 40) !important;
  padding: 0 !important;
  border-radius: 4px !important;
  width: 34px !important;
  height: 34px !important;
  background-color: rgb(245, 246, 249) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

/* End of pagination menu */
body {
  margin: 0;
}

.snackbar {
  width: 50vw;
  margin: 10px 0px !important;
}
.snackbar .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
}
.snackbar .mdc-snackbar__label {
  color: black !important;
}
.snackbar .mat-icon {
  margin-right: 12px;
}

.snackbar-custom {
  width: 50vw;
  margin-top: 75px !important;
}

.snacbar-warning {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-warning .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid #e0ac08;
}
.snacbar-warning .mdc-snackbar__label {
  color: black !important;
}
.snacbar-warning .mat-icon {
  margin-right: 12px;
}

.snacbar-sucess {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-sucess .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid green;
}
.snacbar-sucess .mdc-snackbar__label {
  color: black !important;
}
.snacbar-sucess .mat-icon {
  margin-right: 12px;
}

.snacbar-error {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-error .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid red;
}
.snacbar-error .mdc-snackbar__label {
  color: black !important;
}
.snacbar-error .mat-icon {
  margin-right: 12px;
}

.flex {
  display: flex;
}

.mat-mdc-menu-panel {
  overflow: hidden !important;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .menu-header {
  font-size: 12px;
  padding: 1rem;
  padding-bottom: 0.25rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item {
  margin-left: 1rem;
  padding-left: 0;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:first-of-type {
  margin-top: 0.75rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:not(:last-child) {
  border-bottom: 1px solid rgb(189, 188, 188);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3000;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sort-icon-container {
  display: inline-flex;
  align-items: center;
}
.sort-icon-container mat-icon {
  height: 1rem;
  width: 1rem;
}

@media (max-width: 767px) {
  app-edit-contract .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40% !important;
    height: 45px;
  }
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
  background: white;
  color: rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(189, 188, 188);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}

/* 
  IONIC components
*/
ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-item.no-padding-full {
  --padding-end: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
}

ion-checkbox {
  --checkbox-background-checked: rgba(174, 15, 10, 1);
  --border-color-checked: rgba(174, 15, 10, 1);
}

ion-input.custom-input {
  --border-color: rgba(135, 135, 135, 1);
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.custom-input-user {
  --border-color: #EFEFEF;
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.width-full {
  --border-color: #EFEFEF !important;
  --padding-top: 5px;
  --highlight-color: rgb(37, 19, 19);
}

.filter-panel {
  max-width: 100vw !important;
}

.date-select-modal-filter .mdc-text-field {
  height: 35px;
}
.date-select-modal-filter .mat-mdc-form-field-infix {
  height: 35px;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.date-select-modal-filter .select-year .mat-mdc-text-field-wrapper {
  background-color: #f4f4f4;
  border: 1px solid rgb(189, 188, 188);
}
.date-select-modal-filter .mdc-notched-outline__leading {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__notch {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__trailing {
  border: none !important;
}

@media (min-width: 1025px) {
  .filter-panel {
    max-height: 33rem !important;
    min-width: 60vw;
  }
  .anotation-panel {
    max-width: 30rem !important;
    max-height: 30rem !important;
    min-width: 50vw;
  }
  .historic-panel {
    min-width: 49.5rem;
    min-height: 35.625rem;
    min-width: 50vw;
  }
  .segments-panel {
    width: 72vw;
    min-width: 760px;
    max-width: 1100px !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    min-width: 49.5rem;
    min-height: 23.625rem;
    min-width: 50vw;
  }
}
@media (max-width: 1024px) {
  .btn-actions {
    margin-right: 15px;
  }
  .filter-panel {
    min-height: 30rem;
    max-width: 100vw !important;
    min-width: 90vw;
  }
  .historic-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
  .segments-panel {
    max-width: 90vw !important;
    min-width: 90vw !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
}
@media (max-width: 1024px) {
  .anotation-panel {
    width: 90%;
  }
}
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

@media (max-width: 1024px) {
  .mat-mdc-form-field-label {
    font-size: 0.8rem;
    /* Tamanho de fonte para dispositivos móveis */
  }
}
.button_cad {
  background-color: rgb(174, 15, 10);
  padding: 0.5rem 2rem;
  border-radius: 0.5rem;
  color: #fff;
  font-style: none;
  text-decoration: none;
}
.button_cad mat-icon {
  color: #fff !important;
}

::ng-deep.mat-mdc-card-header-text {
  display: none !important;
}

.input-error {
  border: 1px solid red; /* Ajuste o estilo conforme necessário */
}

.card-mobile {
  min-height: 10rem;
  margin: 1rem auto;
  border: 1px solid #cdcdcd;
}
.card-mobile .mat-mdc-card-header {
  width: 90%;
  display: flex;
  margin: auto;
  justify-content: space-between;
  padding: 0rem;
}
.card-mobile .mat-mdc-card-header p {
  font-weight: bolder;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.card-mobile .mat-mdc-card-header span,
.card-mobile .mat-mdc-card-header .subtitle {
  font-size: 1rem;
  font-weight: normal;
  color: #cdcdcd;
}
@media (max-width: 1024px) {
  .card-mobile .mat-mdc-card-header {
    width: 100%;
    margin: 0 16px;
  }
}
.card-mobile .mat-mdc-card-footer {
  margin: 1rem 0rem;
  border-top: 1px solid black;
  display: flex;
  align-items: center;
}
.card-mobile .mat-mdc-card-footer button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.card-mobile .extension {
  font-weight: bold;
  color: rgb(174, 15, 10);
}
@media (max-width: 1024px) {
  .card-mobile .formatAnotation {
    padding: 0 16px;
  }
}
.card-mobile .content-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-mobile .content-status {
  width: 40%;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.card-mobile .content-status p {
  font-weight: bold;
}

.card-mobile-empty {
  border: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-button.more-filters-btn {
  --background: rgba(174, 15, 10, 1);
  --color: white;
  --border-radius: 10px;
  width: 100%;
  max-width: 15rem;
  text-transform: capitalize;
  font-size: 0.9rem;
  height: 100%;
  font-weight: 600;
  letter-spacing: 0.08em;
}

ion-item.fast-filters {
  padding: 0.25rem 0rem;
}

ion-chip.fast-filter-active-primary {
  background-color: rgb(40, 186, 98);
  color: white;
}

ion-chip.fast-filter-active-secondary {
  background-color: rgb(235, 68, 90);
  color: white;
}

ion-chip.fast-filter-active-primary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

ion-chip.fast-filter-active-secondary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

.more-filters-btn-row {
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.more-filters-btn-row button {
  margin: 5px;
}
@media (max-width: 767px) {
  .more-filters-btn-row button {
    margin: 5px 0;
  }
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

ion-textarea,
ion-input {
  --border-color: rgba(87, 87, 86, 1);
  --padding-top: 5px !important;
  --highlight-color: rgba(135, 135, 135, 1);
  --highlight-color-focused: rgba(135, 135, 135, 1) !important;
  --highlight-color-valid: rgba(135, 135, 135, 1) !important;
  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;
}

ion-alert.custom-alert {
  --backdrop-opacity: 0.7;
}

ion-list.filtered-list {
  display: flex;
  flex-wrap: wrap;
}
ion-list.filtered-list span {
  padding: 0.75rem 0;
  margin: 0 0.75rem;
  border-bottom: 1px solid rgb(189, 188, 188);
  width: 100%;
}

ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-toast.snackbar-toast {
  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
  --width: fit-content;
  --border-radius: 0.75rem;
  --white-space: pre-line;
}

ion-toast.snackbar-toast::part(container) {
  background: #fff;
  color: rgb(34, 36, 40);
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0.75rem;
}

ion-toast.snackbar-toast.toast-success::part(container) {
  border: 1px solid rgb(45, 211, 111);
}
ion-toast.snackbar-toast.toast-success::part(icon) {
  color: rgb(45, 211, 111);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-error::part(container) {
  border: 1px solid rgb(235, 68, 90);
}
ion-toast.snackbar-toast.toast-error::part(icon) {
  color: rgb(235, 68, 90);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-right {
  --start: right;
  --box-shadow: none;
  --background: none;
}
ion-toast.snackbar-toast.toast-right::part(container) {
  transform: translateY(72px) !important;
  box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
}

::ng-deep.mat-tab-label {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

/* Styles for the active tab label */
::ng-deep.mat-tab-label.mat-tab-label-active {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border-color: #2b2b2b;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #2b2b2b;
}

.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {
  box-shadow: none !important;
}

.g-bubble {
  box-shadow: none !important;
}

app-modal-historic-segment {
  display: block;
  width: 100%;
  height: 45em;
}

.column-flex {
  display: flex;
  flex-flow: column;
}

.master-icon {
  background-color: rgb(255, 202, 34);
  color: rgb(34, 36, 40);
  border-radius: 10px;
  align-self: flex-start;
  font-size: 10px;
  padding: 0px 9px;
  margin: 6px 0;
  line-height: 17px;
  font-weight: 600;
}
.master-icon.center-horizontal {
  place-self: center;
}

ion-popover {
  --min-width: 375px;
  --max-width: 500px;
}

.custom-tooltip-menu {
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.custom-tooltip-menu .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background: none;
}
.custom-tooltip-menu .mdc-evolution-chip__text-label {
  color: #c00;
}

.custom-tooltip-menu .filter-title {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  display: block;
  margin-bottom: 4px;
  border-bottom: 1px solid grey;
}

.custom-tooltip-menu .tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.custom-tooltip-menu mat-chip {
  border: 1px solid #c00;
  height: 20px;
}

.custom-tooltip-menu mat-chip mat-icon {
  color: #c00 !important;
  cursor: pointer;
  font-size: 14px !important;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0px !important;
}

.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {
  color: #c00 !important;
  cursor: pointer;
  font-size: 12px !important;
  opacity: 1;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border: 1px solid #c00 !important;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #c00 !important;
}

ion-toggle {
  --handle-background-checked: rgba(174, 15, 10, 1);
  --track-background-checked: rgba(174, 15, 10, 0.38);
}

app-list-contracts thead {
  background: #F4F4F4 !important;
}

app-table-default thead {
  background: #F4F4F4 !important;
}

.mat-expansion-panel-body {
  padding: 0px !important;
}

.mat-mdc-paginator-range-actions {
  overflow-wrap: anywhere !important;
  flex-grow: 1;
  justify-content: center !important;
  position: relative !important;
}

.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {
  position: absolute !important;
  left: 0 !important;
}

.mat-mdc-tab {
  background-color: #F4F4F4 !important;
}

.mdc-tab--active {
  background-color: white !important;
}

@media (max-width: 1025px) {
  #paginator {
    width: 100%;
  }
}

ion-icon.search-icon-absolute {
  position: absolute;
  left: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}

ion-input.search-input label.input-wrapper {
  --padding-start: 55px;
}
.mat-mdc-icon-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.mat-mdc-unelevated-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.item-inner {
  padding-right: 0 !important;
}

@media (max-width: 496px) {
  .mat-mdc-paginator-page-size-label {
    display: none !important;
  }
}

.comentarios .mdc-text-field--outlined {
  --mdc-outlined-text-field-outline-width: 1px;
  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */
  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */
  --mdc-outlined-text-field-container-shape: 4px;
}

.g-0 {
  gap: 0 !important;
}

.g-1 {
  gap: 0.25rem !important;
}

.g-2 {
  gap: 0.5rem !important;
}

.g-3 {
  gap: 1rem !important;
}

.g-4 {
  gap: 1.5rem !important;
}

.g-5 {
  gap: 3rem !important;
}

.gx-0 {
  column-gap: 0 !important;
}

.gx-1 {
  column-gap: 0.25rem !important;
}

.gx-2 {
  column-gap: 0.5rem !important;
}

.gx-3 {
  column-gap: 1rem !important;
}

.gx-4 {
  column-gap: 1.5rem !important;
}

.gx-5 {
  column-gap: 3rem !important;
}

.gy-0 {
  row-gap: 0 !important;
}

.gy-1 {
  row-gap: 0.25rem !important;
}

.gy-2 {
  row-gap: 0.5rem !important;
}

.gy-3 {
  row-gap: 1rem !important;
}

.gy-4 {
  row-gap: 1.5rem !important;
}

.gy-5 {
  row-gap: 3rem !important;
}

.col {
  flex: 1 0 0%;
  max-width: 100%;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.col-1 {
  flex: 0 0 6.333333%;
  max-width: 6.333333%;
}

.col-2 {
  flex: 0 0 14.666667%;
  max-width: 14.666667%;
}

.col-3 {
  flex: 0 0 23%;
  max-width: 23%;
}

.col-4 {
  flex: 0 0 31.333333%;
  max-width: 31.333333%;
}

.col-5 {
  flex: 0 0 39.666667%;
  max-width: 39.666667%;
}

.col-6 {
  flex: 0 0 48%;
  max-width: 48%;
}

.col-7 {
  flex: 0 0 56.333333%;
  max-width: 56.333333%;
}

.col-8 {
  flex: 0 0 64.666667%;
  max-width: 64.666667%;
}

.col-9 {
  flex: 0 0 73%;
  max-width: 73%;
}

.col-10 {
  flex: 0 0 81.333333%;
  max-width: 81.333333%;
}

.col-11 {
  flex: 0 0 89.666667%;
  max-width: 89.666667%;
}

.col-12 {
  flex: 0 0 98%;
  max-width: 98%;
}

/* Colunas responsivas */
@media (min-width: 576px) { /* sm */
  .col-sm-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-sm-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-sm-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-sm-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-sm-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-sm-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-sm-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-sm-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-sm-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-sm-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-sm-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-sm-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 768px) { /* md */
  .col-md-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-md-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-md-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-md-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-md-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-md-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-md-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-md-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-md-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-md-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-md-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 992px) { /* lg */
  .col-lg-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-lg-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-lg-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-lg-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-lg-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-lg-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-lg-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-lg-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-lg-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-lg-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-lg-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-lg-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1200px) { /* xl */
  .col-xl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1400px) { /* xxl */
  .col-xxl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xxl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xxl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xxl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xxl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xxl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xxl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xxl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xxl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xxl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xxl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xxl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
.ampliacao-panel {
  max-width: 60vw !important;
}

.popover-content {
  max-height: 150px;
}

app-form-projetos thead tr th {
  font-family: "Barlow", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 100% !important;
}

app-form-projetos .mat-mdc-header-cell {
  border: none !important;
}

app-form-projetos .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #AE0F0A !important;
  background-color: #AE0F0A !important;
}

table {
  width: 100%;
  box-shadow: none;
  background-color: transparent;
  overflow: auto;
}

.component-segment {
  padding: 2rem;
}

.btn-area {
  width: 95%;
  margin: auto;
  bottom: 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.btn-area .btn-primary {
  background: rgb(174, 15, 10);
  margin: 0rem 2rem;
  color: azure;
}
.btn-area .btn-area:last-child {
  margin-right: 0rem;
}

@media (min-width: 800px) {
  .entitie-filters {
    width: 70% !important;
  }
  #paginator {
    width: 50%;
  }
  .paginator-segment {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .paginator-segment p {
    width: 50%;
    font-size: 1.5rem;
    font-weight: bold;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(1) {
  background: rgb(0, 87, 158);
  color: white;
  width: 100% !important;
  border-radius: 10px;
  padding: 0.75rem 0;
  margin-top: 50px;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(1) {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 100% !important;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(1)[disabled] {
  background: rgb(189, 188, 188);
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {
  background: white;
  color: rgb(174, 15, 10);
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2)[disabled] {
  background: rgb(189, 188, 188);
}

.btn-back {
  width: 100%;
  background-color: transparent !important;
  color: rgb(174, 15, 10) !important;
  border: 2px solid rgb(174, 15, 10) !important;
}

.fields {
  margin: 1rem auto;
  min-height: 30vh;
}
@media (max-width: 900px) {
  .fields .fields {
    flex: 1;
  }
}

.entitie-filters {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  transform: var(--mat-mdc-form-field-label-transform, translateY(0%) translateX(calc(1 * (0px + var(--mat-mdc-form-field-label-offset-x, 0px)))));
}
@media (max-width: 767px) {
  .entitie-filters {
    flex-direction: column;
    width: 100% !important;
  }
}
.entitie-filters .search-input {
  border: 1px solid;
  border-radius: 7px;
  display: flex;
  align-items: center;
  box-shadow: 1px 1px 1px 1px #cdcdcd;
  flex-grow: 3;
}

tr.example-detail-row {
  height: 0;
}

tr.example-element-row:not(.example-expanded-row):hover {
  background: whitesmoke;
}

tr.example-element-row:not(.example-expanded-row):active {
  background: #efefef;
}

.header-expanded-table {
  margin-top: 1rem;
}
.header-expanded-table .mat-mdc-form-field {
  width: 100%;
}
.header-expanded-table button {
  cursor: pointer;
  padding: 1rem 2rem;
  background-color: rgb(174, 15, 10);
  color: #fff;
  border: none;
  border-radius: 0.6rem;
  width: 100%;
  margin: 1rem 0rem !important;
}

.title {
  font-size: 1.5rem;
  display: flex;
  padding: 1rem;
  flex-direction: column;
  font-weight: bold;
}
.title .description {
  font-size: 1rem;
  font-weight: normal;
}
@media (max-width: 1024px) {
  .title {
    padding-left: 0;
  }
}

.mat-ripple {
  overflow: hidden;
  position: relative;
}
.mat-ripple:not(:empty) {
  transform: translateZ(0);
}

.mat-ripple.mat-ripple-unbounded {
  overflow: visible;
}

.mat-ripple-element {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);
  transform: scale3d(0, 0, 0);
}
.cdk-high-contrast-active .mat-ripple-element {
  display: none;
}

.cdk-visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  left: 0;
}
[dir=rtl] .cdk-visually-hidden {
  left: auto;
  right: 0;
}

.cdk-overlay-container, .cdk-global-overlay-wrapper {
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.cdk-overlay-container {
  position: fixed;
  z-index: 1000;
}
.cdk-overlay-container:empty {
  display: none;
}

.cdk-global-overlay-wrapper {
  display: flex;
  position: absolute;
  z-index: 1000;
}

.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
}

.cdk-overlay-backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
}
.cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 1;
}
.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0.6;
}

.cdk-overlay-dark-backdrop {
  background: rgba(0, 0, 0, 0.32);
}

.cdk-overlay-transparent-backdrop {
  transition: visibility 1ms linear, opacity 1ms linear;
  visibility: hidden;
  opacity: 1;
}
.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0;
  visibility: visible;
}

.cdk-overlay-backdrop-noop-animation {
  transition: none;
}

.cdk-overlay-connected-position-bounding-box {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 1px;
  min-height: 1px;
}

.cdk-global-scrollblock {
  position: fixed;
  width: 100%;
  overflow-y: scroll;
}

textarea.cdk-textarea-autosize {
  resize: none;
}

textarea.cdk-textarea-autosize-measuring {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: auto !important;
  overflow: hidden !important;
}

textarea.cdk-textarea-autosize-measuring-firefox {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: 0 !important;
}

@keyframes cdk-text-field-autofill-start { /*!*/ }
@keyframes cdk-text-field-autofill-end { /*!*/ }
.cdk-text-field-autofill-monitored:-webkit-autofill {
  animation: cdk-text-field-autofill-start 0s 1ms;
}

.cdk-text-field-autofill-monitored:not(:-webkit-autofill) {
  animation: cdk-text-field-autofill-end 0s 1ms;
}

.mat-focus-indicator {
  position: relative;
}
.mat-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-focus-indicator-display, none);
  border: var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);
  border-radius: var(--mat-focus-indicator-border-radius, 4px);
}
.mat-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-focus-indicator-display: block;
}

.mat-mdc-focus-indicator {
  position: relative;
}
.mat-mdc-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-mdc-focus-indicator-display, none);
  border: var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);
  border-radius: var(--mat-mdc-focus-indicator-border-radius, 4px);
}
.mat-mdc-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-mdc-focus-indicator-display: block;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
body {
  font-family: "Barlow", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

h1 {
  font-size: 64px;
  line-height: 78px;
}

h2 {
  font-size: 56px;
  line-height: 68px;
}

h3 {
  font-size: 48px;
  line-height: 58px;
}

h4 {
  font-size: 40px;
  line-height: 48px;
}

h5 {
  font-size: 32px;
  line-height: 39px;
}

h6 {
  font-size: 24px;
  line-height: 29px;
}

a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: rgb(174, 15, 10);
  cursor: pointer;
  text-decoration: underline;
}

caption {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

th {
  font-weight: 700;
  cursor: pointer;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pr-0 {
  padding-right: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.m-0 {
  margin: 0px;
}

.mt-0 {
  margin-top: 0px;
}

.mr-0 {
  margin-right: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.ml-0 {
  margin-left: 0px;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.p-1 {
  padding: 8px;
}

.pt-1 {
  padding-top: 8px;
}

.pr-1 {
  padding-right: 8px;
}

.pb-1 {
  padding-bottom: 8px;
}

.pl-1 {
  padding-left: 8px;
}

.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.m-1 {
  margin: 8px;
}

.mt-1 {
  margin-top: 8px;
}

.mr-1 {
  margin-right: 8px;
}

.mb-1 {
  margin-bottom: 8px;
}

.ml-1 {
  margin-left: 8px;
}

.mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}

.my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.p-2 {
  padding: 16px;
}

.pt-2 {
  padding-top: 16px;
}

.pr-2 {
  padding-right: 16px;
}

.pb-2 {
  padding-bottom: 16px;
}

.pl-2 {
  padding-left: 16px;
}

.px-2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-2 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.m-2 {
  margin: 16px;
}

.mt-2 {
  margin-top: 16px;
}

.mr-2 {
  margin-right: 16px;
}

.mb-2 {
  margin-bottom: 16px;
}

.ml-2 {
  margin-left: 16px;
}

.mx-2 {
  margin-left: 16px;
  margin-right: 16px;
}

.my-2 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.p-3 {
  padding: 24px;
}

.pt-3 {
  padding-top: 24px;
}

.pr-3 {
  padding-right: 24px;
}

.pb-3 {
  padding-bottom: 24px;
}

.pl-3 {
  padding-left: 24px;
}

.px-3 {
  padding-left: 24px;
  padding-right: 24px;
}

.py-3 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.m-3 {
  margin: 24px;
}

.mt-3 {
  margin-top: 24px;
}

.mr-3 {
  margin-right: 24px;
}

.mb-3 {
  margin-bottom: 24px;
}

.ml-3 {
  margin-left: 24px;
}

.mx-3 {
  margin-left: 24px;
  margin-right: 24px;
}

.my-3 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.p-4 {
  padding: 32px;
}

.pt-4 {
  padding-top: 32px;
}

.pr-4 {
  padding-right: 32px;
}

.pb-4 {
  padding-bottom: 32px;
}

.pl-4 {
  padding-left: 32px;
}

.px-4 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-4 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.m-4 {
  margin: 32px;
}

.mt-4 {
  margin-top: 32px;
}

.mr-4 {
  margin-right: 32px;
}

.mb-4 {
  margin-bottom: 32px;
}

.ml-4 {
  margin-left: 32px;
}

.mx-4 {
  margin-left: 32px;
  margin-right: 32px;
}

.my-4 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.p-5 {
  padding: 40px;
}

.pt-5 {
  padding-top: 40px;
}

.pr-5 {
  padding-right: 40px;
}

.pb-5 {
  padding-bottom: 40px;
}

.pl-5 {
  padding-left: 40px;
}

.px-5 {
  padding-left: 40px;
  padding-right: 40px;
}

.py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.m-5 {
  margin: 40px;
}

.mt-5 {
  margin-top: 40px;
}

.mr-5 {
  margin-right: 40px;
}

.mb-5 {
  margin-bottom: 40px;
}

.ml-5 {
  margin-left: 40px;
}

.mx-5 {
  margin-left: 40px;
  margin-right: 40px;
}

.my-5 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.p-6 {
  padding: 48px;
}

.pt-6 {
  padding-top: 48px;
}

.pr-6 {
  padding-right: 48px;
}

.pb-6 {
  padding-bottom: 48px;
}

.pl-6 {
  padding-left: 48px;
}

.px-6 {
  padding-left: 48px;
  padding-right: 48px;
}

.py-6 {
  padding-top: 48px;
  padding-bottom: 48px;
}

.m-6 {
  margin: 48px;
}

.mt-6 {
  margin-top: 48px;
}

.mr-6 {
  margin-right: 48px;
}

.mb-6 {
  margin-bottom: 48px;
}

.ml-6 {
  margin-left: 48px;
}

.mx-6 {
  margin-left: 48px;
  margin-right: 48px;
}

.my-6 {
  margin-top: 48px;
  margin-bottom: 48px;
}

.p-7 {
  padding: 56px;
}

.pt-7 {
  padding-top: 56px;
}

.pr-7 {
  padding-right: 56px;
}

.pb-7 {
  padding-bottom: 56px;
}

.pl-7 {
  padding-left: 56px;
}

.px-7 {
  padding-left: 56px;
  padding-right: 56px;
}

.py-7 {
  padding-top: 56px;
  padding-bottom: 56px;
}

.m-7 {
  margin: 56px;
}

.mt-7 {
  margin-top: 56px;
}

.mr-7 {
  margin-right: 56px;
}

.mb-7 {
  margin-bottom: 56px;
}

.ml-7 {
  margin-left: 56px;
}

.mx-7 {
  margin-left: 56px;
  margin-right: 56px;
}

.my-7 {
  margin-top: 56px;
  margin-bottom: 56px;
}

.p-8 {
  padding: 64px;
}

.pt-8 {
  padding-top: 64px;
}

.pr-8 {
  padding-right: 64px;
}

.pb-8 {
  padding-bottom: 64px;
}

.pl-8 {
  padding-left: 64px;
}

.px-8 {
  padding-left: 64px;
  padding-right: 64px;
}

.py-8 {
  padding-top: 64px;
  padding-bottom: 64px;
}

.m-8 {
  margin: 64px;
}

.mt-8 {
  margin-top: 64px;
}

.mr-8 {
  margin-right: 64px;
}

.mb-8 {
  margin-bottom: 64px;
}

.ml-8 {
  margin-left: 64px;
}

.mx-8 {
  margin-left: 64px;
  margin-right: 64px;
}

.my-8 {
  margin-top: 64px;
  margin-bottom: 64px;
}

.p-9 {
  padding: 72px;
}

.pt-9 {
  padding-top: 72px;
}

.pr-9 {
  padding-right: 72px;
}

.pb-9 {
  padding-bottom: 72px;
}

.pl-9 {
  padding-left: 72px;
}

.px-9 {
  padding-left: 72px;
  padding-right: 72px;
}

.py-9 {
  padding-top: 72px;
  padding-bottom: 72px;
}

.m-9 {
  margin: 72px;
}

.mt-9 {
  margin-top: 72px;
}

.mr-9 {
  margin-right: 72px;
}

.mb-9 {
  margin-bottom: 72px;
}

.ml-9 {
  margin-left: 72px;
}

.mx-9 {
  margin-left: 72px;
  margin-right: 72px;
}

.my-9 {
  margin-top: 72px;
  margin-bottom: 72px;
}

.p-10 {
  padding: 80px;
}

.pt-10 {
  padding-top: 80px;
}

.pr-10 {
  padding-right: 80px;
}

.pb-10 {
  padding-bottom: 80px;
}

.pl-10 {
  padding-left: 80px;
}

.px-10 {
  padding-left: 80px;
  padding-right: 80px;
}

.py-10 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.m-10 {
  margin: 80px;
}

.mt-10 {
  margin-top: 80px;
}

.mr-10 {
  margin-right: 80px;
}

.mb-10 {
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 80px;
}

.mx-10 {
  margin-left: 80px;
  margin-right: 80px;
}

.my-10 {
  margin-top: 80px;
  margin-bottom: 80px;
}

html {
  --mdc-outlined-text-field-focus-outline-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mdc-outlined-text-field-focus-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-option-selected-state-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-datepicker-toggle-active-state-icon-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mdc-filled-text-field-focus-active-indicator-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-sidenav-content-background-color: white !important;
}

/* You can add global styles to this file, and also import other style files */
/* Angular 15 adds grey background on mat form components */
/* below removes that background color */
/* Manipulate initial background color*/
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

/*Manipulate background color on hover and focus*/
.mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  width: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted span {
  display: none;
}

/* Pagination menu */
.g-bubble-container {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.g-bubble {
  background-color: rgb(245, 246, 249);
  border-radius: 4px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(34, 36, 40) !important;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

.g-bubble:hover {
  background-color: rgb(189, 188, 188);
  color: rgb(245, 246, 249);
}

.g-bubble__active {
  background-color: rgb(227, 6, 19);
  color: rgb(227, 227, 227) !important;
  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12), 0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
}

mat-paginator {
  background: transparent !important;
}

.mat-mdc-paginator-range-actions {
  margin-right: 12px !important;
}

.mat-mdc-paginator-container {
  justify-content: center !important;
}

.mat-mdc-paginator-navigation-next,
.mat-mdc-paginator-navigation-previous {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgb(34, 36, 40) !important;
  padding: 0 !important;
  border-radius: 4px !important;
  width: 34px !important;
  height: 34px !important;
  background-color: rgb(245, 246, 249) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

/* End of pagination menu */
body {
  margin: 0;
}

.snackbar {
  width: 50vw;
  margin: 10px 0px !important;
}
.snackbar .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
}
.snackbar .mdc-snackbar__label {
  color: black !important;
}
.snackbar .mat-icon {
  margin-right: 12px;
}

.snackbar-custom {
  width: 50vw;
  margin-top: 75px !important;
}

.snacbar-warning {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-warning .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid #e0ac08;
}
.snacbar-warning .mdc-snackbar__label {
  color: black !important;
}
.snacbar-warning .mat-icon {
  margin-right: 12px;
}

.snacbar-sucess {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-sucess .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid green;
}
.snacbar-sucess .mdc-snackbar__label {
  color: black !important;
}
.snacbar-sucess .mat-icon {
  margin-right: 12px;
}

.snacbar-error {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-error .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid red;
}
.snacbar-error .mdc-snackbar__label {
  color: black !important;
}
.snacbar-error .mat-icon {
  margin-right: 12px;
}

.flex {
  display: flex;
}

.mat-mdc-menu-panel {
  overflow: hidden !important;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .menu-header {
  font-size: 12px;
  padding: 1rem;
  padding-bottom: 0.25rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item {
  margin-left: 1rem;
  padding-left: 0;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:first-of-type {
  margin-top: 0.75rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:not(:last-child) {
  border-bottom: 1px solid rgb(189, 188, 188);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3000;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sort-icon-container {
  display: inline-flex;
  align-items: center;
}
.sort-icon-container mat-icon {
  height: 1rem;
  width: 1rem;
}

@media (max-width: 767px) {
  app-edit-contract .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40% !important;
    height: 45px;
  }
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
  background: white;
  color: rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(189, 188, 188);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}

/* 
  IONIC components
*/
ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-item.no-padding-full {
  --padding-end: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
}

ion-checkbox {
  --checkbox-background-checked: rgba(174, 15, 10, 1);
  --border-color-checked: rgba(174, 15, 10, 1);
}

ion-input.custom-input {
  --border-color: rgba(135, 135, 135, 1);
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.custom-input-user {
  --border-color: #EFEFEF;
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.width-full {
  --border-color: #EFEFEF !important;
  --padding-top: 5px;
  --highlight-color: rgb(37, 19, 19);
}

.filter-panel {
  max-width: 100vw !important;
}

.date-select-modal-filter .mdc-text-field {
  height: 35px;
}
.date-select-modal-filter .mat-mdc-form-field-infix {
  height: 35px;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.date-select-modal-filter .select-year .mat-mdc-text-field-wrapper {
  background-color: #f4f4f4;
  border: 1px solid rgb(189, 188, 188);
}
.date-select-modal-filter .mdc-notched-outline__leading {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__notch {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__trailing {
  border: none !important;
}

@media (min-width: 1025px) {
  .filter-panel {
    max-height: 33rem !important;
    min-width: 60vw;
  }
  .anotation-panel {
    max-width: 30rem !important;
    max-height: 30rem !important;
    min-width: 50vw;
  }
  .historic-panel {
    min-width: 49.5rem;
    min-height: 35.625rem;
    min-width: 50vw;
  }
  .segments-panel {
    width: 72vw;
    min-width: 760px;
    max-width: 1100px !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    min-width: 49.5rem;
    min-height: 23.625rem;
    min-width: 50vw;
  }
}
@media (max-width: 1024px) {
  .btn-actions {
    margin-right: 15px;
  }
  .filter-panel {
    min-height: 30rem;
    max-width: 100vw !important;
    min-width: 90vw;
  }
  .historic-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
  .segments-panel {
    max-width: 90vw !important;
    min-width: 90vw !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
}
@media (max-width: 1024px) {
  .anotation-panel {
    width: 90%;
  }
}
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

@media (max-width: 1024px) {
  .mat-mdc-form-field-label {
    font-size: 0.8rem;
    /* Tamanho de fonte para dispositivos móveis */
  }
}
.button_cad {
  background-color: rgb(174, 15, 10);
  padding: 0.5rem 2rem;
  border-radius: 0.5rem;
  color: #fff;
  font-style: none;
  text-decoration: none;
}
.button_cad mat-icon {
  color: #fff !important;
}

::ng-deep.mat-mdc-card-header-text {
  display: none !important;
}

.input-error {
  border: 1px solid red; /* Ajuste o estilo conforme necessário */
}

.card-mobile {
  min-height: 10rem;
  margin: 1rem auto;
  border: 1px solid #cdcdcd;
}
.card-mobile .mat-mdc-card-header {
  width: 90%;
  display: flex;
  margin: auto;
  justify-content: space-between;
  padding: 0rem;
}
.card-mobile .mat-mdc-card-header p {
  font-weight: bolder;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.card-mobile .mat-mdc-card-header span,
.card-mobile .mat-mdc-card-header .subtitle {
  font-size: 1rem;
  font-weight: normal;
  color: #cdcdcd;
}
@media (max-width: 1024px) {
  .card-mobile .mat-mdc-card-header {
    width: 100%;
    margin: 0 16px;
  }
}
.card-mobile .mat-mdc-card-footer {
  margin: 1rem 0rem;
  border-top: 1px solid black;
  display: flex;
  align-items: center;
}
.card-mobile .mat-mdc-card-footer button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.card-mobile .extension {
  font-weight: bold;
  color: rgb(174, 15, 10);
}
@media (max-width: 1024px) {
  .card-mobile .formatAnotation {
    padding: 0 16px;
  }
}
.card-mobile .content-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-mobile .content-status {
  width: 40%;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.card-mobile .content-status p {
  font-weight: bold;
}

.card-mobile-empty {
  border: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-button.more-filters-btn {
  --background: rgba(174, 15, 10, 1);
  --color: white;
  --border-radius: 10px;
  width: 100%;
  max-width: 15rem;
  text-transform: capitalize;
  font-size: 0.9rem;
  height: 100%;
  font-weight: 600;
  letter-spacing: 0.08em;
}

ion-item.fast-filters {
  padding: 0.25rem 0rem;
}

ion-chip.fast-filter-active-primary {
  background-color: rgb(40, 186, 98);
  color: white;
}

ion-chip.fast-filter-active-secondary {
  background-color: rgb(235, 68, 90);
  color: white;
}

ion-chip.fast-filter-active-primary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

ion-chip.fast-filter-active-secondary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

.more-filters-btn-row {
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.more-filters-btn-row button {
  margin: 5px;
}
@media (max-width: 767px) {
  .more-filters-btn-row button {
    margin: 5px 0;
  }
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

ion-textarea,
ion-input {
  --border-color: rgba(87, 87, 86, 1);
  --padding-top: 5px !important;
  --highlight-color: rgba(135, 135, 135, 1);
  --highlight-color-focused: rgba(135, 135, 135, 1) !important;
  --highlight-color-valid: rgba(135, 135, 135, 1) !important;
  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;
}

ion-alert.custom-alert {
  --backdrop-opacity: 0.7;
}

ion-list.filtered-list {
  display: flex;
  flex-wrap: wrap;
}
ion-list.filtered-list span {
  padding: 0.75rem 0;
  margin: 0 0.75rem;
  border-bottom: 1px solid rgb(189, 188, 188);
  width: 100%;
}

ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-toast.snackbar-toast {
  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
  --width: fit-content;
  --border-radius: 0.75rem;
  --white-space: pre-line;
}

ion-toast.snackbar-toast::part(container) {
  background: #fff;
  color: rgb(34, 36, 40);
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0.75rem;
}

ion-toast.snackbar-toast.toast-success::part(container) {
  border: 1px solid rgb(45, 211, 111);
}
ion-toast.snackbar-toast.toast-success::part(icon) {
  color: rgb(45, 211, 111);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-error::part(container) {
  border: 1px solid rgb(235, 68, 90);
}
ion-toast.snackbar-toast.toast-error::part(icon) {
  color: rgb(235, 68, 90);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-right {
  --start: right;
  --box-shadow: none;
  --background: none;
}
ion-toast.snackbar-toast.toast-right::part(container) {
  transform: translateY(72px) !important;
  box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
}

::ng-deep.mat-tab-label {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

/* Styles for the active tab label */
::ng-deep.mat-tab-label.mat-tab-label-active {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border-color: #2b2b2b;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #2b2b2b;
}

.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {
  box-shadow: none !important;
}

.g-bubble {
  box-shadow: none !important;
}

app-modal-historic-segment {
  display: block;
  width: 100%;
  height: 45em;
}

.column-flex {
  display: flex;
  flex-flow: column;
}

.master-icon {
  background-color: rgb(255, 202, 34);
  color: rgb(34, 36, 40);
  border-radius: 10px;
  align-self: flex-start;
  font-size: 10px;
  padding: 0px 9px;
  margin: 6px 0;
  line-height: 17px;
  font-weight: 600;
}
.master-icon.center-horizontal {
  place-self: center;
}

ion-popover {
  --min-width: 375px;
  --max-width: 500px;
}

.custom-tooltip-menu {
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.custom-tooltip-menu .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background: none;
}
.custom-tooltip-menu .mdc-evolution-chip__text-label {
  color: #c00;
}

.custom-tooltip-menu .filter-title {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  display: block;
  margin-bottom: 4px;
  border-bottom: 1px solid grey;
}

.custom-tooltip-menu .tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.custom-tooltip-menu mat-chip {
  border: 1px solid #c00;
  height: 20px;
}

.custom-tooltip-menu mat-chip mat-icon {
  color: #c00 !important;
  cursor: pointer;
  font-size: 14px !important;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0px !important;
}

.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {
  color: #c00 !important;
  cursor: pointer;
  font-size: 12px !important;
  opacity: 1;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border: 1px solid #c00 !important;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #c00 !important;
}

ion-toggle {
  --handle-background-checked: rgba(174, 15, 10, 1);
  --track-background-checked: rgba(174, 15, 10, 0.38);
}

app-list-contracts thead {
  background: #F4F4F4 !important;
}

app-table-default thead {
  background: #F4F4F4 !important;
}

.mat-expansion-panel-body {
  padding: 0px !important;
}

.mat-mdc-paginator-range-actions {
  overflow-wrap: anywhere !important;
  flex-grow: 1;
  justify-content: center !important;
  position: relative !important;
}

.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {
  position: absolute !important;
  left: 0 !important;
}

.mat-mdc-tab {
  background-color: #F4F4F4 !important;
}

.mdc-tab--active {
  background-color: white !important;
}

@media (max-width: 1025px) {
  #paginator {
    width: 100%;
  }
}

ion-icon.search-icon-absolute {
  position: absolute;
  left: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}

ion-input.search-input label.input-wrapper {
  --padding-start: 55px;
}
.mat-mdc-icon-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.mat-mdc-unelevated-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.item-inner {
  padding-right: 0 !important;
}

@media (max-width: 496px) {
  .mat-mdc-paginator-page-size-label {
    display: none !important;
  }
}

.comentarios .mdc-text-field--outlined {
  --mdc-outlined-text-field-outline-width: 1px;
  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */
  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */
  --mdc-outlined-text-field-container-shape: 4px;
}

.g-0 {
  gap: 0 !important;
}

.g-1 {
  gap: 0.25rem !important;
}

.g-2 {
  gap: 0.5rem !important;
}

.g-3 {
  gap: 1rem !important;
}

.g-4 {
  gap: 1.5rem !important;
}

.g-5 {
  gap: 3rem !important;
}

.gx-0 {
  column-gap: 0 !important;
}

.gx-1 {
  column-gap: 0.25rem !important;
}

.gx-2 {
  column-gap: 0.5rem !important;
}

.gx-3 {
  column-gap: 1rem !important;
}

.gx-4 {
  column-gap: 1.5rem !important;
}

.gx-5 {
  column-gap: 3rem !important;
}

.gy-0 {
  row-gap: 0 !important;
}

.gy-1 {
  row-gap: 0.25rem !important;
}

.gy-2 {
  row-gap: 0.5rem !important;
}

.gy-3 {
  row-gap: 1rem !important;
}

.gy-4 {
  row-gap: 1.5rem !important;
}

.gy-5 {
  row-gap: 3rem !important;
}

.col {
  flex: 1 0 0%;
  max-width: 100%;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.col-1 {
  flex: 0 0 6.333333%;
  max-width: 6.333333%;
}

.col-2 {
  flex: 0 0 14.666667%;
  max-width: 14.666667%;
}

.col-3 {
  flex: 0 0 23%;
  max-width: 23%;
}

.col-4 {
  flex: 0 0 31.333333%;
  max-width: 31.333333%;
}

.col-5 {
  flex: 0 0 39.666667%;
  max-width: 39.666667%;
}

.col-6 {
  flex: 0 0 48%;
  max-width: 48%;
}

.col-7 {
  flex: 0 0 56.333333%;
  max-width: 56.333333%;
}

.col-8 {
  flex: 0 0 64.666667%;
  max-width: 64.666667%;
}

.col-9 {
  flex: 0 0 73%;
  max-width: 73%;
}

.col-10 {
  flex: 0 0 81.333333%;
  max-width: 81.333333%;
}

.col-11 {
  flex: 0 0 89.666667%;
  max-width: 89.666667%;
}

.col-12 {
  flex: 0 0 98%;
  max-width: 98%;
}

/* Colunas responsivas */
@media (min-width: 576px) { /* sm */
  .col-sm-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-sm-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-sm-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-sm-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-sm-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-sm-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-sm-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-sm-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-sm-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-sm-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-sm-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-sm-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 768px) { /* md */
  .col-md-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-md-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-md-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-md-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-md-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-md-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-md-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-md-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-md-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-md-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-md-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 992px) { /* lg */
  .col-lg-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-lg-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-lg-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-lg-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-lg-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-lg-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-lg-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-lg-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-lg-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-lg-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-lg-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-lg-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1200px) { /* xl */
  .col-xl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1400px) { /* xxl */
  .col-xxl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xxl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xxl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xxl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xxl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xxl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xxl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xxl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xxl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xxl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xxl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xxl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
.ampliacao-panel {
  max-width: 60vw !important;
}

.popover-content {
  max-height: 150px;
}

app-form-projetos thead tr th {
  font-family: "Barlow", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 100% !important;
}

app-form-projetos .mat-mdc-header-cell {
  border: none !important;
}

app-form-projetos .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #AE0F0A !important;
  background-color: #AE0F0A !important;
}

.entities-list-container {
  padding: 1rem;
  background-color: white;
}
.entities-list-container .entitie-filters {
  display: flex;
  flex-wrap: wrap;
  transform: var(--mat-mdc-form-field-label-transform, translateY(0%) translateX(calc(1 * (0px + var(--mat-mdc-form-field-label-offset-x, 0px)))));
}
@media (max-width: 767px) {
  .entities-list-container .entitie-filters {
    flex-direction: column;
  }
}
.entities-list-container .entitie-filters .search-input {
  border: 1px solid;
  border-radius: 7px;
  display: flex;
  align-items: center;
  box-shadow: 1px 1px 1px 1px #cdcdcd;
  flex-grow: 3;
}
.entities-list-container h6 {
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.entities-list-container .filtros {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.entities-list-container .filtros .fast-filter {
  width: 30%;
  align-items: center;
  background: transparent;
}
.entities-list-container .filtros .fast-filter .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background-color: white;
  border: 1px solid rgb(112, 111, 111);
}
.entities-list-container .filtros .fast-filter .filter-by-active-entitie.mat-mdc-chip-selected.mdc-evolution-chip--selected {
  background-color: rgb(40, 186, 98);
}
.entities-list-container .filtros .fast-filter .filter-by-inactive-entitie.mat-mdc-chip-selected.mdc-evolution-chip--selected {
  background-color: rgb(235, 68, 90);
}
.entities-list-container .filtros .fast-filter .mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  display: none;
}
.entities-list-container .filtros .fast-filter span {
  color: rgb(112, 111, 111);
  font-weight: 400;
  align-content: center;
}
.entities-list-container .filtros .button-list {
  box-shadow: 1px 1px 1px 1px #cdcdcd;
  padding: 0.5rem 5rem;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  margin-bottom: 6px;
}
.entities-list-container .filtros .button-list .spacer {
  flex: 1;
}
.entities-list-container .filtros .button-list .mat-icon {
  margin-left: 0.5rem;
}
.entities-list-container .more-filters {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.entities-list-container .more-filters .mat-mdc-form-field {
  margin: 0rem 2rem;
  margin-bottom: -1rem;
}
.entities-list-container .more-filters .mat-picker {
  margin-right: 0rem !important;
}
.entities-list-container mat-form-field {
  margin-bottom: 16px;
}
.entities-list-container table {
  width: 100%;
}
.entities-list-container th {
  font-weight: 700;
}
.entities-list-container .entitie-list-table-wrapper {
  overflow: auto !important;
}
.entities-list-container .entitie-list-table-wrapper th {
  cursor: pointer;
}
.entities-list-container .status-container {
  display: flex;
  align-items: center;
}
.entities-list-container .status-container .mat-icon {
  width: 1rem;
}
.entities-list-container .status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.entities-list-container .status-container .active {
  color: rgb(40, 186, 98);
}
.entities-list-container .status-container .inactive {
  color: rgb(235, 68, 90);
}
.entities-list-container .create-entitie-link {
  display: flex;
  margin-bottom: 1.5rem;
}
.entities-list-container .create-entitie-link mat-icon {
  height: 1rem;
}
.entities-list-container .icon-entitie-actions-menu {
  color: rgb(174, 15, 10);
}

::ng-deep .mat-calendar-body-selected {
  background-color: red !important;
}

::ng-deep .mat-calendar-body-cell-content {
  border-radius: 0rem !important;
}

::ng-deep .mat-calendar-body-selected.mat-calendar-body-today {
  box-shadow: none;
}

@media (max-width: 700px) {
  .btn-area {
    width: 90% !important;
    flex-direction: column;
  }
  .btn-area .btn-primary {
    width: 100%;
    margin: auto !important;
    margin-bottom: 1rem !important;
  }
  .filtros {
    flex-direction: column;
    align-items: center;
  }
  .fast-filter {
    width: 100% !important;
    margin: 1rem 0rem;
  }
  .more-filters {
    width: 100%;
    margin: 1rem auto;
    flex-direction: column;
    align-items: center;
  }
  .more-filters .mat-mdc-form-field {
    width: 100%;
    margin: 0rem !important;
    margin-bottom: 1rem;
  }
  .label {
    font-size: 0.7rem;
  }
}
::ng-deep .mat-mdc-form-field-label {
  transform: none !important;
}

.mat-mdc-form-field-label {
  transform: none !important;
}

#paginator {
  width: 100%;
}

.paginator-segment {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.paginator-segment p {
  width: 100%;
  font-size: 1.5rem;
  font-weight: bold;
}

@media (min-width: 1000px) {
  .fast-filter {
    width: 50% !important;
    margin: 1rem 0rem;
  }
  .header-expanded-table {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .header-expanded-table .mat-mdc-form-field {
    width: 70%;
  }
  .header-expanded-table button {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media (min-width: 999px) {
  #paginator {
    width: 80%;
  }
  .paginator-segment {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .paginator-segment p {
    width: 20%;
    font-size: 1.5rem;
    font-weight: bold;
  }
}
.mat-ripple {
  overflow: hidden;
  position: relative;
}
.mat-ripple:not(:empty) {
  transform: translateZ(0);
}

.mat-ripple.mat-ripple-unbounded {
  overflow: visible;
}

.mat-ripple-element {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);
  transform: scale3d(0, 0, 0);
}
.cdk-high-contrast-active .mat-ripple-element {
  display: none;
}

.cdk-visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  left: 0;
}
[dir=rtl] .cdk-visually-hidden {
  left: auto;
  right: 0;
}

.cdk-overlay-container, .cdk-global-overlay-wrapper {
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.cdk-overlay-container {
  position: fixed;
  z-index: 1000;
}
.cdk-overlay-container:empty {
  display: none;
}

.cdk-global-overlay-wrapper {
  display: flex;
  position: absolute;
  z-index: 1000;
}

.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
}

.cdk-overlay-backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
}
.cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 1;
}
.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0.6;
}

.cdk-overlay-dark-backdrop {
  background: rgba(0, 0, 0, 0.32);
}

.cdk-overlay-transparent-backdrop {
  transition: visibility 1ms linear, opacity 1ms linear;
  visibility: hidden;
  opacity: 1;
}
.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0;
  visibility: visible;
}

.cdk-overlay-backdrop-noop-animation {
  transition: none;
}

.cdk-overlay-connected-position-bounding-box {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 1px;
  min-height: 1px;
}

.cdk-global-scrollblock {
  position: fixed;
  width: 100%;
  overflow-y: scroll;
}

textarea.cdk-textarea-autosize {
  resize: none;
}

textarea.cdk-textarea-autosize-measuring {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: auto !important;
  overflow: hidden !important;
}

textarea.cdk-textarea-autosize-measuring-firefox {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: 0 !important;
}

@keyframes cdk-text-field-autofill-start { /*!*/ }
@keyframes cdk-text-field-autofill-end { /*!*/ }
.cdk-text-field-autofill-monitored:-webkit-autofill {
  animation: cdk-text-field-autofill-start 0s 1ms;
}

.cdk-text-field-autofill-monitored:not(:-webkit-autofill) {
  animation: cdk-text-field-autofill-end 0s 1ms;
}

.mat-focus-indicator {
  position: relative;
}
.mat-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-focus-indicator-display, none);
  border: var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);
  border-radius: var(--mat-focus-indicator-border-radius, 4px);
}
.mat-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-focus-indicator-display: block;
}

.mat-mdc-focus-indicator {
  position: relative;
}
.mat-mdc-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-mdc-focus-indicator-display, none);
  border: var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);
  border-radius: var(--mat-mdc-focus-indicator-border-radius, 4px);
}
.mat-mdc-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-mdc-focus-indicator-display: block;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
body {
  font-family: "Barlow", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

h1 {
  font-size: 64px;
  line-height: 78px;
}

h2 {
  font-size: 56px;
  line-height: 68px;
}

h3 {
  font-size: 48px;
  line-height: 58px;
}

h4 {
  font-size: 40px;
  line-height: 48px;
}

h5 {
  font-size: 32px;
  line-height: 39px;
}

h6 {
  font-size: 24px;
  line-height: 29px;
}

a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: rgb(174, 15, 10);
  cursor: pointer;
  text-decoration: underline;
}

caption {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

th {
  font-weight: 700;
  cursor: pointer;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pr-0 {
  padding-right: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.m-0 {
  margin: 0px;
}

.mt-0 {
  margin-top: 0px;
}

.mr-0 {
  margin-right: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.ml-0 {
  margin-left: 0px;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.p-1 {
  padding: 8px;
}

.pt-1 {
  padding-top: 8px;
}

.pr-1 {
  padding-right: 8px;
}

.pb-1 {
  padding-bottom: 8px;
}

.pl-1 {
  padding-left: 8px;
}

.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.m-1 {
  margin: 8px;
}

.mt-1 {
  margin-top: 8px;
}

.mr-1 {
  margin-right: 8px;
}

.mb-1 {
  margin-bottom: 8px;
}

.ml-1 {
  margin-left: 8px;
}

.mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}

.my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.p-2 {
  padding: 16px;
}

.pt-2 {
  padding-top: 16px;
}

.pr-2 {
  padding-right: 16px;
}

.pb-2 {
  padding-bottom: 16px;
}

.pl-2 {
  padding-left: 16px;
}

.px-2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-2 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.m-2 {
  margin: 16px;
}

.mt-2 {
  margin-top: 16px;
}

.mr-2 {
  margin-right: 16px;
}

.mb-2 {
  margin-bottom: 16px;
}

.ml-2 {
  margin-left: 16px;
}

.mx-2 {
  margin-left: 16px;
  margin-right: 16px;
}

.my-2 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.p-3 {
  padding: 24px;
}

.pt-3 {
  padding-top: 24px;
}

.pr-3 {
  padding-right: 24px;
}

.pb-3 {
  padding-bottom: 24px;
}

.pl-3 {
  padding-left: 24px;
}

.px-3 {
  padding-left: 24px;
  padding-right: 24px;
}

.py-3 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.m-3 {
  margin: 24px;
}

.mt-3 {
  margin-top: 24px;
}

.mr-3 {
  margin-right: 24px;
}

.mb-3 {
  margin-bottom: 24px;
}

.ml-3 {
  margin-left: 24px;
}

.mx-3 {
  margin-left: 24px;
  margin-right: 24px;
}

.my-3 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.p-4 {
  padding: 32px;
}

.pt-4 {
  padding-top: 32px;
}

.pr-4 {
  padding-right: 32px;
}

.pb-4 {
  padding-bottom: 32px;
}

.pl-4 {
  padding-left: 32px;
}

.px-4 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-4 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.m-4 {
  margin: 32px;
}

.mt-4 {
  margin-top: 32px;
}

.mr-4 {
  margin-right: 32px;
}

.mb-4 {
  margin-bottom: 32px;
}

.ml-4 {
  margin-left: 32px;
}

.mx-4 {
  margin-left: 32px;
  margin-right: 32px;
}

.my-4 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.p-5 {
  padding: 40px;
}

.pt-5 {
  padding-top: 40px;
}

.pr-5 {
  padding-right: 40px;
}

.pb-5 {
  padding-bottom: 40px;
}

.pl-5 {
  padding-left: 40px;
}

.px-5 {
  padding-left: 40px;
  padding-right: 40px;
}

.py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.m-5 {
  margin: 40px;
}

.mt-5 {
  margin-top: 40px;
}

.mr-5 {
  margin-right: 40px;
}

.mb-5 {
  margin-bottom: 40px;
}

.ml-5 {
  margin-left: 40px;
}

.mx-5 {
  margin-left: 40px;
  margin-right: 40px;
}

.my-5 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.p-6 {
  padding: 48px;
}

.pt-6 {
  padding-top: 48px;
}

.pr-6 {
  padding-right: 48px;
}

.pb-6 {
  padding-bottom: 48px;
}

.pl-6 {
  padding-left: 48px;
}

.px-6 {
  padding-left: 48px;
  padding-right: 48px;
}

.py-6 {
  padding-top: 48px;
  padding-bottom: 48px;
}

.m-6 {
  margin: 48px;
}

.mt-6 {
  margin-top: 48px;
}

.mr-6 {
  margin-right: 48px;
}

.mb-6 {
  margin-bottom: 48px;
}

.ml-6 {
  margin-left: 48px;
}

.mx-6 {
  margin-left: 48px;
  margin-right: 48px;
}

.my-6 {
  margin-top: 48px;
  margin-bottom: 48px;
}

.p-7 {
  padding: 56px;
}

.pt-7 {
  padding-top: 56px;
}

.pr-7 {
  padding-right: 56px;
}

.pb-7 {
  padding-bottom: 56px;
}

.pl-7 {
  padding-left: 56px;
}

.px-7 {
  padding-left: 56px;
  padding-right: 56px;
}

.py-7 {
  padding-top: 56px;
  padding-bottom: 56px;
}

.m-7 {
  margin: 56px;
}

.mt-7 {
  margin-top: 56px;
}

.mr-7 {
  margin-right: 56px;
}

.mb-7 {
  margin-bottom: 56px;
}

.ml-7 {
  margin-left: 56px;
}

.mx-7 {
  margin-left: 56px;
  margin-right: 56px;
}

.my-7 {
  margin-top: 56px;
  margin-bottom: 56px;
}

.p-8 {
  padding: 64px;
}

.pt-8 {
  padding-top: 64px;
}

.pr-8 {
  padding-right: 64px;
}

.pb-8 {
  padding-bottom: 64px;
}

.pl-8 {
  padding-left: 64px;
}

.px-8 {
  padding-left: 64px;
  padding-right: 64px;
}

.py-8 {
  padding-top: 64px;
  padding-bottom: 64px;
}

.m-8 {
  margin: 64px;
}

.mt-8 {
  margin-top: 64px;
}

.mr-8 {
  margin-right: 64px;
}

.mb-8 {
  margin-bottom: 64px;
}

.ml-8 {
  margin-left: 64px;
}

.mx-8 {
  margin-left: 64px;
  margin-right: 64px;
}

.my-8 {
  margin-top: 64px;
  margin-bottom: 64px;
}

.p-9 {
  padding: 72px;
}

.pt-9 {
  padding-top: 72px;
}

.pr-9 {
  padding-right: 72px;
}

.pb-9 {
  padding-bottom: 72px;
}

.pl-9 {
  padding-left: 72px;
}

.px-9 {
  padding-left: 72px;
  padding-right: 72px;
}

.py-9 {
  padding-top: 72px;
  padding-bottom: 72px;
}

.m-9 {
  margin: 72px;
}

.mt-9 {
  margin-top: 72px;
}

.mr-9 {
  margin-right: 72px;
}

.mb-9 {
  margin-bottom: 72px;
}

.ml-9 {
  margin-left: 72px;
}

.mx-9 {
  margin-left: 72px;
  margin-right: 72px;
}

.my-9 {
  margin-top: 72px;
  margin-bottom: 72px;
}

.p-10 {
  padding: 80px;
}

.pt-10 {
  padding-top: 80px;
}

.pr-10 {
  padding-right: 80px;
}

.pb-10 {
  padding-bottom: 80px;
}

.pl-10 {
  padding-left: 80px;
}

.px-10 {
  padding-left: 80px;
  padding-right: 80px;
}

.py-10 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.m-10 {
  margin: 80px;
}

.mt-10 {
  margin-top: 80px;
}

.mr-10 {
  margin-right: 80px;
}

.mb-10 {
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 80px;
}

.mx-10 {
  margin-left: 80px;
  margin-right: 80px;
}

.my-10 {
  margin-top: 80px;
  margin-bottom: 80px;
}

html {
  --mdc-outlined-text-field-focus-outline-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mdc-outlined-text-field-focus-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-option-selected-state-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-datepicker-toggle-active-state-icon-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mdc-filled-text-field-focus-active-indicator-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-sidenav-content-background-color: white !important;
}

/* You can add global styles to this file, and also import other style files */
/* Angular 15 adds grey background on mat form components */
/* below removes that background color */
/* Manipulate initial background color*/
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

/*Manipulate background color on hover and focus*/
.mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  width: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted span {
  display: none;
}

/* Pagination menu */
.g-bubble-container {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.g-bubble {
  background-color: rgb(245, 246, 249);
  border-radius: 4px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(34, 36, 40) !important;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

.g-bubble:hover {
  background-color: rgb(189, 188, 188);
  color: rgb(245, 246, 249);
}

.g-bubble__active {
  background-color: rgb(227, 6, 19);
  color: rgb(227, 227, 227) !important;
  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12), 0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
}

mat-paginator {
  background: transparent !important;
}

.mat-mdc-paginator-range-actions {
  margin-right: 12px !important;
}

.mat-mdc-paginator-container {
  justify-content: center !important;
}

.mat-mdc-paginator-navigation-next,
.mat-mdc-paginator-navigation-previous {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgb(34, 36, 40) !important;
  padding: 0 !important;
  border-radius: 4px !important;
  width: 34px !important;
  height: 34px !important;
  background-color: rgb(245, 246, 249) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

/* End of pagination menu */
body {
  margin: 0;
}

.snackbar {
  width: 50vw;
  margin: 10px 0px !important;
}
.snackbar .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
}
.snackbar .mdc-snackbar__label {
  color: black !important;
}
.snackbar .mat-icon {
  margin-right: 12px;
}

.snackbar-custom {
  width: 50vw;
  margin-top: 75px !important;
}

.snacbar-warning {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-warning .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid #e0ac08;
}
.snacbar-warning .mdc-snackbar__label {
  color: black !important;
}
.snacbar-warning .mat-icon {
  margin-right: 12px;
}

.snacbar-sucess {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-sucess .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid green;
}
.snacbar-sucess .mdc-snackbar__label {
  color: black !important;
}
.snacbar-sucess .mat-icon {
  margin-right: 12px;
}

.snacbar-error {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-error .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid red;
}
.snacbar-error .mdc-snackbar__label {
  color: black !important;
}
.snacbar-error .mat-icon {
  margin-right: 12px;
}

.flex {
  display: flex;
}

.mat-mdc-menu-panel {
  overflow: hidden !important;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .menu-header {
  font-size: 12px;
  padding: 1rem;
  padding-bottom: 0.25rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item {
  margin-left: 1rem;
  padding-left: 0;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:first-of-type {
  margin-top: 0.75rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:not(:last-child) {
  border-bottom: 1px solid rgb(189, 188, 188);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3000;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sort-icon-container {
  display: inline-flex;
  align-items: center;
}
.sort-icon-container mat-icon {
  height: 1rem;
  width: 1rem;
}

@media (max-width: 767px) {
  app-edit-contract .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40% !important;
    height: 45px;
  }
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
  background: white;
  color: rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(189, 188, 188);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}

/* 
  IONIC components
*/
ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-item.no-padding-full {
  --padding-end: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
}

ion-checkbox {
  --checkbox-background-checked: rgba(174, 15, 10, 1);
  --border-color-checked: rgba(174, 15, 10, 1);
}

ion-input.custom-input {
  --border-color: rgba(135, 135, 135, 1);
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.custom-input-user {
  --border-color: #EFEFEF;
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.width-full {
  --border-color: #EFEFEF !important;
  --padding-top: 5px;
  --highlight-color: rgb(37, 19, 19);
}

.filter-panel {
  max-width: 100vw !important;
}

.date-select-modal-filter .mdc-text-field {
  height: 35px;
}
.date-select-modal-filter .mat-mdc-form-field-infix {
  height: 35px;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.date-select-modal-filter .select-year .mat-mdc-text-field-wrapper {
  background-color: #f4f4f4;
  border: 1px solid rgb(189, 188, 188);
}
.date-select-modal-filter .mdc-notched-outline__leading {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__notch {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__trailing {
  border: none !important;
}

@media (min-width: 1025px) {
  .filter-panel {
    max-height: 33rem !important;
    min-width: 60vw;
  }
  .anotation-panel {
    max-width: 30rem !important;
    max-height: 30rem !important;
    min-width: 50vw;
  }
  .historic-panel {
    min-width: 49.5rem;
    min-height: 35.625rem;
    min-width: 50vw;
  }
  .segments-panel {
    width: 72vw;
    min-width: 760px;
    max-width: 1100px !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    min-width: 49.5rem;
    min-height: 23.625rem;
    min-width: 50vw;
  }
}
@media (max-width: 1024px) {
  .btn-actions {
    margin-right: 15px;
  }
  .filter-panel {
    min-height: 30rem;
    max-width: 100vw !important;
    min-width: 90vw;
  }
  .historic-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
  .segments-panel {
    max-width: 90vw !important;
    min-width: 90vw !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
}
@media (max-width: 1024px) {
  .anotation-panel {
    width: 90%;
  }
}
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

@media (max-width: 1024px) {
  .mat-mdc-form-field-label {
    font-size: 0.8rem;
    /* Tamanho de fonte para dispositivos móveis */
  }
}
.button_cad {
  background-color: rgb(174, 15, 10);
  padding: 0.5rem 2rem;
  border-radius: 0.5rem;
  color: #fff;
  font-style: none;
  text-decoration: none;
}
.button_cad mat-icon {
  color: #fff !important;
}

::ng-deep.mat-mdc-card-header-text {
  display: none !important;
}

.input-error {
  border: 1px solid red; /* Ajuste o estilo conforme necessário */
}

.card-mobile {
  min-height: 10rem;
  margin: 1rem auto;
  border: 1px solid #cdcdcd;
}
.card-mobile .mat-mdc-card-header {
  width: 90%;
  display: flex;
  margin: auto;
  justify-content: space-between;
  padding: 0rem;
}
.card-mobile .mat-mdc-card-header p {
  font-weight: bolder;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.card-mobile .mat-mdc-card-header span,
.card-mobile .mat-mdc-card-header .subtitle {
  font-size: 1rem;
  font-weight: normal;
  color: #cdcdcd;
}
@media (max-width: 1024px) {
  .card-mobile .mat-mdc-card-header {
    width: 100%;
    margin: 0 16px;
  }
}
.card-mobile .mat-mdc-card-footer {
  margin: 1rem 0rem;
  border-top: 1px solid black;
  display: flex;
  align-items: center;
}
.card-mobile .mat-mdc-card-footer button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.card-mobile .extension {
  font-weight: bold;
  color: rgb(174, 15, 10);
}
@media (max-width: 1024px) {
  .card-mobile .formatAnotation {
    padding: 0 16px;
  }
}
.card-mobile .content-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-mobile .content-status {
  width: 40%;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.card-mobile .content-status p {
  font-weight: bold;
}

.card-mobile-empty {
  border: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-button.more-filters-btn {
  --background: rgba(174, 15, 10, 1);
  --color: white;
  --border-radius: 10px;
  width: 100%;
  max-width: 15rem;
  text-transform: capitalize;
  font-size: 0.9rem;
  height: 100%;
  font-weight: 600;
  letter-spacing: 0.08em;
}

ion-item.fast-filters {
  padding: 0.25rem 0rem;
}

ion-chip.fast-filter-active-primary {
  background-color: rgb(40, 186, 98);
  color: white;
}

ion-chip.fast-filter-active-secondary {
  background-color: rgb(235, 68, 90);
  color: white;
}

ion-chip.fast-filter-active-primary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

ion-chip.fast-filter-active-secondary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

.more-filters-btn-row {
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.more-filters-btn-row button {
  margin: 5px;
}
@media (max-width: 767px) {
  .more-filters-btn-row button {
    margin: 5px 0;
  }
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

ion-textarea,
ion-input {
  --border-color: rgba(87, 87, 86, 1);
  --padding-top: 5px !important;
  --highlight-color: rgba(135, 135, 135, 1);
  --highlight-color-focused: rgba(135, 135, 135, 1) !important;
  --highlight-color-valid: rgba(135, 135, 135, 1) !important;
  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;
}

ion-alert.custom-alert {
  --backdrop-opacity: 0.7;
}

ion-list.filtered-list {
  display: flex;
  flex-wrap: wrap;
}
ion-list.filtered-list span {
  padding: 0.75rem 0;
  margin: 0 0.75rem;
  border-bottom: 1px solid rgb(189, 188, 188);
  width: 100%;
}

ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-toast.snackbar-toast {
  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
  --width: fit-content;
  --border-radius: 0.75rem;
  --white-space: pre-line;
}

ion-toast.snackbar-toast::part(container) {
  background: #fff;
  color: rgb(34, 36, 40);
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0.75rem;
}

ion-toast.snackbar-toast.toast-success::part(container) {
  border: 1px solid rgb(45, 211, 111);
}
ion-toast.snackbar-toast.toast-success::part(icon) {
  color: rgb(45, 211, 111);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-error::part(container) {
  border: 1px solid rgb(235, 68, 90);
}
ion-toast.snackbar-toast.toast-error::part(icon) {
  color: rgb(235, 68, 90);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-right {
  --start: right;
  --box-shadow: none;
  --background: none;
}
ion-toast.snackbar-toast.toast-right::part(container) {
  transform: translateY(72px) !important;
  box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
}

::ng-deep.mat-tab-label {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

/* Styles for the active tab label */
::ng-deep.mat-tab-label.mat-tab-label-active {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border-color: #2b2b2b;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #2b2b2b;
}

.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {
  box-shadow: none !important;
}

.g-bubble {
  box-shadow: none !important;
}

app-modal-historic-segment {
  display: block;
  width: 100%;
  height: 45em;
}

.column-flex {
  display: flex;
  flex-flow: column;
}

.master-icon {
  background-color: rgb(255, 202, 34);
  color: rgb(34, 36, 40);
  border-radius: 10px;
  align-self: flex-start;
  font-size: 10px;
  padding: 0px 9px;
  margin: 6px 0;
  line-height: 17px;
  font-weight: 600;
}
.master-icon.center-horizontal {
  place-self: center;
}

ion-popover {
  --min-width: 375px;
  --max-width: 500px;
}

.custom-tooltip-menu {
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.custom-tooltip-menu .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background: none;
}
.custom-tooltip-menu .mdc-evolution-chip__text-label {
  color: #c00;
}

.custom-tooltip-menu .filter-title {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  display: block;
  margin-bottom: 4px;
  border-bottom: 1px solid grey;
}

.custom-tooltip-menu .tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.custom-tooltip-menu mat-chip {
  border: 1px solid #c00;
  height: 20px;
}

.custom-tooltip-menu mat-chip mat-icon {
  color: #c00 !important;
  cursor: pointer;
  font-size: 14px !important;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0px !important;
}

.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {
  color: #c00 !important;
  cursor: pointer;
  font-size: 12px !important;
  opacity: 1;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border: 1px solid #c00 !important;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #c00 !important;
}

ion-toggle {
  --handle-background-checked: rgba(174, 15, 10, 1);
  --track-background-checked: rgba(174, 15, 10, 0.38);
}

app-list-contracts thead {
  background: #F4F4F4 !important;
}

app-table-default thead {
  background: #F4F4F4 !important;
}

.mat-expansion-panel-body {
  padding: 0px !important;
}

.mat-mdc-paginator-range-actions {
  overflow-wrap: anywhere !important;
  flex-grow: 1;
  justify-content: center !important;
  position: relative !important;
}

.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {
  position: absolute !important;
  left: 0 !important;
}

.mat-mdc-tab {
  background-color: #F4F4F4 !important;
}

.mdc-tab--active {
  background-color: white !important;
}

@media (max-width: 1025px) {
  #paginator {
    width: 100%;
  }
}

ion-icon.search-icon-absolute {
  position: absolute;
  left: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}

ion-input.search-input label.input-wrapper {
  --padding-start: 55px;
}
.mat-mdc-icon-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.mat-mdc-unelevated-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.item-inner {
  padding-right: 0 !important;
}

@media (max-width: 496px) {
  .mat-mdc-paginator-page-size-label {
    display: none !important;
  }
}

.comentarios .mdc-text-field--outlined {
  --mdc-outlined-text-field-outline-width: 1px;
  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */
  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */
  --mdc-outlined-text-field-container-shape: 4px;
}

.g-0 {
  gap: 0 !important;
}

.g-1 {
  gap: 0.25rem !important;
}

.g-2 {
  gap: 0.5rem !important;
}

.g-3 {
  gap: 1rem !important;
}

.g-4 {
  gap: 1.5rem !important;
}

.g-5 {
  gap: 3rem !important;
}

.gx-0 {
  column-gap: 0 !important;
}

.gx-1 {
  column-gap: 0.25rem !important;
}

.gx-2 {
  column-gap: 0.5rem !important;
}

.gx-3 {
  column-gap: 1rem !important;
}

.gx-4 {
  column-gap: 1.5rem !important;
}

.gx-5 {
  column-gap: 3rem !important;
}

.gy-0 {
  row-gap: 0 !important;
}

.gy-1 {
  row-gap: 0.25rem !important;
}

.gy-2 {
  row-gap: 0.5rem !important;
}

.gy-3 {
  row-gap: 1rem !important;
}

.gy-4 {
  row-gap: 1.5rem !important;
}

.gy-5 {
  row-gap: 3rem !important;
}

.col {
  flex: 1 0 0%;
  max-width: 100%;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.col-1 {
  flex: 0 0 6.333333%;
  max-width: 6.333333%;
}

.col-2 {
  flex: 0 0 14.666667%;
  max-width: 14.666667%;
}

.col-3 {
  flex: 0 0 23%;
  max-width: 23%;
}

.col-4 {
  flex: 0 0 31.333333%;
  max-width: 31.333333%;
}

.col-5 {
  flex: 0 0 39.666667%;
  max-width: 39.666667%;
}

.col-6 {
  flex: 0 0 48%;
  max-width: 48%;
}

.col-7 {
  flex: 0 0 56.333333%;
  max-width: 56.333333%;
}

.col-8 {
  flex: 0 0 64.666667%;
  max-width: 64.666667%;
}

.col-9 {
  flex: 0 0 73%;
  max-width: 73%;
}

.col-10 {
  flex: 0 0 81.333333%;
  max-width: 81.333333%;
}

.col-11 {
  flex: 0 0 89.666667%;
  max-width: 89.666667%;
}

.col-12 {
  flex: 0 0 98%;
  max-width: 98%;
}

/* Colunas responsivas */
@media (min-width: 576px) { /* sm */
  .col-sm-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-sm-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-sm-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-sm-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-sm-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-sm-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-sm-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-sm-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-sm-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-sm-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-sm-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-sm-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 768px) { /* md */
  .col-md-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-md-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-md-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-md-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-md-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-md-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-md-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-md-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-md-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-md-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-md-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 992px) { /* lg */
  .col-lg-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-lg-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-lg-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-lg-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-lg-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-lg-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-lg-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-lg-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-lg-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-lg-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-lg-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-lg-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1200px) { /* xl */
  .col-xl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1400px) { /* xxl */
  .col-xxl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xxl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xxl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xxl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xxl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xxl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xxl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xxl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xxl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xxl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xxl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xxl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
.ampliacao-panel {
  max-width: 60vw !important;
}

.popover-content {
  max-height: 150px;
}

app-form-projetos thead tr th {
  font-family: "Barlow", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 100% !important;
}

app-form-projetos .mat-mdc-header-cell {
  border: none !important;
}

app-form-projetos .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #AE0F0A !important;
  background-color: #AE0F0A !important;
}

.field-width {
  width: 70%;
}
@media (max-width: 767px) {
  .field-width {
    width: 90%;
    margin-left: 15px;
  }
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

.login-container {
  display: flex;
}
@media (max-width: 767px) {
  .login-container {
    flex-direction: column;
  }
}

.form-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
}

.bold-font {
  font-weight: bold;
  font-size: 1rem;
}

.login-form {
  width: 100%;
  margin-bottom: 10rem;
  padding: 0 8rem;
}
@media (max-width: 767px) {
  .login-form {
    height: 92vh;
  }
}
.login-form form {
  height: inherit;
  display: flex;
  flex-direction: column;
}
@media (max-width: 767px) {
  .login-form form {
    height: 92vh;
  }
}
.login-form .fields {
  width: 100%;
  flex: 1;
  min-height: 55vh;
}
@media (max-width: 767px) {
  .login-form .fields {
    width: 100%;
  }
}
.login-form .subtitle {
  border-bottom: 1px solid black;
  margin: 1rem 0rem;
}
.login-form .subtitle h6 {
  margin: 0rem;
}
.login-form .line {
  display: flex;
  justify-content: center;
}
.login-form .line hr {
  border: none;
  height: 2px;
  background-color: #bdbcbc;
  width: 80%;
  border-radius: 5px;
}
@media (max-width: 767px) {
  .login-form .line hr {
    width: 100%;
  }
}
.login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(0, 87, 158);
  color: white;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  margin-top: 2.5rem;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 100% !important;
    height: 45px;
  }
}
.login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}
.login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {
  background: white;
  color: rgb(174, 15, 10);
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  margin-top: 2.5rem;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2)[disabled] {
  background: rgb(189, 188, 188);
}
.login-form .name-form-field {
  text-align: center;
  color: rgb(60, 60, 59);
}
.login-form .invalid {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
}
@media (max-width: 767px) {
  .login-form .invalid {
    margin-left: 5px;
  }
}
.login-form .invalid .icon-error {
  padding-left: 10px;
  padding-right: 8px;
}
.login-form .login-field-prefix {
  color: rgb(60, 60, 59);
}
.login-form .email-form-field {
  text-align: center;
  color: rgb(60, 60, 59);
}
.login-form .email-field-prefix {
  color: rgb(60, 60, 59);
}
.login-form .email-field-prefix-invalid {
  padding-top: 7px;
  padding-bottom: 15px;
  color: rgb(60, 60, 59);
}
.login-form h6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.login-form h6 mat-icon {
  cursor: pointer;
}
@media (max-width: 767px) {
  .login-form h6 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
}
.login-form .buttons {
  padding-bottom: 1rem;
  display: flex;
  justify-content: flex-end;
}
.login-form .buttons button:first-of-type {
  margin-right: 10px;
}
@media (max-width: 767px) {
  .login-form {
    margin-bottom: 1rem;
    padding: 0 1rem;
    width: 100%;
  }
}
@media (max-width: 1300px) {
  .login-form form {
    margin: 2rem;
  }
  .login-form .login-form {
    padding: 20px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .login-form {
    margin-bottom: 3rem;
    padding: 0 2rem;
  }
}
@media (min-width: 1025px) and (max-width: 1366px) {
  .login-form {
    margin-bottom: 4rem;
    padding: 0 4rem;
  }
}
@media (min-width: 1367px) {
  .login-form {
    margin-bottom: 5rem;
    padding: 0 4rem;
  }
}

.first-input {
  width: 100%;
}

@media (max-width: 1000px) {
  .buttons {
    display: flex;
    flex-direction: column;
  }
  .buttons button {
    width: 100% !important;
    margin: 0.5rem auto;
    padding: 1.5rem 1rem;
  }
}
.mat-expansion-panel-header-title {
  font-size: 1rem;
}

.panel-with-border .mat-expansion-panel-header {
  border-bottom: 1px solid black;
  /* Estilo da borda quando o painel está aberto */
}

.panel-with-border .mat-expansion-panel-header.mat-expanded {
  border-bottom: none;
  /* Remove a borda inferior quando o painel está aberto */
}

.panel-with-border.mat-expansion-panel {
  border-bottom: 1px solid black;
  /* Estilo da borda do painel quando fechado */
}

.mat-expansion-panel {
  box-shadow: none !important;
  background-color: transparent;
  border-radius: 0;
}

.mat-mdc-select-arrow-wrapper {
  display: none !important;
}

/* Estilizar o novo ícone */
.custom-select-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 24px;
  /* Ajuste o tamanho do ícone conforme necessário */
}

.form-group {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.form-group .mat-mdc-form-field {
  width: 45%;
}
.form-group .first-input {
  width: 100%;
}
.form-group .date-input {
  width: 20%;
}
.form-group .bank-form-field {
  width: 70%;
}
.form-group p {
  margin-top: 0px;
  font-size: 1.1rem;
}

.form-group-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form-group-row .mat-mdc-form-field {
  width: 30%;
}
.form-group-row .first-input {
  width: 100%;
}
.form-group-row .bank-form-field {
  width: 70%;
}
.form-group-row p {
  margin-top: 0px;
  font-size: 1.1rem;
}

.form-group-row2 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form-group-row2 .mat-mdc-form-field {
  width: 20%;
}
.form-group-row2 .first-input {
  width: 100%;
}
.form-group-row2 .bank-form-field {
  width: 70%;
}
.form-group-row2 p {
  margin-top: 0px;
  font-size: 1.1rem;
}

.date-select {
  width: 30%;
  display: flex;
}
.date-select .mat-mdc-form-field {
  width: 70%;
}
.date-select .select-year {
  width: 30%;
}

.btn-primary {
  margin: 0rem 1rem;
}

.btn-exclude {
  border: 2px solid rgb(112, 111, 111) !important;
  background-color: transparent !important;
  color: rgb(112, 111, 111) !important;
  font-weight: bold !important;
}

.btn-submit {
  background-color: rgb(174, 15, 10) !important;
  color: #fff !important;
  border: 2px solid rgb(174, 15, 10) !important;
}

.disabled-button {
  background-color: rgb(112, 111, 111) !important;
  color: white;
  border: 2px solid rgb(112, 111, 111) !important;
  cursor: not-allowed;
}

.btn-back {
  background-color: transparent !important;
  color: rgb(174, 15, 10) !important;
  border: 2px solid rgb(174, 15, 10) !important;
}

.header-form {
  display: flex;
  flex-direction: column;
}
.header-form .header-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-form .header-title h6 {
  margin-bottom: 0px;
}
.header-form .header-title .btn-header {
  display: flex;
  align-items: center;
}

.status-cadastrando {
  background-color: rgb(219, 151, 5);
  color: #fff;
  padding: 0.2rem 2rem;
  border-radius: 0.3rem;
}

.status-aprovado {
  background-color: green;
  color: #fff;
  padding: 0.2rem 2rem;
  border-radius: 0.3rem;
}

.status-rejeitado {
  background-color: red;
  color: #fff;
  padding: 0.2rem 2rem;
  border-radius: 0.3rem;
}

.status-desconhecido {
  background-color: gray;
  color: #fff;
  padding: 0.2rem 2rem;
  border-radius: 0.3rem;
}

.mat-mdc-expansion-panel-body {
  padding: 0px !important;
}

.data-eficacia-form-group {
  display: flex;
  align-items: center;
  width: 30%;
}
.data-eficacia-form-group .mat-mdc-form-field {
  width: 90%;
}

.form-section-field {
  margin: 2rem auto;
}

.header-legend {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.header-legend .first-filter {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-legend .first-filter .mat-mdc-form-field {
  width: 90%;
}
.header-legend .first-filter .btn {
  padding: 1rem 2rem;
  background-color: rgb(227, 6, 19);
  color: #fff;
  border-radius: 0.5rem;
  cursor: pointer;
  border: none;
}
.header-legend .first-filter .btn:hover {
  background-color: rgb(174, 15, 10);
}

.header-form {
  width: 100%;
  display: flex;
}
.header-form h6 {
  width: 80%;
}

.bredCrumb {
  margin: 1rem 0rem;
  align-items: center;
  justify-content: flex-start;
}

.bredCrumb p {
  display: inline;
  cursor: pointer;
}

.bredCrumb p.selected {
  font-weight: bold;
}

.anexos {
  display: flex;
  align-items: center;
}

@media (max-width: 1000px) {
  .form-group-row,
  .form-group {
    flex-direction: column;
  }
  .form-group-row .mat-mdc-form-field,
  .form-group .mat-mdc-form-field {
    width: 100%;
  }
  .data-eficacia-form-group {
    width: 100%;
  }
  .date-select {
    width: 100%;
  }
  .fields {
    flex: 1;
    min-height: auto !important;
  }
  .first-filter {
    flex-direction: column;
    width: 100%;
  }
  .first-filter .mat-mdc-form-field {
    width: 100%;
  }
  .first-filter .btn {
    margin: 1rem 0rem;
    width: 90%;
  }
  .filters {
    display: flex;
    flex-direction: column;
  }
  .filters .mat-mdc-form-field {
    width: 100%;
  }
  .login-form {
    width: 90% !important;
    margin: auto;
  }
}
@media (max-width: 600px) {
  .bredCrumb {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
}
table {
  width: 100%;
}

th {
  font-weight: 700;
}

.entitie-list-table-wrapper {
  overflow: auto;
}
.entitie-list-table-wrapper th {
  cursor: pointer;
}

.document-container {
  margin: 1rem auto;
  border-radius: 1rem 1rem 0rem 0rem;
  padding: 1rem;
}
.document-container .title-document {
  font-size: 1.2rem;
  font-weight: 700;
}
.document-container .header-document {
  margin: 1rem auto;
  margin: 1rem auto;
  display: flex;
  align-items: center;
}

@media (max-width: 999px) {
  .bredCrumb {
    align-items: flex-start;
  }
  .header-document {
    margin: 1rem auto;
    margin: 1rem auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
  }
  .header-document span {
    margin: 1rem 0rem;
    margin-left: 0px !important;
  }
  .row {
    margin: 1rem auto;
    flex-direction: column;
  }
  .row .mat-mdc-form-field {
    width: 100% !important;
  }
  .row button {
    width: 100%;
  }
}
:host {
  display: block;
  height: 100%;
}

.component-segment {
  height: 100%;
  max-height: calc(90vh - 2rem);
  padding: 1.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.component-segment h6 {
  margin: 1rem;
}

.fields {
  margin: 1rem auto;
  min-height: auto;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.entitie-list-table-wrapper {
  overflow: auto !important;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.paginator-segment {
  margin-top: 0.5rem;
}

.buttons {
  justify-content: center;
  display: flex;
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(1) {
  margin-top: 1rem;
}

@media (max-width: 1024px) {
  .component-segment {
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/contracts/segments/segments-table/segments-table.component.scss","webpack://./node_modules/@angular/material/core/ripple/_ripple.scss","webpack://./node_modules/@angular/cdk/a11y/_index.scss","webpack://./node_modules/@angular/cdk/overlay/_index.scss","webpack://./node_modules/@angular/cdk/text-field/_index.scss","webpack://./node_modules/@angular/material/core/focus-indicators/_private.scss","webpack://./node_modules/@angular/material/core/style/_layout-common.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/typography.scss","webpack://./src/theme/spacing.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACKd;EACE,gBAAA;EAIA,kBAAA;ADGJ;ACII;EACE,wBAAA;ADFN;;ACME;EACE,iBAAA;ADHJ;;ACME;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,6DAAA;EAIA,2BAAA;ADPJ;AEsBI;EDXE,aAAA;ADRN;;AE5BE;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EAIA,mBAAA;EAGA,UAAA;EAGA,wBAAA;EACA,qBAAA;EAMA,OAAA;AFmBJ;AEjBI;EACE,UAAA;EACA,QAAA;AFmBN;;AGnCE;EAEE,oBAAA;EAGA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AHmCJ;;AG/BE;EACE,eAAA;EACA,aA3BwB;AH6D5B;AGhCI;EAGE,aAAA;AHgCN;;AGxBE;EACE,aAAA;EACA,kBAAA;EACA,aA1Cc;AHqElB;;AGvBE;EAGE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aApDc;EAwDd,aAAA;EACA,eAAA;EACA,gBAAA;AHqBJ;;AGlBE;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aApEuB;EAqEvB,oBAAA;EACA,wCAAA;EACA,0DAAA;EACA,UAAA;AHmBJ;AGjBI;EACE,UAAA;AHmBN;AGdM;EAGE,YAAA;AHcR;;AGTE;EACE,+BAtFqB;AHkGzB;;AGTE;EAEE,qDAAA;EACA,kBAAA;EACA,UAAA;AHWJ;AGLI;EACE,UAAA;EACA,mBAAA;AHON;;AGHE;EACE,gBAAA;AHMJ;;AGDE;EACE,kBAAA;EACA,aArHc;EA0Hd,aAAA;EAIA,sBAAA;EAGA,cAAA;EACA,eAAA;AHLJ;;AGSE;EACE,eAAA;EAKA,WAAA;EAKA,kBAAA;AHdJ;;AInIE;EACE,YAAA;AJsIJ;;AIhIE;EAyCA,yBAAA;EACA,kCAAA;EAxCE,uBAAA;EACA,2BAAA;AJoIJ;;AI3HE;EA6BA,yBAAA;EACA,kCAAA;EA5BE,oBAAA;AJ+HJ;;AIrHE,2CAAA,IAAA,EAAA;AACA,yCAAA,IAAA,EAAA;AAEA;EAEE,+CAAA;AJsHJ;;AInHE;EAEE,6CAAA;AJqHJ;;AKpJE;EACE,kBAAA;ALuJJ;AKrJI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,iDAAA;EACA,wJAAA;EAYA,4DAAA;ALgJN;AKxII;EACE,WAAA;AL0IN;;AE/FM;EG7BA,oCAAA;ALgIN;;AK3KE;EACE,kBAAA;AL8KJ;AK5KI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,qDAAA;EACA,oKAAA;EAYA,gEAAA;ALuKN;AK/JI;EACE,WAAA;ALiKN;;AEtHM;EG7BA,wCAAA;ALuJN;;AOhNA;;;;;CAAA;ACEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ARuNF;;AQpNA;;;;;;EAME,qCAAA;EACA,gBAAA;ARuNF;;AQpNA;EACE,eAAA;EACA,iBAAA;ARuNF;;AQpNA;EACE,eAAA;EACA,iBAAA;ARuNF;;AQpNA;EACE,eAAA;EACA,iBAAA;ARuNF;;AQpNA;EACE,eAAA;EACA,iBAAA;ARuNF;;AQpNA;EACE,eAAA;EACA,iBAAA;ARuNF;;AQpNA;EACE,eAAA;EACA,iBAAA;ARuNF;;AQpNA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;ARuNF;;AQpNA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;ARuNF;;AQpNA;EACE,gBAAA;EACA,eAAA;ARuNF;;AOzRA;;;;;CAAA;AEeE;EACE,YAAA;ATmRJ;;ASjRE;EACE,gBAAA;AToRJ;;ASlRE;EACE,kBAAA;ATqRJ;;ASnRE;EACE,mBAAA;ATsRJ;;ASpRE;EACE,iBAAA;ATuRJ;;ASrRE;EACE,iBAAA;EACA,kBAAA;ATwRJ;;AStRE;EACE,gBAAA;EACA,mBAAA;ATyRJ;;AStRE;EACE,WAAA;ATyRJ;;ASvRE;EACE,eAAA;AT0RJ;;ASxRE;EACE,iBAAA;AT2RJ;;ASzRE;EACE,kBAAA;AT4RJ;;AS1RE;EACE,gBAAA;AT6RJ;;AS3RE;EACE,gBAAA;EACA,iBAAA;AT8RJ;;AS5RE;EACE,eAAA;EACA,kBAAA;AT+RJ;;AS5UE;EACE,YAAA;AT+UJ;;AS7UE;EACE,gBAAA;ATgVJ;;AS9UE;EACE,kBAAA;ATiVJ;;AS/UE;EACE,mBAAA;ATkVJ;;AShVE;EACE,iBAAA;ATmVJ;;ASjVE;EACE,iBAAA;EACA,kBAAA;AToVJ;;ASlVE;EACE,gBAAA;EACA,mBAAA;ATqVJ;;ASlVE;EACE,WAAA;ATqVJ;;ASnVE;EACE,eAAA;ATsVJ;;ASpVE;EACE,iBAAA;ATuVJ;;ASrVE;EACE,kBAAA;ATwVJ;;AStVE;EACE,gBAAA;ATyVJ;;ASvVE;EACE,gBAAA;EACA,iBAAA;AT0VJ;;ASxVE;EACE,eAAA;EACA,kBAAA;AT2VJ;;ASxYE;EACE,aAAA;AT2YJ;;ASzYE;EACE,iBAAA;AT4YJ;;AS1YE;EACE,mBAAA;AT6YJ;;AS3YE;EACE,oBAAA;AT8YJ;;AS5YE;EACE,kBAAA;AT+YJ;;AS7YE;EACE,kBAAA;EACA,mBAAA;ATgZJ;;AS9YE;EACE,iBAAA;EACA,oBAAA;ATiZJ;;AS9YE;EACE,YAAA;ATiZJ;;AS/YE;EACE,gBAAA;ATkZJ;;AShZE;EACE,kBAAA;ATmZJ;;ASjZE;EACE,mBAAA;AToZJ;;ASlZE;EACE,iBAAA;ATqZJ;;ASnZE;EACE,iBAAA;EACA,kBAAA;ATsZJ;;ASpZE;EACE,gBAAA;EACA,mBAAA;ATuZJ;;ASpcE;EACE,aAAA;ATucJ;;ASrcE;EACE,iBAAA;ATwcJ;;AStcE;EACE,mBAAA;ATycJ;;ASvcE;EACE,oBAAA;AT0cJ;;ASxcE;EACE,kBAAA;AT2cJ;;ASzcE;EACE,kBAAA;EACA,mBAAA;AT4cJ;;AS1cE;EACE,iBAAA;EACA,oBAAA;AT6cJ;;AS1cE;EACE,YAAA;AT6cJ;;AS3cE;EACE,gBAAA;AT8cJ;;AS5cE;EACE,kBAAA;AT+cJ;;AS7cE;EACE,mBAAA;ATgdJ;;AS9cE;EACE,iBAAA;ATidJ;;AS/cE;EACE,iBAAA;EACA,kBAAA;ATkdJ;;AShdE;EACE,gBAAA;EACA,mBAAA;ATmdJ;;AShgBE;EACE,aAAA;ATmgBJ;;ASjgBE;EACE,iBAAA;ATogBJ;;ASlgBE;EACE,mBAAA;ATqgBJ;;ASngBE;EACE,oBAAA;ATsgBJ;;ASpgBE;EACE,kBAAA;ATugBJ;;ASrgBE;EACE,kBAAA;EACA,mBAAA;ATwgBJ;;AStgBE;EACE,iBAAA;EACA,oBAAA;ATygBJ;;AStgBE;EACE,YAAA;ATygBJ;;ASvgBE;EACE,gBAAA;AT0gBJ;;ASxgBE;EACE,kBAAA;AT2gBJ;;ASzgBE;EACE,mBAAA;AT4gBJ;;AS1gBE;EACE,iBAAA;AT6gBJ;;AS3gBE;EACE,iBAAA;EACA,kBAAA;AT8gBJ;;AS5gBE;EACE,gBAAA;EACA,mBAAA;AT+gBJ;;AS5jBE;EACE,aAAA;AT+jBJ;;AS7jBE;EACE,iBAAA;ATgkBJ;;AS9jBE;EACE,mBAAA;ATikBJ;;AS/jBE;EACE,oBAAA;ATkkBJ;;AShkBE;EACE,kBAAA;ATmkBJ;;ASjkBE;EACE,kBAAA;EACA,mBAAA;ATokBJ;;ASlkBE;EACE,iBAAA;EACA,oBAAA;ATqkBJ;;ASlkBE;EACE,YAAA;ATqkBJ;;ASnkBE;EACE,gBAAA;ATskBJ;;ASpkBE;EACE,kBAAA;ATukBJ;;ASrkBE;EACE,mBAAA;ATwkBJ;;AStkBE;EACE,iBAAA;ATykBJ;;ASvkBE;EACE,iBAAA;EACA,kBAAA;AT0kBJ;;ASxkBE;EACE,gBAAA;EACA,mBAAA;AT2kBJ;;ASxnBE;EACE,aAAA;AT2nBJ;;ASznBE;EACE,iBAAA;AT4nBJ;;AS1nBE;EACE,mBAAA;AT6nBJ;;AS3nBE;EACE,oBAAA;AT8nBJ;;AS5nBE;EACE,kBAAA;AT+nBJ;;AS7nBE;EACE,kBAAA;EACA,mBAAA;ATgoBJ;;AS9nBE;EACE,iBAAA;EACA,oBAAA;ATioBJ;;AS9nBE;EACE,YAAA;ATioBJ;;AS/nBE;EACE,gBAAA;ATkoBJ;;AShoBE;EACE,kBAAA;ATmoBJ;;ASjoBE;EACE,mBAAA;ATooBJ;;ASloBE;EACE,iBAAA;ATqoBJ;;ASnoBE;EACE,iBAAA;EACA,kBAAA;ATsoBJ;;ASpoBE;EACE,gBAAA;EACA,mBAAA;ATuoBJ;;ASprBE;EACE,aAAA;ATurBJ;;ASrrBE;EACE,iBAAA;ATwrBJ;;AStrBE;EACE,mBAAA;ATyrBJ;;ASvrBE;EACE,oBAAA;AT0rBJ;;ASxrBE;EACE,kBAAA;AT2rBJ;;ASzrBE;EACE,kBAAA;EACA,mBAAA;AT4rBJ;;AS1rBE;EACE,iBAAA;EACA,oBAAA;AT6rBJ;;AS1rBE;EACE,YAAA;AT6rBJ;;AS3rBE;EACE,gBAAA;AT8rBJ;;AS5rBE;EACE,kBAAA;AT+rBJ;;AS7rBE;EACE,mBAAA;ATgsBJ;;AS9rBE;EACE,iBAAA;ATisBJ;;AS/rBE;EACE,iBAAA;EACA,kBAAA;ATksBJ;;AShsBE;EACE,gBAAA;EACA,mBAAA;ATmsBJ;;AShvBE;EACE,aAAA;ATmvBJ;;ASjvBE;EACE,iBAAA;ATovBJ;;ASlvBE;EACE,mBAAA;ATqvBJ;;ASnvBE;EACE,oBAAA;ATsvBJ;;ASpvBE;EACE,kBAAA;ATuvBJ;;ASrvBE;EACE,kBAAA;EACA,mBAAA;ATwvBJ;;AStvBE;EACE,iBAAA;EACA,oBAAA;ATyvBJ;;AStvBE;EACE,YAAA;ATyvBJ;;ASvvBE;EACE,gBAAA;AT0vBJ;;ASxvBE;EACE,kBAAA;AT2vBJ;;ASzvBE;EACE,mBAAA;AT4vBJ;;AS1vBE;EACE,iBAAA;AT6vBJ;;AS3vBE;EACE,iBAAA;EACA,kBAAA;AT8vBJ;;AS5vBE;EACE,gBAAA;EACA,mBAAA;AT+vBJ;;AS5yBE;EACE,aAAA;AT+yBJ;;AS7yBE;EACE,iBAAA;ATgzBJ;;AS9yBE;EACE,mBAAA;ATizBJ;;AS/yBE;EACE,oBAAA;ATkzBJ;;AShzBE;EACE,kBAAA;ATmzBJ;;ASjzBE;EACE,kBAAA;EACA,mBAAA;ATozBJ;;ASlzBE;EACE,iBAAA;EACA,oBAAA;ATqzBJ;;ASlzBE;EACE,YAAA;ATqzBJ;;ASnzBE;EACE,gBAAA;ATszBJ;;ASpzBE;EACE,kBAAA;ATuzBJ;;ASrzBE;EACE,mBAAA;ATwzBJ;;AStzBE;EACE,iBAAA;ATyzBJ;;ASvzBE;EACE,iBAAA;EACA,kBAAA;AT0zBJ;;ASxzBE;EACE,gBAAA;EACA,mBAAA;AT2zBJ;;ASx2BE;EACE,aAAA;AT22BJ;;ASz2BE;EACE,iBAAA;AT42BJ;;AS12BE;EACE,mBAAA;AT62BJ;;AS32BE;EACE,oBAAA;AT82BJ;;AS52BE;EACE,kBAAA;AT+2BJ;;AS72BE;EACE,kBAAA;EACA,mBAAA;ATg3BJ;;AS92BE;EACE,iBAAA;EACA,oBAAA;ATi3BJ;;AS92BE;EACE,YAAA;ATi3BJ;;AS/2BE;EACE,gBAAA;ATk3BJ;;ASh3BE;EACE,kBAAA;ATm3BJ;;ASj3BE;EACE,mBAAA;ATo3BJ;;ASl3BE;EACE,iBAAA;ATq3BJ;;ASn3BE;EACE,iBAAA;EACA,kBAAA;ATs3BJ;;ASp3BE;EACE,gBAAA;EACA,mBAAA;ATu3BJ;;AU36BA;EACE;;;;;cAAA;EAMA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA,wDAAA;AV06BF;;AUv6BA,8EAAA;AACA,2DAAA;AACA,wCAAA;AACA,uCAAA;AACA;EACE,wCAAA;AV06BF;;AUv6BA,iDAAA;AACA;EACE,wCAAA;AV06BF;;AUv6BA;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AV06BF;AUx6BE;EACE,aAAA;AV06BJ;;AUt6BA,oBAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AVy6BF;;AUt6BA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wHAAA;AVy6BF;;AUr6BA;EACE,oCAAA;EACA,yBAAA;AVw6BF;;AUr6BA;EACE,iCAAA;EACA,oCAAA;EACA,0HAAA;AVw6BF;;AUp6BA;EACE,kCAAA;AVu6BF;;AUp6BA;EACE,6BAAA;AVu6BF;;AUp6BA;EACE,kCAAA;AVu6BF;;AUp6BA;;EAEE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wHAAA;AVu6BF;;AUn6BA,2BAAA;AAEA;EACE,SAAA;AVq6BF;;AUl6BA;EACE,WAAA;EACA,2BAAA;AVq6BF;AUn6BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;AVq6BJ;AUl6BE;EACE,uBAAA;AVo6BJ;AUj6BE;EACE,kBAAA;AVm6BJ;;AU/5BA;EACE,WAAA;EACA,2BAAA;AVk6BF;;AU/5BA;EACE,WAAA;EACA,gBAAA;AVk6BF;AUh6BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;AVk6BJ;AU/5BE;EACE,uBAAA;AVi6BJ;AU95BE;EACE,kBAAA;AVg6BJ;;AU55BA;EACE,WAAA;EACA,gBAAA;AV+5BF;AU75BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AV+5BJ;AU55BE;EACE,uBAAA;AV85BJ;AU35BE;EACE,kBAAA;AV65BJ;;AUz5BA;EACE,WAAA;EACA,gBAAA;AV45BF;AU15BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AV45BJ;AUz5BE;EACE,uBAAA;AV25BJ;AUx5BE;EACE,kBAAA;AV05BJ;;AUt5BA;EACE,aAAA;AVy5BF;;AUt5BA;EACE,2BAAA;AVy5BF;AUt5BI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AVw5BN;AUr5BI;EACE,iBAAA;EACA,eAAA;AVu5BN;AUp5BI;EACE,mBAAA;AVs5BN;AUn5BI;EACE,2CAAA;AVq5BN;;AUh5BA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AVm5BF;;AUh5BA;EACE,oBAAA;EACA,mBAAA;AVm5BF;AUj5BE;EACE,YAAA;EACA,WAAA;AVm5BJ;;AU94BI;EADF;IAEI,gBAAA;IACA,0BAAA;IACA,qBAAA;IACA,YAAA;EVk5BJ;AACF;;AU/4BA;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVk5BF;AUh5BE;EAXF;IAYI,gBAAA;IACA,0BAAA;IACA,UAAA;IACA,YAAA;EVm5BF;AACF;AUj5BE;EACE,8BAAA;AVm5BJ;;AU/4BA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVk5BF;AUh5BE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EVm5BF;AACF;AUj5BE;EACE,8BAAA;AVm5BJ;;AU/4BA;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVk5BF;AUh5BE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EVm5BF;AACF;;AUh5BA;;CAAA;AAGA;EACE,gBAAA;EACA,kBAAA;AVm5BF;;AUh5BA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;AVm5BF;;AUj5BA;EACE,mDAAA;EACA,4CAAA;AVo5BF;;AUj5BA;EACE,sCAAA;EACA,kBAAA;EACA,yCAAA;AVo5BF;;AUl5BA;EACE,uBAAA;EACA,kBAAA;EACA,yCAAA;AVq5BF;;AUn5BA;EACE,kCAAA;EACA,kBAAA;EACA,kCAAA;AVs5BF;;AUp5BA;EACE,2BAAA;AVu5BF;;AUp5BE;EACE,YAAA;AVu5BJ;AUr5BE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;AVu5BJ;AUp5BI;EACE,yBAAA;EACA,oCAAA;AVs5BN;AUl5BE;EACE,uBAAA;AVo5BJ;AUl5BE;EACE,uBAAA;AVo5BJ;AUl5BE;EACE,uBAAA;AVo5BJ;;AUh5BA;EACE;IACE,4BAAA;IACA,eAAA;EVm5BF;EUh5BA;IACE,2BAAA;IACA,4BAAA;IACA,eAAA;EVk5BF;EU/4BA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EVi5BF;EU/4BA;IACE,WAAA;IACA,gBAAA;IACA,4BAAA;IACA,2BAAA;EVi5BF;EU/4BA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EVi5BF;AACF;AU94BA;EACE;IACE,kBAAA;EVg5BF;EU94BA;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EVg5BF;EU74BA;IACE,kBAAA;IACA,0BAAA;EV+4BF;EU74BA;IACE,0BAAA;IACA,0BAAA;IACA,2BAAA;EV+4BF;EU74BE;IACF,kBAAA;IACE,0BAAA;EV+4BF;AACF;AU54BA;EACE;IACE,UAAA;EV84BF;AACF;AU34BA;EACE,wCAAA;AV64BF;;AU14BA;EACE;IACE,iBAAA;IACA,8CAAA;EV64BF;AACF;AU14BA;EACE,kCAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AV44BF;AU14BE;EACE,sBAAA;AV44BJ;;AUx4BA;EACE,wBAAA;AV24BF;;AUz4BA;EACE,qBAAA,EAAA,wCAAA;AV44BF;;AU14BA;EACE,iBAAA;EACA,iBAAA;EACA,yBAAA;AV64BF;AU34BE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EAEA,8BAAA;EACA,aAAA;AV44BJ;AU14BI;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AV44BN;AUz4BI;;EAEE,eAAA;EACA,mBAAA;EACA,cAAA;AV24BN;AUz4BI;EApBF;IAqBI,WAAA;IACA,cAAA;EV44BJ;AACF;AUz4BE;EACE,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AV24BJ;AUz4BI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AV24BN;AUv4BE;EACE,iBAAA;EACA,uBAAA;AVy4BJ;AUt4BI;EADF;IAEI,eAAA;EVy4BJ;AACF;AUt4BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AVw4BJ;AUr4BE;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AVu4BJ;AUr4BI;EACE,iBAAA;AVu4BN;;AUl4BA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AVq4BF;;AUl4BA;EACE,kCAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AVq4BF;;AUl4BA;EACE,qBAAA;AVq4BF;;AUl4BA;EACE,kCAAA;EACA,YAAA;AVq4BF;;AUl4BA;EACE,kCAAA;EACA,YAAA;AVq4BF;;AUn4BA;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AVq4BF;;AUj4BA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AVo4BF;;AUl4BA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AVq4BF;AUn4BE;EACE,WAAA;AVq4BJ;AUl4BE;EACE;IACE,aAAA;EVo4BJ;AACF;;AUh4BA;EACE,aAAA;EACA,mBAAA;AVm4BF;AUj4BE;EACE,WAAA;AVm4BJ;AUh4BE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AVk4BJ;AU/3BE;EACE,uBAAA;AVi4BJ;AU93BE;EACE,uBAAA;AVg4BJ;;AU53BA;;EAEE,mCAAA;EACA,6BAAA;EACA,yCAAA;EACA,4DAAA;EACA,0DAAA;EACA,0DAAA;AV+3BF;;AU53BA;EACE,uBAAA;AV+3BF;;AU53BA;EACE,aAAA;EACA,eAAA;AV+3BF;AU73BE;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;AV+3BJ;;AU33BA;EACE,gBAAA;EACA,kBAAA;AV83BF;;AU13BA;EACE,iDAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AV63BF;;AUz3BE;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sBAAA;AV43BJ;;AUv3BE;EACE,mCAAA;AV03BJ;AUv3BE;EACE,wBAAA;EACA,kBAAA;AVy3BJ;;AUp3BE;EACE,kCAAA;AVu3BJ;AUp3BE;EACE,uBAAA;EACA,kBAAA;AVs3BJ;;AUl3BA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AVq3BF;AUn3BE;EACE,sCAAA;EACA,+CAAA;AVq3BJ;;AUj3BA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AVo3BF;;AUj3BA,oCAAA;AACA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AVo3BF;;AUj3BA;EAEE,qBAAA;AVm3BF;;AU52BA;EAEE,cAAA;AV82BF;;AU32BA;EACM,2BAAA;AV82BN;;AU52BA;EACE,2BAAA;AV+2BF;;AU72BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AVg3BF;;AU72BA;EACE,aAAA;EACA,iBAAA;AVg3BF;;AU72BA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AVg3BF;AU92BE;EACE,kBAAA;AVg3BJ;;AU52BA;EACE,kBAAA;EACA,kBAAA;AV+2BF;;AU72BA;EACE,YAAA;EAEA,wCAAA;EACA,yBAAA;EACA,kBAAA;AV+2BF;AU72BE;EACE,gBAAA;AV+2BJ;AU72BE;EACE,WAAA;AV+2BJ;;AU32BA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AV82BF;;AU32BA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AV82BF;;AU32BA;EACE,sBAAA;EACA,YAAA;AV82BF;;AU32BA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AV82BF;;AU52BA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;AV+2BF;;AU72BA;EACE,iCAAA;AVg3BF;;AU92BA;EACE,sBAAA;AVi3BF;;AU/2BA;EACE,iDAAA;EACA,mDAAA;AVk3BF;;AU/2BE;EACE,8BAAA;AVk3BJ;;AU92BE;EACE,8BAAA;AVi3BJ;;AU92BA;EACE,uBAAA;AVi3BF;;AU/2BA;EAEE,kCAAA;EACA,YAAA;EACA,kCAAA;EACA,6BAAA;AVi3BF;;AU/2BA;EACE,6BAAA;EACA,kBAAA;AVk3BF;;AUh3BA;EACE,oCAAA;AVm3BF;;AUj3BA;EACE,kCAAA;AVo3BF;;AUj3BE;EADF;IAEI,WAAA;EVq3BF;AACF;;AUl3BA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AVq3BF;;AUj3BE;EACE,qBAAA;AVo3BJ;AUz2BA;EACI,eAAA;EACI,oBAAA;EACJ,aAAA;AV22BJ;;AUz2BA;EACI,eAAA;EACE,oBAAA;EACF,aAAA;AV42BJ;;AUz2BA;EACE,2BAAA;AV42BF;;AUx2BE;EADF;IAEI,wBAAA;EV42BF;AACF;;AU12BA;EACE,4CAAA;EACA,gDAAA,EAAA,iBAAA;EACA,sDAAA,EAAA,mBAAA;EACA,8CAAA;AV62BF;;AU12BA;EAAO,iBAAA;AV82BP;;AU72BA;EAAO,uBAAA;AVi3BP;;AUh3BA;EAAO,sBAAA;AVo3BP;;AUn3BA;EAAO,oBAAA;AVu3BP;;AUt3BA;EAAO,sBAAA;AV03BP;;AUz3BA;EAAO,oBAAA;AV63BP;;AU13BA;EAAQ,wBAAA;AV83BR;;AU73BA;EAAQ,8BAAA;AVi4BR;;AUh4BA;EAAQ,6BAAA;AVo4BR;;AUn4BA;EAAQ,2BAAA;AVu4BR;;AUt4BA;EAAQ,6BAAA;AV04BR;;AUz4BA;EAAQ,2BAAA;AV64BR;;AU14BA;EAAQ,qBAAA;AV84BR;;AU74BA;EAAQ,2BAAA;AVi5BR;;AUh5BA;EAAQ,0BAAA;AVo5BR;;AUn5BA;EAAQ,wBAAA;AVu5BR;;AUt5BA;EAAQ,0BAAA;AV05BR;;AUz5BA;EAAQ,wBAAA;AV65BR;;AU55BA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AV+5BF;;AU55BA;EAAS,mBAAA;EAAqB,oBAAA;AVi6B9B;;AUh6BA;EAAS,oBAAA;EAAsB,qBAAA;AVq6B/B;;AUp6BA;EAAS,aAAA;EAAe,cAAA;AVy6BxB;;AUx6BA;EAAS,oBAAA;EAAsB,qBAAA;AV66B/B;;AU56BA;EAAS,oBAAA;EAAsB,qBAAA;AVi7B/B;;AUh7BA;EAAS,aAAA;EAAe,cAAA;AVq7BxB;;AUp7BA;EAAS,oBAAA;EAAsB,qBAAA;AVy7B/B;;AUx7BA;EAAS,oBAAA;EAAsB,qBAAA;AV67B/B;;AU57BA;EAAS,aAAA;EAAe,cAAA;AVi8BxB;;AUh8BA;EAAU,oBAAA;EAAsB,qBAAA;AVq8BhC;;AUp8BA;EAAU,oBAAA;EAAsB,qBAAA;AVy8BhC;;AUx8BA;EAAU,aAAA;EAAe,cAAA;AV68BzB;;AU38BA,wBAAA;AACA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVg9BjC;EU/8BA;IAAY,oBAAA;IAAsB,qBAAA;EVm9BlC;EUl9BA;IAAY,aAAA;IAAe,cAAA;EVs9B3B;EUr9BA;IAAY,oBAAA;IAAsB,qBAAA;EVy9BlC;EUx9BA;IAAY,oBAAA;IAAsB,qBAAA;EV49BlC;EU39BA;IAAY,aAAA;IAAe,cAAA;EV+9B3B;EU99BA;IAAY,oBAAA;IAAsB,qBAAA;EVk+BlC;EUj+BA;IAAY,oBAAA;IAAsB,qBAAA;EVq+BlC;EUp+BA;IAAY,aAAA;IAAe,cAAA;EVw+B3B;EUv+BA;IAAa,oBAAA;IAAsB,qBAAA;EV2+BnC;EU1+BA;IAAa,oBAAA;IAAsB,qBAAA;EV8+BnC;EU7+BA;IAAa,aAAA;IAAe,cAAA;EVi/B5B;AACF;AU/+BA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVm/BjC;EUl/BA;IAAY,oBAAA;IAAsB,qBAAA;EVs/BlC;EUr/BA;IAAY,aAAA;IAAe,cAAA;EVy/B3B;EUx/BA;IAAY,oBAAA;IAAsB,qBAAA;EV4/BlC;EU3/BA;IAAY,oBAAA;IAAsB,qBAAA;EV+/BlC;EU9/BA;IAAY,aAAA;IAAe,cAAA;EVkgC3B;EUjgCA;IAAY,oBAAA;IAAsB,qBAAA;EVqgClC;EUpgCA;IAAY,oBAAA;IAAsB,qBAAA;EVwgClC;EUvgCA;IAAY,aAAA;IAAe,cAAA;EV2gC3B;EU1gCA;IAAa,oBAAA;IAAsB,qBAAA;EV8gCnC;EU7gCA;IAAa,oBAAA;IAAsB,qBAAA;EVihCnC;EUhhCA;IAAa,cAAA;IAAgB,eAAA;EVohC7B;AACF;AUlhCA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVshCjC;EUrhCA;IAAY,oBAAA;IAAsB,qBAAA;EVyhClC;EUxhCA;IAAY,aAAA;IAAe,cAAA;EV4hC3B;EU3hCA;IAAY,oBAAA;IAAsB,qBAAA;EV+hClC;EU9hCA;IAAY,oBAAA;IAAsB,qBAAA;EVkiClC;EUjiCA;IAAY,aAAA;IAAe,cAAA;EVqiC3B;EUpiCA;IAAY,oBAAA;IAAsB,qBAAA;EVwiClC;EUviCA;IAAY,oBAAA;IAAsB,qBAAA;EV2iClC;EU1iCA;IAAY,aAAA;IAAe,cAAA;EV8iC3B;EU7iCA;IAAa,oBAAA;IAAsB,qBAAA;EVijCnC;EUhjCA;IAAa,oBAAA;IAAsB,qBAAA;EVojCnC;EUnjCA;IAAa,aAAA;IAAe,cAAA;EVujC5B;AACF;AUrjCA,6BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVyjCjC;EUxjCA;IAAY,oBAAA;IAAsB,qBAAA;EV4jClC;EU3jCA;IAAY,aAAA;IAAe,cAAA;EV+jC3B;EU9jCA;IAAY,oBAAA;IAAsB,qBAAA;EVkkClC;EUjkCA;IAAY,oBAAA;IAAsB,qBAAA;EVqkClC;EUpkCA;IAAY,aAAA;IAAe,cAAA;EVwkC3B;EUvkCA;IAAY,oBAAA;IAAsB,qBAAA;EV2kClC;EU1kCA;IAAY,oBAAA;IAAsB,qBAAA;EV8kClC;EU7kCA;IAAY,aAAA;IAAe,cAAA;EVilC3B;EUhlCA;IAAa,oBAAA;IAAsB,qBAAA;EVolCnC;EUnlCA;IAAa,oBAAA;IAAsB,qBAAA;EVulCnC;EUtlCA;IAAa,aAAA;IAAe,cAAA;EV0lC5B;AACF;AUxlCA,6BAAA,QAAA;EACE;IAAa,mBAAA;IAAqB,oBAAA;EV4lClC;EU3lCA;IAAa,oBAAA;IAAsB,qBAAA;EV+lCnC;EU9lCA;IAAa,aAAA;IAAe,cAAA;EVkmC5B;EUjmCA;IAAa,oBAAA;IAAsB,qBAAA;EVqmCnC;EUpmCA;IAAa,oBAAA;IAAsB,qBAAA;EVwmCnC;EUvmCA;IAAa,aAAA;IAAe,cAAA;EV2mC5B;EU1mCA;IAAa,oBAAA;IAAsB,qBAAA;EV8mCnC;EU7mCA;IAAa,oBAAA;IAAsB,qBAAA;EVinCnC;EUhnCA;IAAa,aAAA;IAAe,cAAA;EVonC5B;EUnnCA;IAAc,oBAAA;IAAsB,qBAAA;EVunCpC;EUtnCA;IAAc,oBAAA;IAAsB,qBAAA;EV0nCpC;EUznCA;IAAc,aAAA;IAAe,cAAA;EV6nC7B;AACF;AU5nCA;EACE,0BAAA;AV8nCF;;AU5nCA;EACE,iBAAA;AV+nCF;;AU7nCA;EACI,4CAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AVgoCJ;;AU7nCA;EACI,uBAAA;AVgoCJ;;AU7nCA;EACI,aAAA;AVgoCJ;;AU7nCA;EAEI,gCAAA;EACA,oCAAA;AV+nCJ;;AAxsEA;EACE,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;AA2sEF;;AAxsEA;EAEE,aAAA;AA0sEF;;AAvsEA;EAEE,UAAA;EACA,YAAA;EACA,YAAA;EAEA,aAAA;EACA,yBAAA;EACA,mBAAA;AAwsEF;AAtsEE;EACE,4BAAA;EACA,iBAAA;EACA,YAAA;AAwsEJ;AArsEE;EACE,kBAAA;AAusEJ;;AAnsEA;EACE;IACE,qBAAA;EAssEF;EAlsEA;IACE,UAAA;EAosEF;EAjsEA;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;EAmsEF;EAjsEE;IACE,UAAA;IACA,iBAAA;IACA,iBAAA;EAmsEJ;AACF;AA/rEA;EACE,2BAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EAEA,kBAAA;EACA,eAAA;AAgsEF;AA9rEE;EAbF;IAcI,gBAAA;IACA,0BAAA;IACA,sBAAA;IACA,YAAA;EAisEF;AACF;AA/rEE;EACE,8BAAA;AAisEJ;;AA7rEA;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EAEA,kBAAA;EACA,eAAA;AA+rEF;AA7rEE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EAgsEF;AACF;AA9rEE;EACE,8BAAA;AAgsEJ;;AA5rEA;EACE,WAAA;EACA,wCAAA;EACA,kCAAA;EACA,6CAAA;AA+rEF;;AA5rEA;EACE,iBAAA;EACA,gBAAA;AA+rEF;AA7rEE;EACE;IACE,OAAA;EA+rEJ;AACF;;AAzrEA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EAQA,gJAAA;AAqrEF;AA3rEE;EALF;IAMI,sBAAA;IACA,sBAAA;EA8rEF;AACF;AAzrEE;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,YAAA;AA2rEJ;;AAvrEA;EACE,SAAA;AA0rEF;;AAvrEA;EACE,sBAAA;AA0rEF;;AAvrEA;EACE,mBAAA;AA0rEF;;AAtrEA;EACE,gBAAA;AAyrEF;AAvrEE;EACE,WAAA;AAyrEJ;AAtrEE;EACE,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,4BAAA;AAwrEJ;;AAprEA;EACE,iBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAurEF;AArrEE;EACE,eAAA;EACA,mBAAA;AAurEJ;AArrEE;EAXF;IAYI,eAAA;EAwrEF;AACF;;ACr3EE;EACE,gBAAA;EAIA,kBAAA;ADq3EJ;AC92EI;EACE,wBAAA;ADg3EN;;AC52EE;EACE,iBAAA;AD+2EJ;;AC52EE;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,6DAAA;EAIA,2BAAA;AD22EJ;AE51EI;EDXE,aAAA;AD02EN;;AE94EE;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EAIA,mBAAA;EAGA,UAAA;EAGA,wBAAA;EACA,qBAAA;EAMA,OAAA;AFq4EJ;AEn4EI;EACE,UAAA;EACA,QAAA;AFq4EN;;AGr5EE;EAEE,oBAAA;EAGA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AHq5EJ;;AGj5EE;EACE,eAAA;EACA,aA3BwB;AH+6E5B;AGl5EI;EAGE,aAAA;AHk5EN;;AG14EE;EACE,aAAA;EACA,kBAAA;EACA,aA1Cc;AHu7ElB;;AGz4EE;EAGE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aApDc;EAwDd,aAAA;EACA,eAAA;EACA,gBAAA;AHu4EJ;;AGp4EE;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aApEuB;EAqEvB,oBAAA;EACA,wCAAA;EACA,0DAAA;EACA,UAAA;AHq4EJ;AGn4EI;EACE,UAAA;AHq4EN;AGh4EM;EAGE,YAAA;AHg4ER;;AG33EE;EACE,+BAtFqB;AHo9EzB;;AG33EE;EAEE,qDAAA;EACA,kBAAA;EACA,UAAA;AH63EJ;AGv3EI;EACE,UAAA;EACA,mBAAA;AHy3EN;;AGr3EE;EACE,gBAAA;AHw3EJ;;AGn3EE;EACE,kBAAA;EACA,aArHc;EA0Hd,aAAA;EAIA,sBAAA;EAGA,cAAA;EACA,eAAA;AH62EJ;;AGz2EE;EACE,eAAA;EAKA,WAAA;EAKA,kBAAA;AHo2EJ;;AIr/EE;EACE,YAAA;AJw/EJ;;AIl/EE;EAyCA,yBAAA;EACA,kCAAA;EAxCE,uBAAA;EACA,2BAAA;AJs/EJ;;AI7+EE;EA6BA,yBAAA;EACA,kCAAA;EA5BE,oBAAA;AJi/EJ;;AIv+EE,2CAAA,IAAA,EAAA;AACA,yCAAA,IAAA,EAAA;AAEA;EAEE,+CAAA;AJw+EJ;;AIr+EE;EAEE,6CAAA;AJu+EJ;;AKtgFE;EACE,kBAAA;ALygFJ;AKvgFI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,iDAAA;EACA,wJAAA;EAYA,4DAAA;ALkgFN;AK1/EI;EACE,WAAA;AL4/EN;;AEj9EM;EG7BA,oCAAA;ALk/EN;;AK7hFE;EACE,kBAAA;ALgiFJ;AK9hFI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,qDAAA;EACA,oKAAA;EAYA,gEAAA;ALyhFN;AKjhFI;EACE,WAAA;ALmhFN;;AEx+EM;EG7BA,wCAAA;ALygFN;;AOlkFA;;;;;CAAA;ACEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ARykFF;;AQtkFA;;;;;;EAME,qCAAA;EACA,gBAAA;ARykFF;;AQtkFA;EACE,eAAA;EACA,iBAAA;ARykFF;;AQtkFA;EACE,eAAA;EACA,iBAAA;ARykFF;;AQtkFA;EACE,eAAA;EACA,iBAAA;ARykFF;;AQtkFA;EACE,eAAA;EACA,iBAAA;ARykFF;;AQtkFA;EACE,eAAA;EACA,iBAAA;ARykFF;;AQtkFA;EACE,eAAA;EACA,iBAAA;ARykFF;;AQtkFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;ARykFF;;AQtkFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;ARykFF;;AQtkFA;EACE,gBAAA;EACA,eAAA;ARykFF;;AO3oFA;;;;;CAAA;AEeE;EACE,YAAA;ATqoFJ;;ASnoFE;EACE,gBAAA;ATsoFJ;;ASpoFE;EACE,kBAAA;ATuoFJ;;ASroFE;EACE,mBAAA;ATwoFJ;;AStoFE;EACE,iBAAA;ATyoFJ;;ASvoFE;EACE,iBAAA;EACA,kBAAA;AT0oFJ;;ASxoFE;EACE,gBAAA;EACA,mBAAA;AT2oFJ;;ASxoFE;EACE,WAAA;AT2oFJ;;ASzoFE;EACE,eAAA;AT4oFJ;;AS1oFE;EACE,iBAAA;AT6oFJ;;AS3oFE;EACE,kBAAA;AT8oFJ;;AS5oFE;EACE,gBAAA;AT+oFJ;;AS7oFE;EACE,gBAAA;EACA,iBAAA;ATgpFJ;;AS9oFE;EACE,eAAA;EACA,kBAAA;ATipFJ;;AS9rFE;EACE,YAAA;ATisFJ;;AS/rFE;EACE,gBAAA;ATksFJ;;AShsFE;EACE,kBAAA;ATmsFJ;;ASjsFE;EACE,mBAAA;ATosFJ;;ASlsFE;EACE,iBAAA;ATqsFJ;;ASnsFE;EACE,iBAAA;EACA,kBAAA;ATssFJ;;ASpsFE;EACE,gBAAA;EACA,mBAAA;ATusFJ;;ASpsFE;EACE,WAAA;ATusFJ;;ASrsFE;EACE,eAAA;ATwsFJ;;AStsFE;EACE,iBAAA;ATysFJ;;ASvsFE;EACE,kBAAA;AT0sFJ;;ASxsFE;EACE,gBAAA;AT2sFJ;;ASzsFE;EACE,gBAAA;EACA,iBAAA;AT4sFJ;;AS1sFE;EACE,eAAA;EACA,kBAAA;AT6sFJ;;AS1vFE;EACE,aAAA;AT6vFJ;;AS3vFE;EACE,iBAAA;AT8vFJ;;AS5vFE;EACE,mBAAA;AT+vFJ;;AS7vFE;EACE,oBAAA;ATgwFJ;;AS9vFE;EACE,kBAAA;ATiwFJ;;AS/vFE;EACE,kBAAA;EACA,mBAAA;ATkwFJ;;AShwFE;EACE,iBAAA;EACA,oBAAA;ATmwFJ;;AShwFE;EACE,YAAA;ATmwFJ;;ASjwFE;EACE,gBAAA;ATowFJ;;ASlwFE;EACE,kBAAA;ATqwFJ;;ASnwFE;EACE,mBAAA;ATswFJ;;ASpwFE;EACE,iBAAA;ATuwFJ;;ASrwFE;EACE,iBAAA;EACA,kBAAA;ATwwFJ;;AStwFE;EACE,gBAAA;EACA,mBAAA;ATywFJ;;AStzFE;EACE,aAAA;ATyzFJ;;ASvzFE;EACE,iBAAA;AT0zFJ;;ASxzFE;EACE,mBAAA;AT2zFJ;;ASzzFE;EACE,oBAAA;AT4zFJ;;AS1zFE;EACE,kBAAA;AT6zFJ;;AS3zFE;EACE,kBAAA;EACA,mBAAA;AT8zFJ;;AS5zFE;EACE,iBAAA;EACA,oBAAA;AT+zFJ;;AS5zFE;EACE,YAAA;AT+zFJ;;AS7zFE;EACE,gBAAA;ATg0FJ;;AS9zFE;EACE,kBAAA;ATi0FJ;;AS/zFE;EACE,mBAAA;ATk0FJ;;ASh0FE;EACE,iBAAA;ATm0FJ;;ASj0FE;EACE,iBAAA;EACA,kBAAA;ATo0FJ;;ASl0FE;EACE,gBAAA;EACA,mBAAA;ATq0FJ;;ASl3FE;EACE,aAAA;ATq3FJ;;ASn3FE;EACE,iBAAA;ATs3FJ;;ASp3FE;EACE,mBAAA;ATu3FJ;;ASr3FE;EACE,oBAAA;ATw3FJ;;ASt3FE;EACE,kBAAA;ATy3FJ;;ASv3FE;EACE,kBAAA;EACA,mBAAA;AT03FJ;;ASx3FE;EACE,iBAAA;EACA,oBAAA;AT23FJ;;ASx3FE;EACE,YAAA;AT23FJ;;ASz3FE;EACE,gBAAA;AT43FJ;;AS13FE;EACE,kBAAA;AT63FJ;;AS33FE;EACE,mBAAA;AT83FJ;;AS53FE;EACE,iBAAA;AT+3FJ;;AS73FE;EACE,iBAAA;EACA,kBAAA;ATg4FJ;;AS93FE;EACE,gBAAA;EACA,mBAAA;ATi4FJ;;AS96FE;EACE,aAAA;ATi7FJ;;AS/6FE;EACE,iBAAA;ATk7FJ;;ASh7FE;EACE,mBAAA;ATm7FJ;;ASj7FE;EACE,oBAAA;ATo7FJ;;ASl7FE;EACE,kBAAA;ATq7FJ;;ASn7FE;EACE,kBAAA;EACA,mBAAA;ATs7FJ;;ASp7FE;EACE,iBAAA;EACA,oBAAA;ATu7FJ;;ASp7FE;EACE,YAAA;ATu7FJ;;ASr7FE;EACE,gBAAA;ATw7FJ;;ASt7FE;EACE,kBAAA;ATy7FJ;;ASv7FE;EACE,mBAAA;AT07FJ;;ASx7FE;EACE,iBAAA;AT27FJ;;ASz7FE;EACE,iBAAA;EACA,kBAAA;AT47FJ;;AS17FE;EACE,gBAAA;EACA,mBAAA;AT67FJ;;AS1+FE;EACE,aAAA;AT6+FJ;;AS3+FE;EACE,iBAAA;AT8+FJ;;AS5+FE;EACE,mBAAA;AT++FJ;;AS7+FE;EACE,oBAAA;ATg/FJ;;AS9+FE;EACE,kBAAA;ATi/FJ;;AS/+FE;EACE,kBAAA;EACA,mBAAA;ATk/FJ;;ASh/FE;EACE,iBAAA;EACA,oBAAA;ATm/FJ;;ASh/FE;EACE,YAAA;ATm/FJ;;ASj/FE;EACE,gBAAA;ATo/FJ;;ASl/FE;EACE,kBAAA;ATq/FJ;;ASn/FE;EACE,mBAAA;ATs/FJ;;ASp/FE;EACE,iBAAA;ATu/FJ;;ASr/FE;EACE,iBAAA;EACA,kBAAA;ATw/FJ;;ASt/FE;EACE,gBAAA;EACA,mBAAA;ATy/FJ;;AStiGE;EACE,aAAA;ATyiGJ;;ASviGE;EACE,iBAAA;AT0iGJ;;ASxiGE;EACE,mBAAA;AT2iGJ;;ASziGE;EACE,oBAAA;AT4iGJ;;AS1iGE;EACE,kBAAA;AT6iGJ;;AS3iGE;EACE,kBAAA;EACA,mBAAA;AT8iGJ;;AS5iGE;EACE,iBAAA;EACA,oBAAA;AT+iGJ;;AS5iGE;EACE,YAAA;AT+iGJ;;AS7iGE;EACE,gBAAA;ATgjGJ;;AS9iGE;EACE,kBAAA;ATijGJ;;AS/iGE;EACE,mBAAA;ATkjGJ;;AShjGE;EACE,iBAAA;ATmjGJ;;ASjjGE;EACE,iBAAA;EACA,kBAAA;ATojGJ;;ASljGE;EACE,gBAAA;EACA,mBAAA;ATqjGJ;;ASlmGE;EACE,aAAA;ATqmGJ;;ASnmGE;EACE,iBAAA;ATsmGJ;;ASpmGE;EACE,mBAAA;ATumGJ;;ASrmGE;EACE,oBAAA;ATwmGJ;;AStmGE;EACE,kBAAA;ATymGJ;;ASvmGE;EACE,kBAAA;EACA,mBAAA;AT0mGJ;;ASxmGE;EACE,iBAAA;EACA,oBAAA;AT2mGJ;;ASxmGE;EACE,YAAA;AT2mGJ;;ASzmGE;EACE,gBAAA;AT4mGJ;;AS1mGE;EACE,kBAAA;AT6mGJ;;AS3mGE;EACE,mBAAA;AT8mGJ;;AS5mGE;EACE,iBAAA;AT+mGJ;;AS7mGE;EACE,iBAAA;EACA,kBAAA;ATgnGJ;;AS9mGE;EACE,gBAAA;EACA,mBAAA;ATinGJ;;AS9pGE;EACE,aAAA;ATiqGJ;;AS/pGE;EACE,iBAAA;ATkqGJ;;AShqGE;EACE,mBAAA;ATmqGJ;;ASjqGE;EACE,oBAAA;AToqGJ;;ASlqGE;EACE,kBAAA;ATqqGJ;;ASnqGE;EACE,kBAAA;EACA,mBAAA;ATsqGJ;;ASpqGE;EACE,iBAAA;EACA,oBAAA;ATuqGJ;;ASpqGE;EACE,YAAA;ATuqGJ;;ASrqGE;EACE,gBAAA;ATwqGJ;;AStqGE;EACE,kBAAA;ATyqGJ;;ASvqGE;EACE,mBAAA;AT0qGJ;;ASxqGE;EACE,iBAAA;AT2qGJ;;ASzqGE;EACE,iBAAA;EACA,kBAAA;AT4qGJ;;AS1qGE;EACE,gBAAA;EACA,mBAAA;AT6qGJ;;AS1tGE;EACE,aAAA;AT6tGJ;;AS3tGE;EACE,iBAAA;AT8tGJ;;AS5tGE;EACE,mBAAA;AT+tGJ;;AS7tGE;EACE,oBAAA;ATguGJ;;AS9tGE;EACE,kBAAA;ATiuGJ;;AS/tGE;EACE,kBAAA;EACA,mBAAA;ATkuGJ;;AShuGE;EACE,iBAAA;EACA,oBAAA;ATmuGJ;;AShuGE;EACE,YAAA;ATmuGJ;;ASjuGE;EACE,gBAAA;ATouGJ;;ASluGE;EACE,kBAAA;ATquGJ;;ASnuGE;EACE,mBAAA;ATsuGJ;;ASpuGE;EACE,iBAAA;ATuuGJ;;ASruGE;EACE,iBAAA;EACA,kBAAA;ATwuGJ;;AStuGE;EACE,gBAAA;EACA,mBAAA;ATyuGJ;;AU7xGA;EACE;;;;;cAAA;EAMA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA,wDAAA;AV4xGF;;AUzxGA,8EAAA;AACA,2DAAA;AACA,wCAAA;AACA,uCAAA;AACA;EACE,wCAAA;AV4xGF;;AUzxGA,iDAAA;AACA;EACE,wCAAA;AV4xGF;;AUzxGA;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AV4xGF;AU1xGE;EACE,aAAA;AV4xGJ;;AUxxGA,oBAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AV2xGF;;AUxxGA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wHAAA;AV2xGF;;AUvxGA;EACE,oCAAA;EACA,yBAAA;AV0xGF;;AUvxGA;EACE,iCAAA;EACA,oCAAA;EACA,0HAAA;AV0xGF;;AUtxGA;EACE,kCAAA;AVyxGF;;AUtxGA;EACE,6BAAA;AVyxGF;;AUtxGA;EACE,kCAAA;AVyxGF;;AUtxGA;;EAEE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wHAAA;AVyxGF;;AUrxGA,2BAAA;AAEA;EACE,SAAA;AVuxGF;;AUpxGA;EACE,WAAA;EACA,2BAAA;AVuxGF;AUrxGE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;AVuxGJ;AUpxGE;EACE,uBAAA;AVsxGJ;AUnxGE;EACE,kBAAA;AVqxGJ;;AUjxGA;EACE,WAAA;EACA,2BAAA;AVoxGF;;AUjxGA;EACE,WAAA;EACA,gBAAA;AVoxGF;AUlxGE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;AVoxGJ;AUjxGE;EACE,uBAAA;AVmxGJ;AUhxGE;EACE,kBAAA;AVkxGJ;;AU9wGA;EACE,WAAA;EACA,gBAAA;AVixGF;AU/wGE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AVixGJ;AU9wGE;EACE,uBAAA;AVgxGJ;AU7wGE;EACE,kBAAA;AV+wGJ;;AU3wGA;EACE,WAAA;EACA,gBAAA;AV8wGF;AU5wGE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AV8wGJ;AU3wGE;EACE,uBAAA;AV6wGJ;AU1wGE;EACE,kBAAA;AV4wGJ;;AUxwGA;EACE,aAAA;AV2wGF;;AUxwGA;EACE,2BAAA;AV2wGF;AUxwGI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AV0wGN;AUvwGI;EACE,iBAAA;EACA,eAAA;AVywGN;AUtwGI;EACE,mBAAA;AVwwGN;AUrwGI;EACE,2CAAA;AVuwGN;;AUlwGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AVqwGF;;AUlwGA;EACE,oBAAA;EACA,mBAAA;AVqwGF;AUnwGE;EACE,YAAA;EACA,WAAA;AVqwGJ;;AUhwGI;EADF;IAEI,gBAAA;IACA,0BAAA;IACA,qBAAA;IACA,YAAA;EVowGJ;AACF;;AUjwGA;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVowGF;AUlwGE;EAXF;IAYI,gBAAA;IACA,0BAAA;IACA,UAAA;IACA,YAAA;EVqwGF;AACF;AUnwGE;EACE,8BAAA;AVqwGJ;;AUjwGA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVowGF;AUlwGE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EVqwGF;AACF;AUnwGE;EACE,8BAAA;AVqwGJ;;AUjwGA;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVowGF;AUlwGE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EVqwGF;AACF;;AUlwGA;;CAAA;AAGA;EACE,gBAAA;EACA,kBAAA;AVqwGF;;AUlwGA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;AVqwGF;;AUnwGA;EACE,mDAAA;EACA,4CAAA;AVswGF;;AUnwGA;EACE,sCAAA;EACA,kBAAA;EACA,yCAAA;AVswGF;;AUpwGA;EACE,uBAAA;EACA,kBAAA;EACA,yCAAA;AVuwGF;;AUrwGA;EACE,kCAAA;EACA,kBAAA;EACA,kCAAA;AVwwGF;;AUtwGA;EACE,2BAAA;AVywGF;;AUtwGE;EACE,YAAA;AVywGJ;AUvwGE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;AVywGJ;AUtwGI;EACE,yBAAA;EACA,oCAAA;AVwwGN;AUpwGE;EACE,uBAAA;AVswGJ;AUpwGE;EACE,uBAAA;AVswGJ;AUpwGE;EACE,uBAAA;AVswGJ;;AUlwGA;EACE;IACE,4BAAA;IACA,eAAA;EVqwGF;EUlwGA;IACE,2BAAA;IACA,4BAAA;IACA,eAAA;EVowGF;EUjwGA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EVmwGF;EUjwGA;IACE,WAAA;IACA,gBAAA;IACA,4BAAA;IACA,2BAAA;EVmwGF;EUjwGA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EVmwGF;AACF;AUhwGA;EACE;IACE,kBAAA;EVkwGF;EUhwGA;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EVkwGF;EU/vGA;IACE,kBAAA;IACA,0BAAA;EViwGF;EU/vGA;IACE,0BAAA;IACA,0BAAA;IACA,2BAAA;EViwGF;EU/vGE;IACF,kBAAA;IACE,0BAAA;EViwGF;AACF;AU9vGA;EACE;IACE,UAAA;EVgwGF;AACF;AU7vGA;EACE,wCAAA;AV+vGF;;AU5vGA;EACE;IACE,iBAAA;IACA,8CAAA;EV+vGF;AACF;AU5vGA;EACE,kCAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AV8vGF;AU5vGE;EACE,sBAAA;AV8vGJ;;AU1vGA;EACE,wBAAA;AV6vGF;;AU3vGA;EACE,qBAAA,EAAA,wCAAA;AV8vGF;;AU5vGA;EACE,iBAAA;EACA,iBAAA;EACA,yBAAA;AV+vGF;AU7vGE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EAEA,8BAAA;EACA,aAAA;AV8vGJ;AU5vGI;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AV8vGN;AU3vGI;;EAEE,eAAA;EACA,mBAAA;EACA,cAAA;AV6vGN;AU3vGI;EApBF;IAqBI,WAAA;IACA,cAAA;EV8vGJ;AACF;AU3vGE;EACE,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AV6vGJ;AU3vGI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AV6vGN;AUzvGE;EACE,iBAAA;EACA,uBAAA;AV2vGJ;AUxvGI;EADF;IAEI,eAAA;EV2vGJ;AACF;AUxvGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AV0vGJ;AUvvGE;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AVyvGJ;AUvvGI;EACE,iBAAA;AVyvGN;;AUpvGA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AVuvGF;;AUpvGA;EACE,kCAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AVuvGF;;AUpvGA;EACE,qBAAA;AVuvGF;;AUpvGA;EACE,kCAAA;EACA,YAAA;AVuvGF;;AUpvGA;EACE,kCAAA;EACA,YAAA;AVuvGF;;AUrvGA;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AVuvGF;;AUnvGA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AVsvGF;;AUpvGA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AVuvGF;AUrvGE;EACE,WAAA;AVuvGJ;AUpvGE;EACE;IACE,aAAA;EVsvGJ;AACF;;AUlvGA;EACE,aAAA;EACA,mBAAA;AVqvGF;AUnvGE;EACE,WAAA;AVqvGJ;AUlvGE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AVovGJ;AUjvGE;EACE,uBAAA;AVmvGJ;AUhvGE;EACE,uBAAA;AVkvGJ;;AU9uGA;;EAEE,mCAAA;EACA,6BAAA;EACA,yCAAA;EACA,4DAAA;EACA,0DAAA;EACA,0DAAA;AVivGF;;AU9uGA;EACE,uBAAA;AVivGF;;AU9uGA;EACE,aAAA;EACA,eAAA;AVivGF;AU/uGE;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;AVivGJ;;AU7uGA;EACE,gBAAA;EACA,kBAAA;AVgvGF;;AU5uGA;EACE,iDAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AV+uGF;;AU3uGE;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sBAAA;AV8uGJ;;AUzuGE;EACE,mCAAA;AV4uGJ;AUzuGE;EACE,wBAAA;EACA,kBAAA;AV2uGJ;;AUtuGE;EACE,kCAAA;AVyuGJ;AUtuGE;EACE,uBAAA;EACA,kBAAA;AVwuGJ;;AUpuGA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AVuuGF;AUruGE;EACE,sCAAA;EACA,+CAAA;AVuuGJ;;AUnuGA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AVsuGF;;AUnuGA,oCAAA;AACA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AVsuGF;;AUnuGA;EAEE,qBAAA;AVquGF;;AU9tGA;EAEE,cAAA;AVguGF;;AU7tGA;EACM,2BAAA;AVguGN;;AU9tGA;EACE,2BAAA;AViuGF;;AU/tGA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AVkuGF;;AU/tGA;EACE,aAAA;EACA,iBAAA;AVkuGF;;AU/tGA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AVkuGF;AUhuGE;EACE,kBAAA;AVkuGJ;;AU9tGA;EACE,kBAAA;EACA,kBAAA;AViuGF;;AU/tGA;EACE,YAAA;EAEA,wCAAA;EACA,yBAAA;EACA,kBAAA;AViuGF;AU/tGE;EACE,gBAAA;AViuGJ;AU/tGE;EACE,WAAA;AViuGJ;;AU7tGA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AVguGF;;AU7tGA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AVguGF;;AU7tGA;EACE,sBAAA;EACA,YAAA;AVguGF;;AU7tGA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AVguGF;;AU9tGA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;AViuGF;;AU/tGA;EACE,iCAAA;AVkuGF;;AUhuGA;EACE,sBAAA;AVmuGF;;AUjuGA;EACE,iDAAA;EACA,mDAAA;AVouGF;;AUjuGE;EACE,8BAAA;AVouGJ;;AUhuGE;EACE,8BAAA;AVmuGJ;;AUhuGA;EACE,uBAAA;AVmuGF;;AUjuGA;EAEE,kCAAA;EACA,YAAA;EACA,kCAAA;EACA,6BAAA;AVmuGF;;AUjuGA;EACE,6BAAA;EACA,kBAAA;AVouGF;;AUluGA;EACE,oCAAA;AVquGF;;AUnuGA;EACE,kCAAA;AVsuGF;;AUnuGE;EADF;IAEI,WAAA;EVuuGF;AACF;;AUpuGA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AVuuGF;;AUnuGE;EACE,qBAAA;AVsuGJ;AU3tGA;EACI,eAAA;EACI,oBAAA;EACJ,aAAA;AV6tGJ;;AU3tGA;EACI,eAAA;EACE,oBAAA;EACF,aAAA;AV8tGJ;;AU3tGA;EACE,2BAAA;AV8tGF;;AU1tGE;EADF;IAEI,wBAAA;EV8tGF;AACF;;AU5tGA;EACE,4CAAA;EACA,gDAAA,EAAA,iBAAA;EACA,sDAAA,EAAA,mBAAA;EACA,8CAAA;AV+tGF;;AU5tGA;EAAO,iBAAA;AVguGP;;AU/tGA;EAAO,uBAAA;AVmuGP;;AUluGA;EAAO,sBAAA;AVsuGP;;AUruGA;EAAO,oBAAA;AVyuGP;;AUxuGA;EAAO,sBAAA;AV4uGP;;AU3uGA;EAAO,oBAAA;AV+uGP;;AU5uGA;EAAQ,wBAAA;AVgvGR;;AU/uGA;EAAQ,8BAAA;AVmvGR;;AUlvGA;EAAQ,6BAAA;AVsvGR;;AUrvGA;EAAQ,2BAAA;AVyvGR;;AUxvGA;EAAQ,6BAAA;AV4vGR;;AU3vGA;EAAQ,2BAAA;AV+vGR;;AU5vGA;EAAQ,qBAAA;AVgwGR;;AU/vGA;EAAQ,2BAAA;AVmwGR;;AUlwGA;EAAQ,0BAAA;AVswGR;;AUrwGA;EAAQ,wBAAA;AVywGR;;AUxwGA;EAAQ,0BAAA;AV4wGR;;AU3wGA;EAAQ,wBAAA;AV+wGR;;AU9wGA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AVixGF;;AU9wGA;EAAS,mBAAA;EAAqB,oBAAA;AVmxG9B;;AUlxGA;EAAS,oBAAA;EAAsB,qBAAA;AVuxG/B;;AUtxGA;EAAS,aAAA;EAAe,cAAA;AV2xGxB;;AU1xGA;EAAS,oBAAA;EAAsB,qBAAA;AV+xG/B;;AU9xGA;EAAS,oBAAA;EAAsB,qBAAA;AVmyG/B;;AUlyGA;EAAS,aAAA;EAAe,cAAA;AVuyGxB;;AUtyGA;EAAS,oBAAA;EAAsB,qBAAA;AV2yG/B;;AU1yGA;EAAS,oBAAA;EAAsB,qBAAA;AV+yG/B;;AU9yGA;EAAS,aAAA;EAAe,cAAA;AVmzGxB;;AUlzGA;EAAU,oBAAA;EAAsB,qBAAA;AVuzGhC;;AUtzGA;EAAU,oBAAA;EAAsB,qBAAA;AV2zGhC;;AU1zGA;EAAU,aAAA;EAAe,cAAA;AV+zGzB;;AU7zGA,wBAAA;AACA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVk0GjC;EUj0GA;IAAY,oBAAA;IAAsB,qBAAA;EVq0GlC;EUp0GA;IAAY,aAAA;IAAe,cAAA;EVw0G3B;EUv0GA;IAAY,oBAAA;IAAsB,qBAAA;EV20GlC;EU10GA;IAAY,oBAAA;IAAsB,qBAAA;EV80GlC;EU70GA;IAAY,aAAA;IAAe,cAAA;EVi1G3B;EUh1GA;IAAY,oBAAA;IAAsB,qBAAA;EVo1GlC;EUn1GA;IAAY,oBAAA;IAAsB,qBAAA;EVu1GlC;EUt1GA;IAAY,aAAA;IAAe,cAAA;EV01G3B;EUz1GA;IAAa,oBAAA;IAAsB,qBAAA;EV61GnC;EU51GA;IAAa,oBAAA;IAAsB,qBAAA;EVg2GnC;EU/1GA;IAAa,aAAA;IAAe,cAAA;EVm2G5B;AACF;AUj2GA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVq2GjC;EUp2GA;IAAY,oBAAA;IAAsB,qBAAA;EVw2GlC;EUv2GA;IAAY,aAAA;IAAe,cAAA;EV22G3B;EU12GA;IAAY,oBAAA;IAAsB,qBAAA;EV82GlC;EU72GA;IAAY,oBAAA;IAAsB,qBAAA;EVi3GlC;EUh3GA;IAAY,aAAA;IAAe,cAAA;EVo3G3B;EUn3GA;IAAY,oBAAA;IAAsB,qBAAA;EVu3GlC;EUt3GA;IAAY,oBAAA;IAAsB,qBAAA;EV03GlC;EUz3GA;IAAY,aAAA;IAAe,cAAA;EV63G3B;EU53GA;IAAa,oBAAA;IAAsB,qBAAA;EVg4GnC;EU/3GA;IAAa,oBAAA;IAAsB,qBAAA;EVm4GnC;EUl4GA;IAAa,cAAA;IAAgB,eAAA;EVs4G7B;AACF;AUp4GA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVw4GjC;EUv4GA;IAAY,oBAAA;IAAsB,qBAAA;EV24GlC;EU14GA;IAAY,aAAA;IAAe,cAAA;EV84G3B;EU74GA;IAAY,oBAAA;IAAsB,qBAAA;EVi5GlC;EUh5GA;IAAY,oBAAA;IAAsB,qBAAA;EVo5GlC;EUn5GA;IAAY,aAAA;IAAe,cAAA;EVu5G3B;EUt5GA;IAAY,oBAAA;IAAsB,qBAAA;EV05GlC;EUz5GA;IAAY,oBAAA;IAAsB,qBAAA;EV65GlC;EU55GA;IAAY,aAAA;IAAe,cAAA;EVg6G3B;EU/5GA;IAAa,oBAAA;IAAsB,qBAAA;EVm6GnC;EUl6GA;IAAa,oBAAA;IAAsB,qBAAA;EVs6GnC;EUr6GA;IAAa,aAAA;IAAe,cAAA;EVy6G5B;AACF;AUv6GA,6BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EV26GjC;EU16GA;IAAY,oBAAA;IAAsB,qBAAA;EV86GlC;EU76GA;IAAY,aAAA;IAAe,cAAA;EVi7G3B;EUh7GA;IAAY,oBAAA;IAAsB,qBAAA;EVo7GlC;EUn7GA;IAAY,oBAAA;IAAsB,qBAAA;EVu7GlC;EUt7GA;IAAY,aAAA;IAAe,cAAA;EV07G3B;EUz7GA;IAAY,oBAAA;IAAsB,qBAAA;EV67GlC;EU57GA;IAAY,oBAAA;IAAsB,qBAAA;EVg8GlC;EU/7GA;IAAY,aAAA;IAAe,cAAA;EVm8G3B;EUl8GA;IAAa,oBAAA;IAAsB,qBAAA;EVs8GnC;EUr8GA;IAAa,oBAAA;IAAsB,qBAAA;EVy8GnC;EUx8GA;IAAa,aAAA;IAAe,cAAA;EV48G5B;AACF;AU18GA,6BAAA,QAAA;EACE;IAAa,mBAAA;IAAqB,oBAAA;EV88GlC;EU78GA;IAAa,oBAAA;IAAsB,qBAAA;EVi9GnC;EUh9GA;IAAa,aAAA;IAAe,cAAA;EVo9G5B;EUn9GA;IAAa,oBAAA;IAAsB,qBAAA;EVu9GnC;EUt9GA;IAAa,oBAAA;IAAsB,qBAAA;EV09GnC;EUz9GA;IAAa,aAAA;IAAe,cAAA;EV69G5B;EU59GA;IAAa,oBAAA;IAAsB,qBAAA;EVg+GnC;EU/9GA;IAAa,oBAAA;IAAsB,qBAAA;EVm+GnC;EUl+GA;IAAa,aAAA;IAAe,cAAA;EVs+G5B;EUr+GA;IAAc,oBAAA;IAAsB,qBAAA;EVy+GpC;EUx+GA;IAAc,oBAAA;IAAsB,qBAAA;EV4+GpC;EU3+GA;IAAc,aAAA;IAAe,cAAA;EV++G7B;AACF;AU9+GA;EACE,0BAAA;AVg/GF;;AU9+GA;EACE,iBAAA;AVi/GF;;AU/+GA;EACI,4CAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AVk/GJ;;AU/+GA;EACI,uBAAA;AVk/GJ;;AU/+GA;EACI,aAAA;AVk/GJ;;AU/+GA;EAEI,gCAAA;EACA,oCAAA;AVi/GJ;;AAp3IA;EACE,aAAA;EACA,uBAAA;AAu3IF;AAr3IE;EAEE,aAAA;EACA,eAAA;EAMA,gJAAA;AAi3IJ;AAr3II;EALF;IAMI,sBAAA;EAw3IJ;AACF;AAp3II;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,YAAA;AAs3IN;AAl3IE;EACE,mBAAA;EACA,gBAAA;AAo3IJ;AA/2IE;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;AAg3IJ;AA72II;EAEE,UAAA;EACA,mBAAA;EAEA,uBAAA;AA62IN;AA32IM;EACE,uBAAA;EACA,oCAAA;AA62IR;AA12IM;EACE,kCAAA;AA42IR;AAz2IM;EACE,kCAAA;AA22IR;AAx2IM;EACE,aAAA;AA02IR;AAv2IM;EACE,yBAAA;EACA,gBAAA;EACA,qBAAA;AAy2IR;AAj2II;EACE,mCAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAm2IN;AAj2IM;EACE,OAAA;AAm2IR;AAh2IM;EACE,mBAAA;AAk2IR;AA71IE;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;AA+1IJ;AA71II;EACE,iBAAA;EACA,oBAAA;AA+1IN;AA51II;EACE,6BAAA;AA81IN;AA11IE;EACE,mBAAA;AA41IJ;AAz1IE;EACE,WAAA;AA21IJ;AAx1IE;EACE,gBAAA;AA01IJ;AAr1IE;EACE,yBAAA;AAu1IJ;AAr1II;EACE,eAAA;AAu1IN;AAn1IE;EACE,aAAA;EACA,mBAAA;AAq1IJ;AAn1II;EACE,WAAA;AAq1IN;AAl1II;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AAo1IN;AAj1II;EACE,uBAAA;AAm1IN;AAh1II;EACE,uBAAA;AAk1IN;AA90IE;EACE,aAAA;EACA,qBAAA;AAg1IJ;AA90II;EACE,YAAA;AAg1IN;AA50IE;EACE,uBAAA;AA80IJ;;AA10IA;EACE,gCAAA;AA60IF;;AA10IA;EACE,8BAAA;AA60IF;;AA10IA;EACE,gBAAA;AA60IF;;AA10IA;EACE;IACE,qBAAA;IACA,sBAAA;EA60IF;EA30IE;IACE,WAAA;IACA,uBAAA;IACA,8BAAA;EA60IJ;EAv0IA;IACE,sBAAA;IACA,mBAAA;EAy0IF;EAt0IA;IACE,sBAAA;IACA,iBAAA;EAw0IF;EAr0IA;IACE,WAAA;IACA,iBAAA;IACA,sBAAA;IACA,mBAAA;EAu0IF;EAr0IE;IACE,WAAA;IACA,uBAAA;IACA,mBAAA;EAu0IJ;EAn0IA;IACE,iBAAA;EAq0IF;AACF;AAl0IA;EACE,0BAAA;AAo0IF;;AAj0IA;EACE,0BAAA;AAo0IF;;AAj0IA;EACE,WAAA;AAo0IF;;AAj0IA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAo0IF;AAl0IE;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;AAo0IJ;;AAh0IA;EACE;IACE,qBAAA;IACA,iBAAA;EAm0IF;EAh0IA;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,8BAAA;EAk0IF;EAh0IE;IACE,UAAA;EAk0IJ;EA/zIE;IACE,UAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EAi0IJ;AACF;AA5zIA;EACE;IACE,UAAA;EA8zIF;EA3zIA;IAEE,aAAA;IACA,mBAAA;IACA,8BAAA;EA4zIF;EA1zIE;IACE,UAAA;IACA,iBAAA;IACA,iBAAA;EA4zIJ;AACF;AC9xJE;EACE,gBAAA;EAIA,kBAAA;AD6xJJ;ACtxJI;EACE,wBAAA;ADwxJN;;ACpxJE;EACE,iBAAA;ADuxJJ;;ACpxJE;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,6DAAA;EAIA,2BAAA;ADmxJJ;AEpwJI;EDXE,aAAA;ADkxJN;;AEtzJE;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EAIA,mBAAA;EAGA,UAAA;EAGA,wBAAA;EACA,qBAAA;EAMA,OAAA;AF6yJJ;AE3yJI;EACE,UAAA;EACA,QAAA;AF6yJN;;AG7zJE;EAEE,oBAAA;EAGA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AH6zJJ;;AGzzJE;EACE,eAAA;EACA,aA3BwB;AHu1J5B;AG1zJI;EAGE,aAAA;AH0zJN;;AGlzJE;EACE,aAAA;EACA,kBAAA;EACA,aA1Cc;AH+1JlB;;AGjzJE;EAGE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aApDc;EAwDd,aAAA;EACA,eAAA;EACA,gBAAA;AH+yJJ;;AG5yJE;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aApEuB;EAqEvB,oBAAA;EACA,wCAAA;EACA,0DAAA;EACA,UAAA;AH6yJJ;AG3yJI;EACE,UAAA;AH6yJN;AGxyJM;EAGE,YAAA;AHwyJR;;AGnyJE;EACE,+BAtFqB;AH43JzB;;AGnyJE;EAEE,qDAAA;EACA,kBAAA;EACA,UAAA;AHqyJJ;AG/xJI;EACE,UAAA;EACA,mBAAA;AHiyJN;;AG7xJE;EACE,gBAAA;AHgyJJ;;AG3xJE;EACE,kBAAA;EACA,aArHc;EA0Hd,aAAA;EAIA,sBAAA;EAGA,cAAA;EACA,eAAA;AHqxJJ;;AGjxJE;EACE,eAAA;EAKA,WAAA;EAKA,kBAAA;AH4wJJ;;AI75JE;EACE,YAAA;AJg6JJ;;AI15JE;EAyCA,yBAAA;EACA,kCAAA;EAxCE,uBAAA;EACA,2BAAA;AJ85JJ;;AIr5JE;EA6BA,yBAAA;EACA,kCAAA;EA5BE,oBAAA;AJy5JJ;;AI/4JE,2CAAA,IAAA,EAAA;AACA,yCAAA,IAAA,EAAA;AAEA;EAEE,+CAAA;AJg5JJ;;AI74JE;EAEE,6CAAA;AJ+4JJ;;AK96JE;EACE,kBAAA;ALi7JJ;AK/6JI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,iDAAA;EACA,wJAAA;EAYA,4DAAA;AL06JN;AKl6JI;EACE,WAAA;ALo6JN;;AEz3JM;EG7BA,oCAAA;AL05JN;;AKr8JE;EACE,kBAAA;ALw8JJ;AKt8JI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,qDAAA;EACA,oKAAA;EAYA,gEAAA;ALi8JN;AKz7JI;EACE,WAAA;AL27JN;;AEh5JM;EG7BA,wCAAA;ALi7JN;;AO1+JA;;;;;CAAA;ACEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ARi/JF;;AQ9+JA;;;;;;EAME,qCAAA;EACA,gBAAA;ARi/JF;;AQ9+JA;EACE,eAAA;EACA,iBAAA;ARi/JF;;AQ9+JA;EACE,eAAA;EACA,iBAAA;ARi/JF;;AQ9+JA;EACE,eAAA;EACA,iBAAA;ARi/JF;;AQ9+JA;EACE,eAAA;EACA,iBAAA;ARi/JF;;AQ9+JA;EACE,eAAA;EACA,iBAAA;ARi/JF;;AQ9+JA;EACE,eAAA;EACA,iBAAA;ARi/JF;;AQ9+JA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;ARi/JF;;AQ9+JA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;ARi/JF;;AQ9+JA;EACE,gBAAA;EACA,eAAA;ARi/JF;;AOnjKA;;;;;CAAA;AEeE;EACE,YAAA;AT6iKJ;;AS3iKE;EACE,gBAAA;AT8iKJ;;AS5iKE;EACE,kBAAA;AT+iKJ;;AS7iKE;EACE,mBAAA;ATgjKJ;;AS9iKE;EACE,iBAAA;ATijKJ;;AS/iKE;EACE,iBAAA;EACA,kBAAA;ATkjKJ;;AShjKE;EACE,gBAAA;EACA,mBAAA;ATmjKJ;;AShjKE;EACE,WAAA;ATmjKJ;;ASjjKE;EACE,eAAA;ATojKJ;;ASljKE;EACE,iBAAA;ATqjKJ;;ASnjKE;EACE,kBAAA;ATsjKJ;;ASpjKE;EACE,gBAAA;ATujKJ;;ASrjKE;EACE,gBAAA;EACA,iBAAA;ATwjKJ;;AStjKE;EACE,eAAA;EACA,kBAAA;ATyjKJ;;AStmKE;EACE,YAAA;ATymKJ;;ASvmKE;EACE,gBAAA;AT0mKJ;;ASxmKE;EACE,kBAAA;AT2mKJ;;ASzmKE;EACE,mBAAA;AT4mKJ;;AS1mKE;EACE,iBAAA;AT6mKJ;;AS3mKE;EACE,iBAAA;EACA,kBAAA;AT8mKJ;;AS5mKE;EACE,gBAAA;EACA,mBAAA;AT+mKJ;;AS5mKE;EACE,WAAA;AT+mKJ;;AS7mKE;EACE,eAAA;ATgnKJ;;AS9mKE;EACE,iBAAA;ATinKJ;;AS/mKE;EACE,kBAAA;ATknKJ;;AShnKE;EACE,gBAAA;ATmnKJ;;ASjnKE;EACE,gBAAA;EACA,iBAAA;ATonKJ;;ASlnKE;EACE,eAAA;EACA,kBAAA;ATqnKJ;;ASlqKE;EACE,aAAA;ATqqKJ;;ASnqKE;EACE,iBAAA;ATsqKJ;;ASpqKE;EACE,mBAAA;ATuqKJ;;ASrqKE;EACE,oBAAA;ATwqKJ;;AStqKE;EACE,kBAAA;ATyqKJ;;ASvqKE;EACE,kBAAA;EACA,mBAAA;AT0qKJ;;ASxqKE;EACE,iBAAA;EACA,oBAAA;AT2qKJ;;ASxqKE;EACE,YAAA;AT2qKJ;;ASzqKE;EACE,gBAAA;AT4qKJ;;AS1qKE;EACE,kBAAA;AT6qKJ;;AS3qKE;EACE,mBAAA;AT8qKJ;;AS5qKE;EACE,iBAAA;AT+qKJ;;AS7qKE;EACE,iBAAA;EACA,kBAAA;ATgrKJ;;AS9qKE;EACE,gBAAA;EACA,mBAAA;ATirKJ;;AS9tKE;EACE,aAAA;ATiuKJ;;AS/tKE;EACE,iBAAA;ATkuKJ;;AShuKE;EACE,mBAAA;ATmuKJ;;ASjuKE;EACE,oBAAA;ATouKJ;;ASluKE;EACE,kBAAA;ATquKJ;;ASnuKE;EACE,kBAAA;EACA,mBAAA;ATsuKJ;;ASpuKE;EACE,iBAAA;EACA,oBAAA;ATuuKJ;;ASpuKE;EACE,YAAA;ATuuKJ;;ASruKE;EACE,gBAAA;ATwuKJ;;AStuKE;EACE,kBAAA;ATyuKJ;;ASvuKE;EACE,mBAAA;AT0uKJ;;ASxuKE;EACE,iBAAA;AT2uKJ;;ASzuKE;EACE,iBAAA;EACA,kBAAA;AT4uKJ;;AS1uKE;EACE,gBAAA;EACA,mBAAA;AT6uKJ;;AS1xKE;EACE,aAAA;AT6xKJ;;AS3xKE;EACE,iBAAA;AT8xKJ;;AS5xKE;EACE,mBAAA;AT+xKJ;;AS7xKE;EACE,oBAAA;ATgyKJ;;AS9xKE;EACE,kBAAA;ATiyKJ;;AS/xKE;EACE,kBAAA;EACA,mBAAA;ATkyKJ;;AShyKE;EACE,iBAAA;EACA,oBAAA;ATmyKJ;;AShyKE;EACE,YAAA;ATmyKJ;;ASjyKE;EACE,gBAAA;AToyKJ;;ASlyKE;EACE,kBAAA;ATqyKJ;;ASnyKE;EACE,mBAAA;ATsyKJ;;ASpyKE;EACE,iBAAA;ATuyKJ;;ASryKE;EACE,iBAAA;EACA,kBAAA;ATwyKJ;;AStyKE;EACE,gBAAA;EACA,mBAAA;ATyyKJ;;ASt1KE;EACE,aAAA;ATy1KJ;;ASv1KE;EACE,iBAAA;AT01KJ;;ASx1KE;EACE,mBAAA;AT21KJ;;ASz1KE;EACE,oBAAA;AT41KJ;;AS11KE;EACE,kBAAA;AT61KJ;;AS31KE;EACE,kBAAA;EACA,mBAAA;AT81KJ;;AS51KE;EACE,iBAAA;EACA,oBAAA;AT+1KJ;;AS51KE;EACE,YAAA;AT+1KJ;;AS71KE;EACE,gBAAA;ATg2KJ;;AS91KE;EACE,kBAAA;ATi2KJ;;AS/1KE;EACE,mBAAA;ATk2KJ;;ASh2KE;EACE,iBAAA;ATm2KJ;;ASj2KE;EACE,iBAAA;EACA,kBAAA;ATo2KJ;;ASl2KE;EACE,gBAAA;EACA,mBAAA;ATq2KJ;;ASl5KE;EACE,aAAA;ATq5KJ;;ASn5KE;EACE,iBAAA;ATs5KJ;;ASp5KE;EACE,mBAAA;ATu5KJ;;ASr5KE;EACE,oBAAA;ATw5KJ;;ASt5KE;EACE,kBAAA;ATy5KJ;;ASv5KE;EACE,kBAAA;EACA,mBAAA;AT05KJ;;ASx5KE;EACE,iBAAA;EACA,oBAAA;AT25KJ;;ASx5KE;EACE,YAAA;AT25KJ;;ASz5KE;EACE,gBAAA;AT45KJ;;AS15KE;EACE,kBAAA;AT65KJ;;AS35KE;EACE,mBAAA;AT85KJ;;AS55KE;EACE,iBAAA;AT+5KJ;;AS75KE;EACE,iBAAA;EACA,kBAAA;ATg6KJ;;AS95KE;EACE,gBAAA;EACA,mBAAA;ATi6KJ;;AS98KE;EACE,aAAA;ATi9KJ;;AS/8KE;EACE,iBAAA;ATk9KJ;;ASh9KE;EACE,mBAAA;ATm9KJ;;ASj9KE;EACE,oBAAA;ATo9KJ;;ASl9KE;EACE,kBAAA;ATq9KJ;;ASn9KE;EACE,kBAAA;EACA,mBAAA;ATs9KJ;;ASp9KE;EACE,iBAAA;EACA,oBAAA;ATu9KJ;;ASp9KE;EACE,YAAA;ATu9KJ;;ASr9KE;EACE,gBAAA;ATw9KJ;;ASt9KE;EACE,kBAAA;ATy9KJ;;ASv9KE;EACE,mBAAA;AT09KJ;;ASx9KE;EACE,iBAAA;AT29KJ;;ASz9KE;EACE,iBAAA;EACA,kBAAA;AT49KJ;;AS19KE;EACE,gBAAA;EACA,mBAAA;AT69KJ;;AS1gLE;EACE,aAAA;AT6gLJ;;AS3gLE;EACE,iBAAA;AT8gLJ;;AS5gLE;EACE,mBAAA;AT+gLJ;;AS7gLE;EACE,oBAAA;ATghLJ;;AS9gLE;EACE,kBAAA;ATihLJ;;AS/gLE;EACE,kBAAA;EACA,mBAAA;ATkhLJ;;AShhLE;EACE,iBAAA;EACA,oBAAA;ATmhLJ;;AShhLE;EACE,YAAA;ATmhLJ;;ASjhLE;EACE,gBAAA;ATohLJ;;ASlhLE;EACE,kBAAA;ATqhLJ;;ASnhLE;EACE,mBAAA;ATshLJ;;ASphLE;EACE,iBAAA;ATuhLJ;;ASrhLE;EACE,iBAAA;EACA,kBAAA;ATwhLJ;;ASthLE;EACE,gBAAA;EACA,mBAAA;ATyhLJ;;AStkLE;EACE,aAAA;ATykLJ;;ASvkLE;EACE,iBAAA;AT0kLJ;;ASxkLE;EACE,mBAAA;AT2kLJ;;ASzkLE;EACE,oBAAA;AT4kLJ;;AS1kLE;EACE,kBAAA;AT6kLJ;;AS3kLE;EACE,kBAAA;EACA,mBAAA;AT8kLJ;;AS5kLE;EACE,iBAAA;EACA,oBAAA;AT+kLJ;;AS5kLE;EACE,YAAA;AT+kLJ;;AS7kLE;EACE,gBAAA;ATglLJ;;AS9kLE;EACE,kBAAA;ATilLJ;;AS/kLE;EACE,mBAAA;ATklLJ;;AShlLE;EACE,iBAAA;ATmlLJ;;ASjlLE;EACE,iBAAA;EACA,kBAAA;ATolLJ;;ASllLE;EACE,gBAAA;EACA,mBAAA;ATqlLJ;;ASloLE;EACE,aAAA;ATqoLJ;;ASnoLE;EACE,iBAAA;ATsoLJ;;ASpoLE;EACE,mBAAA;ATuoLJ;;ASroLE;EACE,oBAAA;ATwoLJ;;AStoLE;EACE,kBAAA;ATyoLJ;;ASvoLE;EACE,kBAAA;EACA,mBAAA;AT0oLJ;;ASxoLE;EACE,iBAAA;EACA,oBAAA;AT2oLJ;;ASxoLE;EACE,YAAA;AT2oLJ;;ASzoLE;EACE,gBAAA;AT4oLJ;;AS1oLE;EACE,kBAAA;AT6oLJ;;AS3oLE;EACE,mBAAA;AT8oLJ;;AS5oLE;EACE,iBAAA;AT+oLJ;;AS7oLE;EACE,iBAAA;EACA,kBAAA;ATgpLJ;;AS9oLE;EACE,gBAAA;EACA,mBAAA;ATipLJ;;AUrsLA;EACE;;;;;cAAA;EAMA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA,wDAAA;AVosLF;;AUjsLA,8EAAA;AACA,2DAAA;AACA,wCAAA;AACA,uCAAA;AACA;EACE,wCAAA;AVosLF;;AUjsLA,iDAAA;AACA;EACE,wCAAA;AVosLF;;AUjsLA;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AVosLF;AUlsLE;EACE,aAAA;AVosLJ;;AUhsLA,oBAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AVmsLF;;AUhsLA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wHAAA;AVmsLF;;AU/rLA;EACE,oCAAA;EACA,yBAAA;AVksLF;;AU/rLA;EACE,iCAAA;EACA,oCAAA;EACA,0HAAA;AVksLF;;AU9rLA;EACE,kCAAA;AVisLF;;AU9rLA;EACE,6BAAA;AVisLF;;AU9rLA;EACE,kCAAA;AVisLF;;AU9rLA;;EAEE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wHAAA;AVisLF;;AU7rLA,2BAAA;AAEA;EACE,SAAA;AV+rLF;;AU5rLA;EACE,WAAA;EACA,2BAAA;AV+rLF;AU7rLE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;AV+rLJ;AU5rLE;EACE,uBAAA;AV8rLJ;AU3rLE;EACE,kBAAA;AV6rLJ;;AUzrLA;EACE,WAAA;EACA,2BAAA;AV4rLF;;AUzrLA;EACE,WAAA;EACA,gBAAA;AV4rLF;AU1rLE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;AV4rLJ;AUzrLE;EACE,uBAAA;AV2rLJ;AUxrLE;EACE,kBAAA;AV0rLJ;;AUtrLA;EACE,WAAA;EACA,gBAAA;AVyrLF;AUvrLE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AVyrLJ;AUtrLE;EACE,uBAAA;AVwrLJ;AUrrLE;EACE,kBAAA;AVurLJ;;AUnrLA;EACE,WAAA;EACA,gBAAA;AVsrLF;AUprLE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AVsrLJ;AUnrLE;EACE,uBAAA;AVqrLJ;AUlrLE;EACE,kBAAA;AVorLJ;;AUhrLA;EACE,aAAA;AVmrLF;;AUhrLA;EACE,2BAAA;AVmrLF;AUhrLI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AVkrLN;AU/qLI;EACE,iBAAA;EACA,eAAA;AVirLN;AU9qLI;EACE,mBAAA;AVgrLN;AU7qLI;EACE,2CAAA;AV+qLN;;AU1qLA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AV6qLF;;AU1qLA;EACE,oBAAA;EACA,mBAAA;AV6qLF;AU3qLE;EACE,YAAA;EACA,WAAA;AV6qLJ;;AUxqLI;EADF;IAEI,gBAAA;IACA,0BAAA;IACA,qBAAA;IACA,YAAA;EV4qLJ;AACF;;AUzqLA;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV4qLF;AU1qLE;EAXF;IAYI,gBAAA;IACA,0BAAA;IACA,UAAA;IACA,YAAA;EV6qLF;AACF;AU3qLE;EACE,8BAAA;AV6qLJ;;AUzqLA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV4qLF;AU1qLE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EV6qLF;AACF;AU3qLE;EACE,8BAAA;AV6qLJ;;AUzqLA;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV4qLF;AU1qLE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EV6qLF;AACF;;AU1qLA;;CAAA;AAGA;EACE,gBAAA;EACA,kBAAA;AV6qLF;;AU1qLA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;AV6qLF;;AU3qLA;EACE,mDAAA;EACA,4CAAA;AV8qLF;;AU3qLA;EACE,sCAAA;EACA,kBAAA;EACA,yCAAA;AV8qLF;;AU5qLA;EACE,uBAAA;EACA,kBAAA;EACA,yCAAA;AV+qLF;;AU7qLA;EACE,kCAAA;EACA,kBAAA;EACA,kCAAA;AVgrLF;;AU9qLA;EACE,2BAAA;AVirLF;;AU9qLE;EACE,YAAA;AVirLJ;AU/qLE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;AVirLJ;AU9qLI;EACE,yBAAA;EACA,oCAAA;AVgrLN;AU5qLE;EACE,uBAAA;AV8qLJ;AU5qLE;EACE,uBAAA;AV8qLJ;AU5qLE;EACE,uBAAA;AV8qLJ;;AU1qLA;EACE;IACE,4BAAA;IACA,eAAA;EV6qLF;EU1qLA;IACE,2BAAA;IACA,4BAAA;IACA,eAAA;EV4qLF;EUzqLA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EV2qLF;EUzqLA;IACE,WAAA;IACA,gBAAA;IACA,4BAAA;IACA,2BAAA;EV2qLF;EUzqLA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EV2qLF;AACF;AUxqLA;EACE;IACE,kBAAA;EV0qLF;EUxqLA;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EV0qLF;EUvqLA;IACE,kBAAA;IACA,0BAAA;EVyqLF;EUvqLA;IACE,0BAAA;IACA,0BAAA;IACA,2BAAA;EVyqLF;EUvqLE;IACF,kBAAA;IACE,0BAAA;EVyqLF;AACF;AUtqLA;EACE;IACE,UAAA;EVwqLF;AACF;AUrqLA;EACE,wCAAA;AVuqLF;;AUpqLA;EACE;IACE,iBAAA;IACA,8CAAA;EVuqLF;AACF;AUpqLA;EACE,kCAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AVsqLF;AUpqLE;EACE,sBAAA;AVsqLJ;;AUlqLA;EACE,wBAAA;AVqqLF;;AUnqLA;EACE,qBAAA,EAAA,wCAAA;AVsqLF;;AUpqLA;EACE,iBAAA;EACA,iBAAA;EACA,yBAAA;AVuqLF;AUrqLE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EAEA,8BAAA;EACA,aAAA;AVsqLJ;AUpqLI;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AVsqLN;AUnqLI;;EAEE,eAAA;EACA,mBAAA;EACA,cAAA;AVqqLN;AUnqLI;EApBF;IAqBI,WAAA;IACA,cAAA;EVsqLJ;AACF;AUnqLE;EACE,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AVqqLJ;AUnqLI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AVqqLN;AUjqLE;EACE,iBAAA;EACA,uBAAA;AVmqLJ;AUhqLI;EADF;IAEI,eAAA;EVmqLJ;AACF;AUhqLE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AVkqLJ;AU/pLE;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AViqLJ;AU/pLI;EACE,iBAAA;AViqLN;;AU5pLA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AV+pLF;;AU5pLA;EACE,kCAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AV+pLF;;AU5pLA;EACE,qBAAA;AV+pLF;;AU5pLA;EACE,kCAAA;EACA,YAAA;AV+pLF;;AU5pLA;EACE,kCAAA;EACA,YAAA;AV+pLF;;AU7pLA;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AV+pLF;;AU3pLA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AV8pLF;;AU5pLA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AV+pLF;AU7pLE;EACE,WAAA;AV+pLJ;AU5pLE;EACE;IACE,aAAA;EV8pLJ;AACF;;AU1pLA;EACE,aAAA;EACA,mBAAA;AV6pLF;AU3pLE;EACE,WAAA;AV6pLJ;AU1pLE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AV4pLJ;AUzpLE;EACE,uBAAA;AV2pLJ;AUxpLE;EACE,uBAAA;AV0pLJ;;AUtpLA;;EAEE,mCAAA;EACA,6BAAA;EACA,yCAAA;EACA,4DAAA;EACA,0DAAA;EACA,0DAAA;AVypLF;;AUtpLA;EACE,uBAAA;AVypLF;;AUtpLA;EACE,aAAA;EACA,eAAA;AVypLF;AUvpLE;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;AVypLJ;;AUrpLA;EACE,gBAAA;EACA,kBAAA;AVwpLF;;AUppLA;EACE,iDAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AVupLF;;AUnpLE;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sBAAA;AVspLJ;;AUjpLE;EACE,mCAAA;AVopLJ;AUjpLE;EACE,wBAAA;EACA,kBAAA;AVmpLJ;;AU9oLE;EACE,kCAAA;AVipLJ;AU9oLE;EACE,uBAAA;EACA,kBAAA;AVgpLJ;;AU5oLA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AV+oLF;AU7oLE;EACE,sCAAA;EACA,+CAAA;AV+oLJ;;AU3oLA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AV8oLF;;AU3oLA,oCAAA;AACA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AV8oLF;;AU3oLA;EAEE,qBAAA;AV6oLF;;AUtoLA;EAEE,cAAA;AVwoLF;;AUroLA;EACM,2BAAA;AVwoLN;;AUtoLA;EACE,2BAAA;AVyoLF;;AUvoLA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AV0oLF;;AUvoLA;EACE,aAAA;EACA,iBAAA;AV0oLF;;AUvoLA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AV0oLF;AUxoLE;EACE,kBAAA;AV0oLJ;;AUtoLA;EACE,kBAAA;EACA,kBAAA;AVyoLF;;AUvoLA;EACE,YAAA;EAEA,wCAAA;EACA,yBAAA;EACA,kBAAA;AVyoLF;AUvoLE;EACE,gBAAA;AVyoLJ;AUvoLE;EACE,WAAA;AVyoLJ;;AUroLA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AVwoLF;;AUroLA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AVwoLF;;AUroLA;EACE,sBAAA;EACA,YAAA;AVwoLF;;AUroLA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AVwoLF;;AUtoLA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;AVyoLF;;AUvoLA;EACE,iCAAA;AV0oLF;;AUxoLA;EACE,sBAAA;AV2oLF;;AUzoLA;EACE,iDAAA;EACA,mDAAA;AV4oLF;;AUzoLE;EACE,8BAAA;AV4oLJ;;AUxoLE;EACE,8BAAA;AV2oLJ;;AUxoLA;EACE,uBAAA;AV2oLF;;AUzoLA;EAEE,kCAAA;EACA,YAAA;EACA,kCAAA;EACA,6BAAA;AV2oLF;;AUzoLA;EACE,6BAAA;EACA,kBAAA;AV4oLF;;AU1oLA;EACE,oCAAA;AV6oLF;;AU3oLA;EACE,kCAAA;AV8oLF;;AU3oLE;EADF;IAEI,WAAA;EV+oLF;AACF;;AU5oLA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AV+oLF;;AU3oLE;EACE,qBAAA;AV8oLJ;AUnoLA;EACI,eAAA;EACI,oBAAA;EACJ,aAAA;AVqoLJ;;AUnoLA;EACI,eAAA;EACE,oBAAA;EACF,aAAA;AVsoLJ;;AUnoLA;EACE,2BAAA;AVsoLF;;AUloLE;EADF;IAEI,wBAAA;EVsoLF;AACF;;AUpoLA;EACE,4CAAA;EACA,gDAAA,EAAA,iBAAA;EACA,sDAAA,EAAA,mBAAA;EACA,8CAAA;AVuoLF;;AUpoLA;EAAO,iBAAA;AVwoLP;;AUvoLA;EAAO,uBAAA;AV2oLP;;AU1oLA;EAAO,sBAAA;AV8oLP;;AU7oLA;EAAO,oBAAA;AVipLP;;AUhpLA;EAAO,sBAAA;AVopLP;;AUnpLA;EAAO,oBAAA;AVupLP;;AUppLA;EAAQ,wBAAA;AVwpLR;;AUvpLA;EAAQ,8BAAA;AV2pLR;;AU1pLA;EAAQ,6BAAA;AV8pLR;;AU7pLA;EAAQ,2BAAA;AViqLR;;AUhqLA;EAAQ,6BAAA;AVoqLR;;AUnqLA;EAAQ,2BAAA;AVuqLR;;AUpqLA;EAAQ,qBAAA;AVwqLR;;AUvqLA;EAAQ,2BAAA;AV2qLR;;AU1qLA;EAAQ,0BAAA;AV8qLR;;AU7qLA;EAAQ,wBAAA;AVirLR;;AUhrLA;EAAQ,0BAAA;AVorLR;;AUnrLA;EAAQ,wBAAA;AVurLR;;AUtrLA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AVyrLF;;AUtrLA;EAAS,mBAAA;EAAqB,oBAAA;AV2rL9B;;AU1rLA;EAAS,oBAAA;EAAsB,qBAAA;AV+rL/B;;AU9rLA;EAAS,aAAA;EAAe,cAAA;AVmsLxB;;AUlsLA;EAAS,oBAAA;EAAsB,qBAAA;AVusL/B;;AUtsLA;EAAS,oBAAA;EAAsB,qBAAA;AV2sL/B;;AU1sLA;EAAS,aAAA;EAAe,cAAA;AV+sLxB;;AU9sLA;EAAS,oBAAA;EAAsB,qBAAA;AVmtL/B;;AUltLA;EAAS,oBAAA;EAAsB,qBAAA;AVutL/B;;AUttLA;EAAS,aAAA;EAAe,cAAA;AV2tLxB;;AU1tLA;EAAU,oBAAA;EAAsB,qBAAA;AV+tLhC;;AU9tLA;EAAU,oBAAA;EAAsB,qBAAA;AVmuLhC;;AUluLA;EAAU,aAAA;EAAe,cAAA;AVuuLzB;;AUruLA,wBAAA;AACA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EV0uLjC;EUzuLA;IAAY,oBAAA;IAAsB,qBAAA;EV6uLlC;EU5uLA;IAAY,aAAA;IAAe,cAAA;EVgvL3B;EU/uLA;IAAY,oBAAA;IAAsB,qBAAA;EVmvLlC;EUlvLA;IAAY,oBAAA;IAAsB,qBAAA;EVsvLlC;EUrvLA;IAAY,aAAA;IAAe,cAAA;EVyvL3B;EUxvLA;IAAY,oBAAA;IAAsB,qBAAA;EV4vLlC;EU3vLA;IAAY,oBAAA;IAAsB,qBAAA;EV+vLlC;EU9vLA;IAAY,aAAA;IAAe,cAAA;EVkwL3B;EUjwLA;IAAa,oBAAA;IAAsB,qBAAA;EVqwLnC;EUpwLA;IAAa,oBAAA;IAAsB,qBAAA;EVwwLnC;EUvwLA;IAAa,aAAA;IAAe,cAAA;EV2wL5B;AACF;AUzwLA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EV6wLjC;EU5wLA;IAAY,oBAAA;IAAsB,qBAAA;EVgxLlC;EU/wLA;IAAY,aAAA;IAAe,cAAA;EVmxL3B;EUlxLA;IAAY,oBAAA;IAAsB,qBAAA;EVsxLlC;EUrxLA;IAAY,oBAAA;IAAsB,qBAAA;EVyxLlC;EUxxLA;IAAY,aAAA;IAAe,cAAA;EV4xL3B;EU3xLA;IAAY,oBAAA;IAAsB,qBAAA;EV+xLlC;EU9xLA;IAAY,oBAAA;IAAsB,qBAAA;EVkyLlC;EUjyLA;IAAY,aAAA;IAAe,cAAA;EVqyL3B;EUpyLA;IAAa,oBAAA;IAAsB,qBAAA;EVwyLnC;EUvyLA;IAAa,oBAAA;IAAsB,qBAAA;EV2yLnC;EU1yLA;IAAa,cAAA;IAAgB,eAAA;EV8yL7B;AACF;AU5yLA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVgzLjC;EU/yLA;IAAY,oBAAA;IAAsB,qBAAA;EVmzLlC;EUlzLA;IAAY,aAAA;IAAe,cAAA;EVszL3B;EUrzLA;IAAY,oBAAA;IAAsB,qBAAA;EVyzLlC;EUxzLA;IAAY,oBAAA;IAAsB,qBAAA;EV4zLlC;EU3zLA;IAAY,aAAA;IAAe,cAAA;EV+zL3B;EU9zLA;IAAY,oBAAA;IAAsB,qBAAA;EVk0LlC;EUj0LA;IAAY,oBAAA;IAAsB,qBAAA;EVq0LlC;EUp0LA;IAAY,aAAA;IAAe,cAAA;EVw0L3B;EUv0LA;IAAa,oBAAA;IAAsB,qBAAA;EV20LnC;EU10LA;IAAa,oBAAA;IAAsB,qBAAA;EV80LnC;EU70LA;IAAa,aAAA;IAAe,cAAA;EVi1L5B;AACF;AU/0LA,6BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVm1LjC;EUl1LA;IAAY,oBAAA;IAAsB,qBAAA;EVs1LlC;EUr1LA;IAAY,aAAA;IAAe,cAAA;EVy1L3B;EUx1LA;IAAY,oBAAA;IAAsB,qBAAA;EV41LlC;EU31LA;IAAY,oBAAA;IAAsB,qBAAA;EV+1LlC;EU91LA;IAAY,aAAA;IAAe,cAAA;EVk2L3B;EUj2LA;IAAY,oBAAA;IAAsB,qBAAA;EVq2LlC;EUp2LA;IAAY,oBAAA;IAAsB,qBAAA;EVw2LlC;EUv2LA;IAAY,aAAA;IAAe,cAAA;EV22L3B;EU12LA;IAAa,oBAAA;IAAsB,qBAAA;EV82LnC;EU72LA;IAAa,oBAAA;IAAsB,qBAAA;EVi3LnC;EUh3LA;IAAa,aAAA;IAAe,cAAA;EVo3L5B;AACF;AUl3LA,6BAAA,QAAA;EACE;IAAa,mBAAA;IAAqB,oBAAA;EVs3LlC;EUr3LA;IAAa,oBAAA;IAAsB,qBAAA;EVy3LnC;EUx3LA;IAAa,aAAA;IAAe,cAAA;EV43L5B;EU33LA;IAAa,oBAAA;IAAsB,qBAAA;EV+3LnC;EU93LA;IAAa,oBAAA;IAAsB,qBAAA;EVk4LnC;EUj4LA;IAAa,aAAA;IAAe,cAAA;EVq4L5B;EUp4LA;IAAa,oBAAA;IAAsB,qBAAA;EVw4LnC;EUv4LA;IAAa,oBAAA;IAAsB,qBAAA;EV24LnC;EU14LA;IAAa,aAAA;IAAe,cAAA;EV84L5B;EU74LA;IAAc,oBAAA;IAAsB,qBAAA;EVi5LpC;EUh5LA;IAAc,oBAAA;IAAsB,qBAAA;EVo5LpC;EUn5LA;IAAc,aAAA;IAAe,cAAA;EVu5L7B;AACF;AUt5LA;EACE,0BAAA;AVw5LF;;AUt5LA;EACE,iBAAA;AVy5LF;;AUv5LA;EACI,4CAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AV05LJ;;AUv5LA;EACI,uBAAA;AV05LJ;;AUv5LA;EACI,aAAA;AV05LJ;;AUv5LA;EAEI,gCAAA;EACA,oCAAA;AVy5LJ;;AAx/MA;EACE,UAAA;AA2/MF;AAz/ME;EAHF;IAII,UAAA;IACA,iBAAA;EA4/MF;AACF;;AAz/MA;EACE,aAAA;EACA,mBAAA;AA4/MF;AA1/ME;EACE,WAAA;AA4/MJ;AAz/ME;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AA2/MJ;AAx/ME;EACE,uBAAA;AA0/MJ;AAv/ME;EACE,uBAAA;AAy/MJ;;AAr/MA;EACE,aAAA;AAw/MF;AAt/ME;EAHF;IAII,sBAAA;EAy/MF;AACF;;AAp/MA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EAEA,WAAA;AAs/MF;;AAn/MA;EACE,iBAAA;EACA,eAAA;AAs/MF;;AAn/MA;EACE,WAAA;EAEA,oBAAA;EACA,eAAA;AAq/MF;AAn/ME;EANF;IAOI,YAAA;EAs/MF;AACF;AAp/ME;EACE,eAAA;EACA,aAAA;EACA,sBAAA;AAs/MJ;AAp/MI;EALF;IAMI,YAAA;EAu/MJ;AACF;AAp/ME;EAEE,WAAA;EACA,OAAA;EACA,gBAAA;AAq/MJ;AAn/MI;EANF;IAOI,WAAA;EAs/MJ;AACF;AAl/ME;EACE,8BAAA;EACA,iBAAA;AAo/MJ;AAl/MI;EACE,YAAA;AAo/MN;AAh/ME;EACE,aAAA;EACA,uBAAA;AAk/MJ;AAh/MI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;AAk/MN;AAh/MM;EAPF;IAQI,WAAA;EAm/MN;AACF;AA/+ME;EACE,2BAAA;EACA,YAAA;EAEA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAg/MJ;AA9+MI;EAZF;IAaI,gBAAA;IACA,0BAAA;IACA,sBAAA;IACA,YAAA;EAi/MJ;AACF;AA/+MI;EACE,8BAAA;AAi/MN;AA7+ME;EACE,iBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA8+MJ;AA5+MI;EAZF;IAaI,gBAAA;IACA,WAAA;IACA,YAAA;EA++MJ;AACF;AA7+MI;EACE,8BAAA;AA++MN;AA3+ME;EACE,kBAAA;EACA,sBAAA;AA6+MJ;AA1+ME;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AA4+MJ;AA1+MI;EANF;IAOI,gBAAA;EA6+MJ;AACF;AA3+MI;EACE,kBAAA;EACA,kBAAA;AA6+MN;AAz+ME;EACE,sBAAA;AA2+MJ;AAx+ME;EACE,kBAAA;EACA,sBAAA;AA0+MJ;AAv+ME;EACE,sBAAA;AAy+MJ;AAt+ME;EACE,gBAAA;EACA,oBAAA;EACA,sBAAA;AAw+MJ;AAr+ME;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAu+MJ;AAr+MI;EACE,eAAA;AAu+MN;AAp+MI;EATF;IAUI,gBAAA;IACA,mBAAA;EAu+MJ;AACF;AAn+ME;EACE,oBAAA;EACA,aAAA;EACA,yBAAA;AAq+MJ;AAj+MI;EACE,kBAAA;AAm+MN;AA/9ME;EA7KF;IA8KI,mBAAA;IACA,eAAA;IACA,WAAA;EAk+MF;AACF;AAh+ME;EACE;IACE,YAAA;EAk+MJ;EA/9ME;IACE,aAAA;EAi+MJ;AACF;AA99ME;EA7LF;IA8LI,mBAAA;IACA,eAAA;EAi+MF;AACF;AA/9ME;EAlMF;IAmMI,mBAAA;IACA,eAAA;EAk+MF;AACF;AAh+ME;EAvMF;IAwMI,mBAAA;IACA,eAAA;EAm+MF;AACF;;AAh+MA;EACE,WAAA;AAm+MF;;AAh+MA;EACE;IACE,aAAA;IACA,sBAAA;EAm+MF;EAj+ME;IACE,sBAAA;IACA,mBAAA;IACA,oBAAA;EAm+MJ;AACF;AA/9MA;EACE,eAAA;AAi+MF;;AA79MA;EACE,8BAAA;EACA,gDAAA;AAg+MF;;AA79MA;EACE,mBAAA;EACA,wDAAA;AAg+MF;;AA79MA;EACE,8BAAA;EACA,6CAAA;AAg+MF;;AA79MA;EACE,2BAAA;EACA,6BAAA;EAEA,gBAAA;AA+9MF;;AA59MA;EACE,wBAAA;AA+9MF;;AA59MA,2BAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,eAAA;EACA,kDAAA;AA+9MF;;AA59MA;EACE,WAAA;EACA,aAAA;EAEA,8BAAA;AA89MF;AA59ME;EACE,UAAA;AA89MJ;AA39ME;EACE,WAAA;AA69MJ;AA19ME;EACE,UAAA;AA49MJ;AAz9ME;EACE,UAAA;AA29MJ;AAx9ME;EACE,eAAA;EACA,iBAAA;AA09MJ;;AAt9MA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAy9MF;AAv9ME;EACE,UAAA;AAy9MJ;AAt9ME;EACE,WAAA;AAw9MJ;AAr9ME;EACE,UAAA;AAu9MJ;AAp9ME;EACE,eAAA;EACA,iBAAA;AAs9MJ;;AAl9MA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAq9MF;AAn9ME;EACE,UAAA;AAq9MJ;AAl9ME;EACE,WAAA;AAo9MJ;AAj9ME;EACE,UAAA;AAm9MJ;AAh9ME;EACE,eAAA;EACA,iBAAA;AAk9MJ;;AA98MA;EACE,UAAA;EACA,aAAA;AAi9MF;AA98ME;EAEE,UAAA;AA+8MJ;AA58ME;EAEE,UAAA;AA68MJ;;AAz8MA;EACE,iBAAA;AA48MF;;AAz8MA;EACE,+CAAA;EACA,wCAAA;EACA,oCAAA;EACA,4BAAA;AA48MF;;AAz8MA;EACE,6CAAA;EACA,sBAAA;EACA,6CAAA;AA48MF;;AAz8MA;EACE,+CAAA;EACA,YAAA;EACA,+CAAA;EACA,mBAAA;AA48MF;;AAx8MA;EACE,wCAAA;EACA,kCAAA;EACA,6CAAA;AA28MF;;AAx8MA;EAEE,aAAA;EACA,sBAAA;AA08MF;AAx8ME;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA08MJ;AAx8MI;EACE,kBAAA;AA08MN;AAv8MI;EACE,aAAA;EACA,mBAAA;AAy8MN;;AAp8MA;EACE,kCAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AAu8MF;;AAp8MA;EACE,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AAu8MF;;AAp8MA;EACE,qBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AAu8MF;;AAp8MA;EACE,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AAu8MF;;AAp8MA;EACE,uBAAA;AAu8MF;;AAp8MA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AAu8MF;AAr8ME;EACE,UAAA;AAu8MJ;;AAn8MA;EACE,iBAAA;AAs8MF;;AAn8MA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AAs8MF;AAp8ME;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAs8MJ;AAp8MI;EACE,UAAA;AAs8MN;AAn8MI;EACE,kBAAA;EACA,iCAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;AAq8MN;AAn8MM;EACE,kCAAA;AAq8MR;;AA/7MA;EACE,WAAA;EACA,aAAA;AAk8MF;AA/7ME;EACE,UAAA;AAi8MJ;;AA77MA;EACE,iBAAA;EAEA,mBAAA;EACA,2BAAA;AA+7MF;;AA57MA;EACE,eAAA;EACA,eAAA;AA+7MF;;AA57MA;EACE,iBAAA;AA+7MF;;AA57MA;EACE,aAAA;EACA,mBAAA;AA+7MF;;AA57MA;EAEE;;IAEE,sBAAA;EA87MF;EA57ME;;IACE,WAAA;EA+7MJ;EA37MA;IACE,WAAA;EA67MF;EA17MA;IACE,WAAA;EA47MF;EAz7MA;IACE,OAAA;IACA,2BAAA;EA27MF;EAx7MA;IACE,sBAAA;IACA,WAAA;EA07MF;EAx7ME;IACE,WAAA;EA07MJ;EAv7ME;IACE,iBAAA;IACA,UAAA;EAy7MJ;EAr7MA;IACE,aAAA;IACA,sBAAA;EAu7MF;EAr7ME;IACE,WAAA;EAu7MJ;EAn7MA;IACE,qBAAA;IACA,YAAA;EAq7MF;AACF;AA96MA;EACE;IACE,aAAA;IACA,sBAAA;IACA,2BAAA;EAg7MF;AACF;AA36MA;EACE,WAAA;AA66MF;;AA16MA;EACE,gBAAA;AA66MF;;AA16MA;EACE,cAAA;AA66MF;AA36ME;EACE,eAAA;AA66MJ;;AAz6MA;EACE,iBAAA;EACA,kCAAA;EAEA,aAAA;AA26MF;AAz6ME;EACE,iBAAA;EACA,gBAAA;AA26MJ;AAx6ME;EACE,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AA06MJ;;AAp5MA;EAEE;IACE,uBAAA;EAs5MF;EAn5MA;IACE,iBAAA;IACA,iBAAA;IACA,aAAA;IACA,sBAAA;IACA,kCAAA;EAq5MF;EAl5ME;IACE,iBAAA;IACA,2BAAA;EAo5MJ;EA/4MA;IACE,iBAAA;IACA,sBAAA;EAi5MF;EA/4ME;IACE,sBAAA;EAi5MJ;EA94ME;IACE,WAAA;EAg5MJ;AACF;AA54MA;EACE,cAAA;EACA,YAAA;AA84MF;;AA34MA;EACE,YAAA;EACA,6BAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AA84MF;AA54ME;EACE,YAAA;AA84MJ;;AA14MA;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;AA64MF;;AA14MA;EACE,yBAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;AA64MF;;AA14MA;EACE,kBAAA;AA64MF;;AA14MA;EACE,uBAAA;EACA,aAAA;AA64MF;;AA14MA;EACE,gBAAA;AA64MF;;AA14MA;EACE;IACE,aAAA;EA64MF;AACF","sourcesContent":["@import \"src/styles\";\n\n\ntable {\n  width: 100%;\n  box-shadow: none;\n  background-color: transparent;\n  overflow: auto;\n}\n\n.component-segment {\n  // width: 100%;\n  padding: 2rem;\n}\n\n.btn-area {\n\n  width: 95%;\n  margin: auto;\n  bottom: 1rem;\n\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  .btn-primary {\n    background: map-get($primary-color, 500);\n    margin: 0rem 2rem;\n    color: azure;\n  }\n\n  .btn-area:last-child {\n    margin-right: 0rem;\n  }\n}\n\n@media(min-width: 800px) {\n  .entitie-filters {\n    width: 70% !important;\n\n  }\n\n  #paginator {\n    width: 50%;\n  }\n\n  .paginator-segment {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    p {\n      width: 50%;\n      font-size: 1.5rem;\n      font-weight: bold;\n    }\n  }\n}\n\n.btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(1) {\n  background: map-get($secondary-color, 500);\n  color: white;\n  width: 100% !important;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  margin-top: 50px;\n  border: none;\n  font-weight: bold;\n\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    margin-right: 0 !important;\n    width: 100% !important;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {\n  background: white;\n  color: map-get($primary-color, 500);\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: 2px solid map-get($primary-color, 500);\n  font-weight: bold;\n\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-back {\n  width: 100%;\n  background-color: transparent !important;\n  color: rgba(174, 15, 10, 1) !important;\n  border: 2px solid rgba(174, 15, 10, 1) !important;\n}\n\n.fields {\n  margin: 1rem auto;\n  min-height: 30vh;\n\n  @media(max-width: 900px) {\n    .fields {\n      flex: 1;\n    }\n  }\n\n}\n\n\n.entitie-filters {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    width: 100% !important;\n\n  }\n\n  transform: var(--mat-mdc-form-field-label-transform, translateY(0%) translateX(calc(1*(0px + var(--mat-mdc-form-field-label-offset-x, 0px)))));\n\n  .search-input {\n    border: 1px solid;\n    border-radius: 7px;\n    display: flex;\n    align-items: center;\n    box-shadow: 1px 1px 1px 1px #cdcdcd;\n    flex-grow: 3;\n  }\n}\n\ntr.example-detail-row {\n  height: 0;\n}\n\ntr.example-element-row:not(.example-expanded-row):hover {\n  background: whitesmoke;\n}\n\ntr.example-element-row:not(.example-expanded-row):active {\n  background: #efefef;\n}\n\n\n.header-expanded-table {\n  margin-top: 1rem;\n\n  .mat-mdc-form-field {\n    width: 100%;\n  }\n\n  button {\n    cursor: pointer;\n    padding: 1rem 2rem;\n    background-color: rgba(174, 15, 10, 1);\n    color: #fff;\n    border: none;\n    border-radius: .6rem;\n    width: 100%;\n    margin: 1rem 0rem !important;\n  }\n}\n\n.title {\n  font-size: 1.5rem;\n  display: flex;\n  padding: 1rem;\n  flex-direction: column;\n  font-weight: bold;\n\n  .description {\n    font-size: 1rem;\n    font-weight: normal;\n  }\n  @media(max-width: 1024px){\n    padding-left: 0;\n  }\n}\n\n@import \"src/styles\";\n\n\n\n.entities-list-container {\n  padding: 1rem;\n  background-color: white;\n\n  .entitie-filters {\n    // width: 90%;\n    display: flex;\n    flex-wrap: wrap;\n\n    @media (max-width: 767px) {\n      flex-direction: column;\n    }\n\n    transform: var(--mat-mdc-form-field-label-transform, translateY(0%) translateX(calc(1*(0px + var(--mat-mdc-form-field-label-offset-x, 0px)))));\n\n    .search-input {\n      border: 1px solid;\n      border-radius: 7px;\n      display: flex;\n      align-items: center;\n      box-shadow: 1px 1px 1px 1px #cdcdcd;\n      flex-grow: 3;\n    }\n  }\n\n  h6 {\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n  }\n\n\n\n  .filtros {\n    // width: 90%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n\n    .fast-filter {\n      // flex-grow: 1;\n      width: 30%;\n      align-items: center;\n      // margin-left: 1rem;\n      background: transparent;\n\n      .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {\n        background-color: white;\n        border: 1px solid map-get($medium-color, 500);\n      }\n\n      .filter-by-active-entitie.mat-mdc-chip-selected.mdc-evolution-chip--selected {\n        background-color: map-get($success-color, 700);\n      }\n\n      .filter-by-inactive-entitie.mat-mdc-chip-selected.mdc-evolution-chip--selected {\n        background-color: map-get($danger-color, 500);\n      }\n\n      .mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {\n        display: none;\n      }\n\n      span {\n        color: map-get($medium-color, 500);\n        font-weight: 400;\n        align-content: center;\n      }\n    }\n\n\n\n\n\n    .button-list {\n      box-shadow: 1px 1px 1px 1px #cdcdcd;\n      padding: .5rem 5rem;\n      display: flex;\n      align-items: center;\n      flex-direction: row-reverse;\n      margin-bottom: 6px;\n\n      .spacer {\n        flex: 1;\n      }\n\n      .mat-icon {\n        margin-left: 0.5rem;\n      }\n    }\n  }\n\n  .more-filters {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n\n    .mat-mdc-form-field {\n      margin: 0rem 2rem;\n      margin-bottom: -1rem;\n    }\n\n    .mat-picker {\n      margin-right: 0rem !important;\n    }\n  }\n\n  mat-form-field {\n    margin-bottom: 16px;\n  }\n\n  table {\n    width: 100%;\n  }\n\n  th {\n    font-weight: 700;\n  }\n\n\n\n  .entitie-list-table-wrapper {\n    overflow: auto !important;\n\n    th {\n      cursor: pointer;\n    }\n  }\n\n  .status-container {\n    display: flex;\n    align-items: center;\n\n    .mat-icon {\n      width: 1rem;\n    }\n\n    .status-icon {\n      font-size: 8px;\n      align-content: center;\n      text-align: center;\n    }\n\n    .active {\n      color: map-get($success-color, 700);\n    }\n\n    .inactive {\n      color: map-get($danger-color, 500);\n    }\n  }\n\n  .create-entitie-link {\n    display: flex;\n    margin-bottom: 1.5rem;\n\n    mat-icon {\n      height: 1rem;\n    }\n  }\n\n  .icon-entitie-actions-menu {\n    color: map-get($primary-color, 500);\n  }\n}\n\n::ng-deep .mat-calendar-body-selected {\n  background-color: red !important;\n}\n\n::ng-deep .mat-calendar-body-cell-content {\n  border-radius: 0rem !important;\n}\n\n::ng-deep .mat-calendar-body-selected.mat-calendar-body-today {\n  box-shadow: none;\n}\n\n@media(max-width:700px) {\n  .btn-area {\n    width: 90% !important;\n    flex-direction: column;\n\n    .btn-primary {\n      width: 100%;\n      margin: auto !important;\n      margin-bottom: 1rem !important\n    }\n\n\n  }\n\n  .filtros {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .fast-filter {\n    width: 100% !important;\n    margin: 1rem 0rem;\n  }\n\n  .more-filters {\n    width: 100%;\n    margin: 1rem auto;\n    flex-direction: column;\n    align-items: center;\n\n    .mat-mdc-form-field {\n      width: 100%;\n      margin: 0rem !important;\n      margin-bottom: 1rem;\n    }\n  }\n\n  .label {\n    font-size: 0.7rem;\n  }\n}\n\n::ng-deep .mat-mdc-form-field-label {\n  transform: none !important;\n}\n\n.mat-mdc-form-field-label {\n  transform: none !important;\n}\n\n#paginator {\n  width: 100%;\n}\n\n.paginator-segment {\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  p {\n    width: 100%;\n    font-size: 1.5rem;\n    font-weight: bold;\n  }\n}\n\n@media(min-width:1000px) {\n  .fast-filter {\n    width: 50% !important;\n    margin: 1rem 0rem;\n  }\n\n  .header-expanded-table {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n\n    .mat-mdc-form-field {\n      width: 70%;\n    }\n\n    button {\n      width: 40%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n}\n\n@media(min-width: 999px) {\n  #paginator {\n    width: 80%;\n  }\n\n  .paginator-segment {\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    p {\n      width: 20%;\n      font-size: 1.5rem;\n      font-weight: bold;\n    }\n  }\n}\n\n@import \"src/styles\";\n\n.field-width {\n  width: 70%;\n\n  @media (max-width: 767px) {\n    width: 90%;\n    margin-left: 15px;\n  }\n}\n\n.status-container {\n  display: flex;\n  align-items: center;\n\n  .mat-icon {\n    width: 1rem;\n  }\n\n  .status-icon {\n    font-size: 8px;\n    align-content: center;\n    text-align: center;\n  }\n\n  .active {\n    color: map-get($success-color, 700);\n  }\n\n  .inactive {\n    color: map-get($danger-color, 500);\n  }\n}\n\n.login-container {\n  display: flex;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n  }\n}\n\n\n\n.form-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  // height: 92vh;\n  width: 100%;\n}\n\n.bold-font {\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.login-form {\n  width: 100%;\n  // height: 100%;\n  margin-bottom: 10rem;\n  padding: 0 8rem;\n\n  @media (max-width: 767px) {\n    height: 92vh;\n  }\n\n  form {\n    height: inherit;\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 767px) {\n      height: 92vh;\n    }\n  }\n\n  .fields {\n\n    width: 100%;\n    flex: 1;\n    min-height: 55vh;\n\n    @media (max-width: 767px) {\n      width: 100%;\n      // min-height: 55%;\n    }\n  }\n\n  .subtitle {\n    border-bottom: 1px solid black;\n    margin: 1rem 0rem;\n\n    h6 {\n      margin: 0rem;\n    }\n  }\n\n  .line {\n    display: flex;\n    justify-content: center;\n\n    hr {\n      border: none;\n      height: 2px;\n      background-color: #bdbcbc;\n      width: 80%;\n      border-radius: 5px;\n\n      @media (max-width: 767px) {\n        width: 100%;\n      }\n    }\n  }\n\n  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n    background: map-get($secondary-color, 500);\n    color: white;\n    // width: 14rem;\n    border-radius: 10px;\n    padding: 0.75rem 0;\n    border: none;\n    font-weight: bold;\n    margin-top: 2.5rem;\n    align-self: center;\n    cursor: pointer;\n\n    @media (max-width: 767px) {\n      margin-top: 15px;\n      margin-right: 0 !important;\n      width: 100% !important;\n      height: 45px;\n    }\n\n    &[disabled] {\n      background: map-get($medium-color, 700);\n    }\n  }\n\n  .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {\n    background: white;\n    color: map-get($primary-color, 500);\n    // width: 14rem;\n    border-radius: 10px;\n    padding: 0.75rem 0;\n    border: 2px solid map-get($primary-color, 500);\n    font-weight: bold;\n    margin-top: 2.5rem;\n    align-self: center;\n    cursor: pointer;\n\n    @media (max-width: 767px) {\n      margin-top: 15px;\n      width: 100%;\n      height: 45px;\n    }\n\n    &[disabled] {\n      background: map-get($medium-color, 700);\n    }\n  }\n\n  .name-form-field {\n    text-align: center;\n    color: map-get($dark-color, 300);\n  }\n\n  .invalid {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 15px;\n\n    @media (max-width: 767px) {\n      margin-left: 5px;\n    }\n\n    .icon-error {\n      padding-left: 10px;\n      padding-right: 8px;\n    }\n  }\n\n  .login-field-prefix {\n    color: map-get($dark-color, 300);\n  }\n\n  .email-form-field {\n    text-align: center;\n    color: map-get($dark-color, 300);\n  }\n\n  .email-field-prefix {\n    color: map-get($dark-color, 300);\n  }\n\n  .email-field-prefix-invalid {\n    padding-top: 7px;\n    padding-bottom: 15px;\n    color: map-get($dark-color, 300);\n  }\n\n  h6 {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    mat-icon {\n      cursor: pointer;\n    }\n\n    @media (max-width: 767px) {\n      margin-top: 2rem;\n      margin-bottom: 2rem;\n      // margin-left: 15px;\n    }\n  }\n\n  .buttons {\n    padding-bottom: 1rem;\n    display: flex;\n    justify-content: flex-end;\n\n\n\n    button:first-of-type {\n      margin-right: 10px;\n    }\n  }\n\n  @media (max-width: 767px) {\n    margin-bottom: 1rem;\n    padding: 0 1rem;\n    width: 100%;\n  }\n\n  @media(max-width:1300px) {\n    form {\n      margin: 2rem;\n    }\n\n    .login-form {\n      padding: 20px;\n    }\n  }\n\n  @media (min-width: 768px) and (max-width: 1024px) {\n    margin-bottom: 3rem;\n    padding: 0 2rem;\n  }\n\n  @media (min-width: 1025px) and (max-width: 1366px) {\n    margin-bottom: 4rem;\n    padding: 0 4rem;\n  }\n\n  @media (min-width: 1367px) {\n    margin-bottom: 5rem;\n    padding: 0 4rem;\n  }\n}\n\n.first-input {\n  width: 100%;\n}\n\n@media (max-width: 1000px) {\n  .buttons {\n    display: flex;\n    flex-direction: column;\n\n    button {\n      width: 100% !important;\n      margin: .5rem auto;\n      padding: 1.5rem 1rem\n    }\n  }\n}\n\n.mat-expansion-panel-header-title {\n  font-size: 1rem;\n}\n\n\n.panel-with-border .mat-expansion-panel-header {\n  border-bottom: 1px solid black;\n  /* Estilo da borda quando o painel está aberto */\n}\n\n.panel-with-border .mat-expansion-panel-header.mat-expanded {\n  border-bottom: none;\n  /* Remove a borda inferior quando o painel está aberto */\n}\n\n.panel-with-border.mat-expansion-panel {\n  border-bottom: 1px solid black;\n  /* Estilo da borda do painel quando fechado */\n}\n\n.mat-expansion-panel {\n  box-shadow: none !important;\n  background-color: transparent;\n  // border-bottom: 1px solid;\n  border-radius: 0;\n}\n\n.mat-mdc-select-arrow-wrapper {\n  display: none !important;\n}\n\n/* Estilizar o novo ícone */\n.custom-select-icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  font-size: 24px;\n  /* Ajuste o tamanho do ícone conforme necessário */\n}\n\n.form-group {\n  width: 100%;\n  display: flex;\n  // align-items: center;\n  justify-content: space-between;\n\n  .mat-mdc-form-field {\n    width: 45%;\n  }\n\n  .first-input {\n    width: 100%;\n  }\n\n  .date-input {\n    width: 20%;\n  }\n\n  .bank-form-field {\n    width: 70%;\n  }\n\n  p {\n    margin-top: 0px;\n    font-size: 1.1rem;\n  }\n}\n\n.form-group-row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .mat-mdc-form-field {\n    width: 30%;\n  }\n\n  .first-input {\n    width: 100%;\n  }\n\n  .bank-form-field {\n    width: 70%;\n  }\n\n  p {\n    margin-top: 0px;\n    font-size: 1.1rem;\n  }\n}\n\n.form-group-row2 {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .mat-mdc-form-field {\n    width: 20%;\n  }\n\n  .first-input {\n    width: 100%;\n  }\n\n  .bank-form-field {\n    width: 70%;\n  }\n\n  p {\n    margin-top: 0px;\n    font-size: 1.1rem;\n  }\n}\n\n.date-select {\n  width: 30%;\n  display: flex;\n\n\n  .mat-mdc-form-field {\n    // margin-bottom: -1.5rem;\n    width: 70%;\n  }\n\n  .select-year {\n    // margin-bottom: -1.5rem;\n    width: 30%;\n  }\n}\n\n.btn-primary {\n  margin: 0rem 1rem;\n}\n\n.btn-exclude {\n  border: 2px solid rgba(112, 111, 111, 1) !important;\n  background-color: transparent !important;\n  color: rgba(112, 111, 111, 1) !important;\n  font-weight: bold !important;\n}\n\n.btn-submit {\n  background-color: rgba(174, 15, 10, 1) !important;\n  color: #fff !important;\n  border: 2px solid rgba(174, 15, 10, 1) !important;\n}\n\n.disabled-button {\n  background-color: rgba(112, 111, 111, 1) !important;\n  color: white;\n  border: 2px solid rgba(112, 111, 111, 1) !important;\n  cursor: not-allowed;\n\n}\n\n.btn-back {\n  background-color: transparent !important;\n  color: rgba(174, 15, 10, 1) !important;\n  border: 2px solid rgba(174, 15, 10, 1) !important;\n}\n\n.header-form {\n\n  display: flex;\n  flex-direction: column;\n\n  .header-title {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    h6 {\n      margin-bottom: 0px;\n    }\n\n    .btn-header {\n      display: flex;\n      align-items: center;\n    }\n  }\n}\n\n.status-cadastrando {\n  background-color: rgb(219, 151, 5);\n  color: #fff;\n  padding: .2rem 2rem;\n  border-radius: .3rem;\n}\n\n.status-aprovado {\n  background-color: green;\n  color: #fff;\n  padding: .2rem 2rem;\n  border-radius: .3rem;\n}\n\n.status-rejeitado {\n  background-color: red;\n  color: #fff;\n  padding: .2rem 2rem;\n  border-radius: .3rem;\n}\n\n.status-desconhecido {\n  background-color: gray;\n  color: #fff;\n  padding: .2rem 2rem;\n  border-radius: .3rem;\n}\n\n.mat-mdc-expansion-panel-body {\n  padding: 0px !important;\n}\n\n.data-eficacia-form-group {\n  display: flex;\n  align-items: center;\n  width: 30%;\n\n  .mat-mdc-form-field {\n    width: 90%;\n  }\n}\n\n.form-section-field {\n  margin: 2rem auto;\n}\n\n.header-legend {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  .first-filter {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .mat-mdc-form-field {\n      width: 90%;\n    }\n\n    .btn {\n      padding: 1rem 2rem;\n      background-color: rgba(227, 6, 19, 1);\n      color: #fff;\n      border-radius: .5rem;\n      cursor: pointer;\n      border: none;\n\n      &:hover {\n        background-color: rgba(174, 15, 10, 1);\n      }\n    }\n  }\n}\n\n.header-form {\n  width: 100%;\n  display: flex;\n  // align-items: center;\n\n  h6 {\n    width: 80%;\n  }\n}\n\n.bredCrumb {\n  margin: 1rem 0rem;\n  // display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.bredCrumb p {\n  display: inline;\n  cursor: pointer;\n}\n\n.bredCrumb p.selected {\n  font-weight: bold;\n}\n\n.anexos {\n  display: flex;\n  align-items: center;\n}\n\n@media(max-width:1000px) {\n\n  .form-group-row,\n  .form-group {\n    flex-direction: column;\n\n    .mat-mdc-form-field {\n      width: 100%;\n    }\n  }\n\n  .data-eficacia-form-group {\n    width: 100%;\n  }\n\n  .date-select {\n    width: 100%;\n  }\n\n  .fields {\n    flex: 1;\n    min-height: auto !important;\n  }\n\n  .first-filter {\n    flex-direction: column;\n    width: 100%;\n\n    .mat-mdc-form-field {\n      width: 100%;\n    }\n\n    .btn {\n      margin: 1rem 0rem;\n      width: 90%;\n    }\n  }\n\n  .filters {\n    display: flex;\n    flex-direction: column;\n\n    .mat-mdc-form-field {\n      width: 100%;\n    }\n  }\n\n  .login-form {\n    width: 90% !important;\n    margin: auto;\n  }\n\n\n\n\n}\n\n@media(max-width:600px) {\n  .bredCrumb {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n}\n\n\n\ntable {\n  width: 100%;\n}\n\nth {\n  font-weight: 700;\n}\n\n.entitie-list-table-wrapper {\n  overflow: auto;\n\n  th {\n    cursor: pointer;\n  }\n}\n\n.document-container {\n  margin: 1rem auto;\n  border-radius: 1rem 1rem 0rem 0rem;\n\n  padding: 1rem;\n\n  .title-document {\n    font-size: 1.2rem;\n    font-weight: 700;\n  }\n\n  .header-document {\n    margin: 1rem auto;\n    margin: 1rem auto;\n    display: flex;\n    align-items: center;\n\n\n    // span {\n    //     margin-left: 1rem;\n    // }\n\n    // .button-add {\n    //     font-weight: bold;\n    //     display: flex;\n    //     align-items: center;\n    //     justify-content: center;\n    //     cursor: pointer;\n    //     padding: .5rem 2rem;\n    //     background-color: rgba(174, 15, 10, 1);\n    //     color: #fff;\n    //     border: none;\n    //     border-radius: .6rem;\n    // }\n  }\n}\n\n@media(max-width:999px) {\n\n  .bredCrumb {\n    align-items: flex-start;\n  }\n\n  .header-document {\n    margin: 1rem auto;\n    margin: 1rem auto;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start !important;\n\n\n    span {\n      margin: 1rem 0rem;\n      margin-left: 0px !important;\n    }\n\n  }\n\n  .row {\n    margin: 1rem auto;\n    flex-direction: column;\n\n    .mat-mdc-form-field {\n      width: 100% !important;\n    }\n\n    button {\n      width: 100%;\n    }\n  }\n}\n\n:host {\n  display: block;\n  height: 100%;\n}\n\n.component-segment {\n  height: 100%;\n  max-height: calc(90vh - 2rem);\n  padding: 1.5rem;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n\n  h6 {\n    margin: 1rem;\n  }\n}\n\n.fields {\n  margin: 1rem auto;\n  min-height: auto;\n  width: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.entitie-list-table-wrapper {\n  overflow: auto !important;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.paginator-segment {\n  margin-top: 0.5rem;\n}\n\n.buttons {\n  justify-content: center;\n  display: flex;\n}\n\n.btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(1) {\n  margin-top: 1rem;\n}\n\n@media(max-width:1024px) {\n  .component-segment {\n    padding: 1rem;\n  }\n}\n","@use '@angular/cdk';\n\n@mixin ripple() {\n  // The host element of an mat-ripple directive should always have a position of \"absolute\" or\n  // \"relative\" so that the ripples inside are correctly positioned relatively to the container.\n  .mat-ripple {\n    overflow: hidden;\n\n    // By default, every ripple container should have position: relative in favor of creating an\n    // easy API for developers using the MatRipple directive.\n    position: relative;\n\n    // Promote containers that have ripples to a new layer. We want to target `:not(:empty)`,\n    // because we don't want all ripple containers to have their own layer since they're used in a\n    // lot of places and the layer is only relevant while animating. Note that ideally we'd use\n    // the `contain` property here (see #13175), because `:empty` can be broken by having extra\n    // text inside the element, but it isn't very well supported yet.\n    &:not(:empty) {\n      transform: translateZ(0);\n    }\n  }\n\n  .mat-ripple.mat-ripple-unbounded {\n    overflow: visible;\n  }\n\n  .mat-ripple-element {\n    position: absolute;\n    border-radius: 50%;\n    pointer-events: none;\n\n    transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);\n\n    // We use a 3d transform here in order to avoid an issue in Safari where\n    // the ripples aren't clipped when inside the shadow DOM (see #24028).\n    transform: scale3d(0, 0, 0);\n\n    // In high contrast mode the ripple is opaque, causing it to obstruct the content.\n    @include cdk.high-contrast(active, off) {\n      display: none;\n    }\n  }\n}\n","/// Emits a CSS class, `.cdk-visually-hidden`. This class can be applied to an element\n/// to make that element visually hidden while remaining available to assistive technology.\n@mixin a11y-visually-hidden() {\n  .cdk-visually-hidden {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n\n    // This works around a Chrome bug that can cause the tab to crash when large amounts of\n    // non-English text get wrapped: https://bugs.chromium.org/p/chromium/issues/detail?id=1201444\n    white-space: nowrap;\n\n    // Avoid browsers rendering the focus ring in some cases.\n    outline: 0;\n\n    // Avoid some cases where the browser will still render the native controls (see #9049).\n    -webkit-appearance: none;\n    -moz-appearance: none;\n\n    // We need at least one of top/bottom/left/right in order to prevent cases where the\n    // absolute-positioned element is pushed down and can affect scrolling (see #24597).\n    // `left` was chosen here, because it's the least likely to break overrides where the\n    // element might have been positioned (e.g. `mat-checkbox`).\n    left: 0;\n\n    [dir='rtl'] & {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n\n/// @deprecated Use `a11y-visually-hidden`.\n@mixin a11y() {\n  @include a11y-visually-hidden;\n}\n\n/// Emits the mixin's content nested under `$selector-context` if `$selector-context`\n/// is non-empty.\n/// @param {String} selector-context The selector under which to nest the mixin's content.\n@mixin _optionally-nest-content($selector-context) {\n  @if ($selector-context == '') {\n    @content;\n  }\n  @else {\n    #{$selector-context} {\n      @content;\n    }\n  }\n}\n\n/// Applies styles for users in high contrast mode. Note that this only applies\n/// to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n/// attribute, however Chrome handles high contrast differently.\n///\n/// @param {String} target Type of high contrast setting to target. Defaults to `active`, can be\n///     `white-on-black` or `black-on-white`.\n/// @param {String} encapsulation Whether to emit styles for view encapsulation. Values are:\n///     * `on` - works for `Emulated`, `Native`, and `ShadowDom`\n///     * `off` - works for `None`\n///     * `any` - works for all encapsulation modes by emitting the CSS twice (default).\n@mixin high-contrast($target: active, $encapsulation: 'any') {\n  @if ($target != 'active' and $target != 'black-on-white' and $target != 'white-on-black') {\n    @error 'Unknown cdk-high-contrast value \"#{$target}\" provided. ' +\n           'Allowed values are \"active\", \"black-on-white\", and \"white-on-black\"';\n  }\n\n  @if ($encapsulation != 'on' and $encapsulation != 'off' and $encapsulation != 'any') {\n    @error 'Unknown cdk-high-contrast encapsulation \"#{$encapsulation}\" provided. ' +\n           'Allowed values are \"on\", \"off\", and \"any\"';\n  }\n\n  // If the selector context has multiple parts, such as `.section, .region`, just doing\n  // `.cdk-high-contrast-xxx #{&}` will only apply the parent selector to the first part of the\n  // context. We address this by nesting the selector context under .cdk-high-contrast.\n  @at-root {\n    $selector-context: #{&};\n\n    @if ($encapsulation != 'on') {\n      // Note that if this selector is updated, the same change has to be made inside\n      // `_overlay.scss` which can't depend on this mixin due to some infrastructure limitations.\n      .cdk-high-contrast-#{$target} {\n        @include _optionally-nest-content($selector-context) {\n          @content;\n        }\n      }\n    }\n\n    @if ($encapsulation != 'off') {\n      .cdk-high-contrast-#{$target} :host {\n        @include _optionally-nest-content($selector-context) {\n          @content;\n        }\n      }\n    }\n  }\n}\n","// We want overlays to always appear over user content, so set a baseline\n// very high z-index for the overlay container, which is where we create the new\n// stacking context for all overlays.\n$overlay-container-z-index: 1000 !default;\n$overlay-z-index: 1000 !default;\n$overlay-backdrop-z-index: 1000 !default;\n\n// Background color for all of the backdrops\n$overlay-backdrop-color: rgba(0, 0, 0, 0.32) !default;\n\n// Default backdrop animation is based on the Material Design swift-ease-out.\n$backdrop-animation-duration: 400ms !default;\n$backdrop-animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1) !default;\n\n/// Emits structural styles required for cdk/overlay to function.\n@mixin overlay() {\n  .cdk-overlay-container, .cdk-global-overlay-wrapper {\n    // Disable events from being captured on the overlay container.\n    pointer-events: none;\n\n    // The container should be the size of the viewport.\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n  }\n\n  // The overlay-container is an invisible element which contains all individual overlays.\n  .cdk-overlay-container {\n    position: fixed;\n    z-index: $overlay-container-z-index;\n\n    &:empty {\n      // Hide the element when it doesn't have any child nodes. This doesn't\n      // include overlays that have been detached, rather than disposed.\n      display: none;\n    }\n  }\n\n  // We use an extra wrapper element in order to use make the overlay itself a flex item.\n  // This makes centering the overlay easy without running into the subpixel rendering\n  // problems tied to using `transform` and without interfering with the other position\n  // strategies.\n  .cdk-global-overlay-wrapper {\n    display: flex;\n    position: absolute;\n    z-index: $overlay-z-index;\n  }\n\n  // A single overlay pane.\n  .cdk-overlay-pane {\n    // Note: it's important for this one to start off `absolute`,\n    // in order for us to be able to measure it correctly.\n    position: absolute;\n    pointer-events: auto;\n    box-sizing: border-box;\n    z-index: $overlay-z-index;\n\n    // For connected-position overlays, we set `display: flex` in\n    // order to force `max-width` and `max-height` to take effect.\n    display: flex;\n    max-width: 100%;\n    max-height: 100%;\n  }\n\n  .cdk-overlay-backdrop {\n    // TODO(jelbourn): reuse sidenav fullscreen mixin.\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n\n    z-index: $overlay-backdrop-z-index;\n    pointer-events: auto;\n    -webkit-tap-highlight-color: transparent;\n    transition: opacity $backdrop-animation-duration $backdrop-animation-timing-function;\n    opacity: 0;\n\n    &.cdk-overlay-backdrop-showing {\n      opacity: 1;\n\n      // Note that we can't import and use the `high-contrast` mixin from `_a11y.scss`, because\n      // this file will be copied to the top-level `cdk` package when putting together the files\n      // for npm. Any relative import paths we use here will become invalid once the file is copied.\n      .cdk-high-contrast-active & {\n        // In high contrast mode the rgba background will become solid\n        // so we need to fall back to making it opaque using `opacity`.\n        opacity: 0.6;\n      }\n    }\n  }\n\n  .cdk-overlay-dark-backdrop {\n    background: $overlay-backdrop-color;\n  }\n\n  .cdk-overlay-transparent-backdrop {\n    // Define a transition on the visibility so that the `transitionend` event can fire immediately.\n    transition: visibility 1ms linear, opacity 1ms linear;\n    visibility: hidden;\n    opacity: 1;\n\n    // Note: as of Firefox 57, having the backdrop be `background: none` will prevent it from\n    // capturing the user's mouse scroll events. Since we also can't use something like\n    // `rgba(0, 0, 0, 0)`, we work around the inconsistency by not setting the background at\n    // all and using `opacity` to make the element transparent.\n    &.cdk-overlay-backdrop-showing {\n      opacity: 0;\n      visibility: visible;\n    }\n  }\n\n  .cdk-overlay-backdrop-noop-animation {\n    transition: none;\n  }\n\n  // Overlay parent element used with the connected position strategy. Used to constrain the\n  // overlay element's size to fit within the viewport.\n  .cdk-overlay-connected-position-bounding-box {\n    position: absolute;\n    z-index: $overlay-z-index;\n\n    // We use `display: flex` on this element exclusively for centering connected overlays.\n    // When *not* centering, a top/left/bottom/right will be set which overrides the normal\n    // flex layout.\n    display: flex;\n\n    // We use the `column` direction here to avoid some flexbox issues in Edge\n    // when using the \"grow after open\" options.\n    flex-direction: column;\n\n    // Add some dimensions so the element has an `innerText` which some people depend on in tests.\n    min-width: 1px;\n    min-height: 1px;\n  }\n\n  // Used when disabling global scrolling.\n  .cdk-global-scrollblock {\n    position: fixed;\n\n    // Necessary for the content not to lose its width. Note that we're using 100%, instead of\n    // 100vw, because 100vw includes the width plus the scrollbar, whereas 100% is the width\n    // that the element had before we made it `fixed`.\n    width: 100%;\n\n    // Note: this will always add a scrollbar to whatever element it is on, which can\n    // potentially result in double scrollbars. It shouldn't be an issue, because we won't\n    // block scrolling on a page that doesn't have a scrollbar in the first place.\n    overflow-y: scroll;\n  }\n}\n","// Structural styles for the autosize text fields.\n@mixin text-field-autosize() {\n  // Remove the resize handle on autosizing textareas, because whatever height\n  // the user resized to will be overwritten once they start typing again.\n  textarea.cdk-textarea-autosize {\n    resize: none;\n  }\n\n  // This class is temporarily applied to the textarea when it is being measured. It is immediately\n  // removed when measuring is complete. We use `!important` rules here to make sure user-specified\n  // rules do not interfere with the measurement.\n  textarea.cdk-textarea-autosize-measuring {\n    @include _autosize-measuring-base;\n    height: auto !important;\n    overflow: hidden !important;\n  }\n\n  // Similar to the `cdk-textarea-autosize-measuring` class, but only applied on Firefox. We need\n  // to use this class, because Firefox has a bug where changing the `overflow` breaks the user's\n  // ability to undo/redo what they were typing (see #16629). This class is only scoped to Firefox,\n  // because the measurements there don't seem to be affected by the `height: 0`, whereas on other\n  // browsers they are, e.g. Chrome detects longer text and IE does't resize back to normal.\n  // Identical issue report: https://bugzilla.mozilla.org/show_bug.cgi?id=448784\n  textarea.cdk-textarea-autosize-measuring-firefox {\n    @include _autosize-measuring-base;\n    height: 0 !important;\n  }\n}\n\n// Core styles that enable monitoring autofill state of text fields.\n@mixin text-field-autofill() {\n  // Keyframes that apply no styles, but allow us to monitor when an text field becomes autofilled\n  // by watching for the animation events that are fired when they start. Note: the /*!*/ comment is\n  // needed to prevent LibSass from stripping the keyframes out.\n  // Based on: https://medium.com/@brunn/detecting-autofilled-fields-in-javascript-aed598d25da7\n  @keyframes cdk-text-field-autofill-start {/*!*/}\n  @keyframes cdk-text-field-autofill-end {/*!*/}\n\n  .cdk-text-field-autofill-monitored:-webkit-autofill {\n    // Since Chrome 80 we need a 1ms delay, or the animationstart event won't fire.\n    animation: cdk-text-field-autofill-start 0s 1ms;\n  }\n\n  .cdk-text-field-autofill-monitored:not(:-webkit-autofill) {\n    // Since Chrome 80 we need a 1ms delay, or the animationstart event won't fire.\n    animation: cdk-text-field-autofill-end 0s 1ms;\n  }\n}\n\n@mixin _autosize-measuring-base {\n  // Having 2px top and bottom padding seems to fix a bug where Chrome gets an incorrect\n  // measurement. We just have to account for it later and subtract it off the final result.\n  padding: 2px 0 !important;\n  box-sizing: content-box !important;\n}\n\n// Used to generate UIDs for keyframes used to change the text field autofill styles.\n$autofill-color-frame-count: 0;\n\n// Mixin used to apply custom background and foreground colors to an autofilled text field.\n// Based on: https://stackoverflow.com/questions/2781549/\n// removing-input-background-colour-for-chrome-autocomplete#answer-37432260\n@mixin text-field-autofill-color($background, $foreground:'') {\n  @keyframes cdk-text-field-autofill-color-#{$autofill-color-frame-count} {\n    to {\n      background: $background;\n      @if $foreground != '' { color: $foreground; }\n    }\n  }\n\n  &:-webkit-autofill {\n    animation: cdk-text-field-autofill-color-#{$autofill-color-frame-count} both;\n  }\n\n  &.cdk-text-field-autofill-monitored:-webkit-autofill {\n    // Since Chrome 80 we need a 1ms delay for cdk-text-field-autofill-start, or the animationstart\n    // event won't fire.\n    animation: cdk-text-field-autofill-start 0s 1ms,\n               cdk-text-field-autofill-color-#{$autofill-color-frame-count} both;\n  }\n\n  $autofill-color-frame-count: $autofill-color-frame-count + 1 !global;\n}\n\n// @deprecated Use `autosize` and `autofill` instead.\n@mixin text-field {\n  @include text-field-autosize();\n  @include text-field-autofill();\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use '@angular/cdk';\n@use '../style/layout-common';\n@use '../theming/theming';\n\n// Private sass variables that will be used as reference throughout component stylesheets.\n$default-border-width: 3px;\n$default-border-style: solid;\n$default-border-color: transparent;\n$default-border-radius: 4px;\n\n// Mixin that renders the focus indicator structural styles.\n@mixin structural-styling($prefix) {\n  .#{$prefix}-focus-indicator {\n    position: relative;\n\n    &::before {\n      @include layout-common.fill();\n      box-sizing: border-box;\n      pointer-events: none;\n      display: var(--#{$prefix}-focus-indicator-display, none); // Hide the indicator by default.\n      border: var(\n          --#{$prefix}-focus-indicator-border-width,\n          #{$default-border-width}\n        )\n        var(\n          --#{$prefix}-focus-indicator-border-style,\n          #{$default-border-style}\n        )\n        var(\n          --#{$prefix}-focus-indicator-border-color,\n          #{$default-border-color}\n        );\n      border-radius: var(\n        --#{$prefix}-focus-indicator-border-radius,\n        #{$default-border-radius}\n      );\n    }\n\n    // By default, render the focus indicator when the focus indicator host element takes focus.\n    // Defining a pseudo element's content will cause it to render.\n    &:focus::before {\n      content: '';\n    }\n  }\n\n  // Enable the indicator in high contrast mode.\n  @include cdk.high-contrast(active, off) {\n    @include customize-focus-indicators((display: block), $prefix);\n  }\n}\n\n// Generates CSS variable declarations from a map.\n@mixin _output-variables($map) {\n  @each $key, $value in $map {\n    @if ($value) {\n      --#{$key}: #{$value};\n    }\n  }\n}\n\n// Mixin that dedups CSS variables for the strong-focus-indicators mixin.\n@mixin customize-focus-indicators($config, $prefix) {\n  $border-style: map.get($config, border-style);\n  $border-width: map.get($config, border-width);\n  $border-radius: map.get($config, border-radius);\n  $border-color: map.get($config, border-color);\n  $display: map.get($config, display);\n  $map: (\n    '#{$prefix}-focus-indicator-border-style': $border-style,\n    '#{$prefix}-focus-indicator-border-width': $border-width,\n    '#{$prefix}-focus-indicator-border-radius': $border-radius,\n    '#{$prefix}-focus-indicator-border-color': $border-color,\n    '#{$prefix}-focus-indicator-display': $display,\n  );\n\n  @if (&) {\n    @include _output-variables($map);\n  }\n  @else {\n    // We use `html` here instead of `:root`, because the\n    // latter causes some issues with internal tooling.\n    html {\n      @include _output-variables($map);\n    }\n  }\n}\n\n@mixin strong-focus-indicators($config: ()) {\n  // Default focus indicator config.\n  $default-config: (\n      border-color: black,\n      display: block,\n  );\n\n  // Merge default config with user config.\n  $config: map.merge($default-config, $config);\n\n  @include customize-focus-indicators($config, 'mat');\n}\n\n@mixin mdc-strong-focus-indicators($config: ()) {\n  // Default focus indicator config.\n  $default-config: (\n      border-color: black,\n      display: block,\n  );\n\n  // Merge default config with user config.\n  $config: map.merge($default-config, $config);\n\n  @include customize-focus-indicators($config, 'mat-mdc');\n}\n\n@mixin strong-focus-indicators-color($config-or-theme-or-color) {\n  @if meta.type-of($config-or-theme-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $config-or-theme-or-color\n    ), 'mat');\n  }\n  @else {\n    $config: theming.get-color-config($config-or-theme-or-color);\n    $border-color: theming.get-color-from-palette(map.get($config, primary));\n    @include customize-focus-indicators((\n        border-color: $border-color\n    ), 'mat');\n  }\n}\n\n@mixin strong-focus-indicators-theme($theme-or-color-config-or-color) {\n  @if meta.type-of($theme-or-color-config-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $theme-or-color-config-or-color\n    ), 'mat');\n  }\n  @else {\n    $theme: theming.private-legacy-get-theme($theme-or-color-config-or-color);\n    @include theming.private-check-duplicate-theme-styles($theme, 'mat-focus-indicators') {\n      $color: theming.get-color-config($theme);\n      @if $color != null {\n        @include strong-focus-indicators-color($color);\n      }\n    }\n  }\n}\n\n@mixin mdc-strong-focus-indicators-color($config-or-theme-or-color) {\n  @if meta.type-of($config-or-theme-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $config-or-theme-or-color\n    ), 'mat-mdc');\n  }\n  @else {\n    $config: theming.get-color-config($config-or-theme-or-color);\n    $border-color: theming.get-color-from-palette(map.get($config, primary));\n    @include customize-focus-indicators((\n        border-color: $border-color\n    ), 'mat-mdc');\n  }\n}\n\n@mixin mdc-strong-focus-indicators-theme($theme-or-color-config-or-color) {\n  @if meta.type-of($theme-or-color-config-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $theme-or-color-config-or-color\n    ), 'mat-mdc');\n  }\n  @else {\n    $theme: theming.private-legacy-get-theme($theme-or-color-config-or-color);\n    @include theming.private-check-duplicate-theme-styles($theme, 'mat-mdc-focus-indicators') {\n      $color: theming.get-color-config($theme);\n      @if $color != null {\n        @include mdc-strong-focus-indicators-color($color);\n      }\n    }\n  }\n}\n","// This mixin ensures an element spans to fill the nearest ancestor with defined positioning.\n@mixin fill {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n}\n","/* \n\tColors values \n\t300 = tint\n\t500 = default\n\t700 = shade\n*/\n$primary-color: (\n  500: rgba(174, 15, 10, 1),\n  300: rgba(227, 6, 19, 1),\n  700: rgba(228, 173, 181, 1),\n  contrast: (500: white,\n    300: white,\n    700: black,\n  ),\n);\n$secondary-color: (\n  500: rgba(0, 87, 158, 1),\n  300: rgba(51, 125, 192, 1),\n  700: rgba(0, 59, 109, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$warning-color: (\n  500: rgba(255, 196, 9, 1),\n  300: rgba(255, 202, 34, 1),\n  700: rgba(224, 172, 8, 1),\n  contrast: (500: black,\n    300: black,\n    700: black,\n  ),\n);\n\n$danger-color: (\n  500: rgba(235, 68, 90, 1),\n  300: rgba(237, 87, 107, 1),\n  700: rgba(207, 60, 79, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$success-color: (\n  500: rgba(45, 211, 111, 1),\n  300: rgba(66, 215, 125, 1),\n  700: rgba(40, 186, 98, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$dark-color: (\n  500: rgba(34, 36, 40, 1),\n  300: rgba(60, 60, 59, 1),\n  700: rgba(87, 87, 86, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$medium-color: (\n  500: rgba(112, 111, 111, 1),\n  300: rgba(135, 135, 135, 1),\n  700: rgba(189, 188, 188, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$light-color: (\n  500: rgba(227, 227, 227, 1),\n  300: rgba(245, 246, 249, 1),\n  700: rgba(189, 188, 188, 1),\n  contrast: (500: black,\n    300: black,\n    700: black,\n  ),\n);","@import \"variables\";\n\nbody {\n  font-family: \"Barlow\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 600;\n}\n\nh1 {\n  font-size: 64px;\n  line-height: 78px;\n}\n\nh2 {\n  font-size: 56px;\n  line-height: 68px;\n}\n\nh3 {\n  font-size: 48px;\n  line-height: 58px;\n}\n\nh4 {\n  font-size: 40px;\n  line-height: 48px;\n}\n\nh5 {\n  font-size: 32px;\n  line-height: 39px;\n}\n\nh6 {\n  font-size: 24px;\n  line-height: 29px;\n}\n\na {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n  color: map-get($primary-color, 500);\n  cursor: pointer;\n  text-decoration: underline;\n}\n\ncaption {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n}\n\nth {\n  font-weight: 700;\n  cursor: pointer;\n}\n","$spacing-sizes: (\n  0: 0px,\n  1: 8px,\n  2: 16px,\n  3: 24px,\n  4: 32px,\n  5: 40px,\n  6: 48px,\n  7: 56px,\n  8: 64px,\n  9: 72px,\n  10: 80px,\n);\n\n@each $key, $size in $spacing-sizes {\n  .p-#{$key} {\n    padding: #{$size};\n  }\n  .pt-#{$key} {\n    padding-top: #{$size};\n  }\n  .pr-#{$key} {\n    padding-right: #{$size};\n  }\n  .pb-#{$key} {\n    padding-bottom: #{$size};\n  }\n  .pl-#{$key} {\n    padding-left: #{$size};\n  }\n  .px-#{$key} {\n    padding-left: #{$size};\n    padding-right: #{$size};\n  }\n  .py-#{$key} {\n    padding-top: #{$size};\n    padding-bottom: #{$size};\n  }\n\n  .m-#{$key} {\n    margin: #{$size};\n  }\n  .mt-#{$key} {\n    margin-top: #{$size};\n  }\n  .mr-#{$key} {\n    margin-right: #{$size};\n  }\n  .mb-#{$key} {\n    margin-bottom: #{$size};\n  }\n  .ml-#{$key} {\n    margin-left: #{$size};\n  }\n  .mx-#{$key} {\n    margin-left: #{$size};\n    margin-right: #{$size};\n  }\n  .my-#{$key} {\n    margin-top: #{$size};\n    margin-bottom: #{$size};\n  }\n}\n","@use \"@angular/material\" as mat;\n@include mat.core();\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\n@import \"theme/typography.scss\";\n@import \"theme/variables.scss\";\n@import \"theme/spacing\";\n@import url(\"https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap\");\nhtml {\n  --mdc-outlined-text-field-focus-outline-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n  --mdc-outlined-text-field-focus-label-text-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-option-selected-state-label-text-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-datepicker-toggle-active-state-icon-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n\n  --mdc-filled-text-field-focus-active-indicator-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-sidenav-content-background-color: white !important;\n}\n\n/* You can add global styles to this file, and also import other style files */\n/* Angular 15 adds grey background on mat form components */\n/* below removes that background color */\n/* Manipulate initial background color*/\n.mdc-text-field--filled:not(.mdc-text-field--disabled) {\n  background-color: transparent !important;\n}\n\n/*Manipulate background color on hover and focus*/\n.mat-mdc-form-field-focus-overlay {\n  background-color: transparent !important;\n}\n\n.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {\n  width: 0px;\n  padding-left: 6px;\n  padding-right: 6px;\n\n  span {\n    display: none;\n  }\n}\n\n/* Pagination menu */\n.g-bubble-container {\n  display: flex;\n  gap: 4px;\n  margin-left: 8px;\n}\n\n.g-bubble {\n  background-color: map-get($light-color, 300);\n  border-radius: 4px;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: map-get($dark-color, 500) !important;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: 0.3s;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0.5px;\n  text-align: center;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);\n}\n\n.g-bubble:hover {\n  background-color: map-get($light-color, 700);\n  color: map-get($light-color, 300);\n}\n\n.g-bubble__active {\n  background-color: map-get($primary-color, 300);\n  color: map-get($light-color, 500) !important;\n  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12),\n    0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);\n}\n\nmat-paginator {\n  background: transparent !important;\n}\n\n.mat-mdc-paginator-range-actions {\n  margin-right: 12px !important;\n}\n\n.mat-mdc-paginator-container {\n  justify-content: center !important;\n}\n\n.mat-mdc-paginator-navigation-next,\n.mat-mdc-paginator-navigation-previous {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: map-get($dark-color, 500) !important;\n  padding: 0 !important;\n  border-radius: 4px !important;\n  width: 34px !important;\n  height: 34px !important;\n  background-color: map-get($light-color, 300) !important;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);\n}\n\n/* End of pagination menu */\n\nbody {\n  margin: 0;\n}\n\n.snackbar {\n  width: 50vw;\n  margin: 10px 0px !important;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snackbar-custom {\n  width: 50vw;\n  margin-top: 75px !important;\n}\n\n.snacbar-warning {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid #e0ac08;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snacbar-sucess {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid green;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snacbar-error {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid red;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.flex {\n  display: flex;\n}\n\n.mat-mdc-menu-panel {\n  overflow: hidden !important;\n\n  .mat-mdc-menu-content {\n    .menu-header {\n      font-size: 12px;\n      padding: 1rem;\n      padding-bottom: 0.25rem;\n    }\n\n    .mat-mdc-menu-item {\n      margin-left: 1rem;\n      padding-left: 0;\n    }\n\n    .mat-mdc-menu-item:first-of-type {\n      margin-top: 0.75rem;\n    }\n\n    .mat-mdc-menu-item:not(:last-child) {\n      border-bottom: 1px solid map-get($light-color, 700);\n    }\n  }\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 3000;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sort-icon-container {\n  display: inline-flex;\n  align-items: center;\n\n  mat-icon {\n    height: 1rem;\n    width: 1rem;\n  }\n}\napp-edit-contract{\n  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n    @media (max-width: 767px) {\n      margin-top: 15px;\n      margin-right: 0 !important;\n      width: 40% !important;\n      height: 45px;\n    }\n  }\n}\n.btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($primary-color, 500);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: none;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    margin-right: 0 !important;\n    width: 40%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {\n  background: white;\n  color: map-get($primary-color, 500);\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: 2px solid map-get($primary-color, 500);\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($medium-color, 700);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: none;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n}\n\n/* \n  IONIC components\n*/\nion-item.no-padding {\n  --padding-end: 0;\n  --padding-start: 0;\n}\n\nion-item.no-padding-full {\n  --padding-end: 0;\n  --padding-start: 0;\n  --inner-padding-end: 0;\n  --inner-padding-start: 0;\n}\nion-checkbox {\n  --checkbox-background-checked: rgba(174, 15, 10, 1);\n  --border-color-checked: rgba(174, 15, 10, 1);\n}\n\nion-input.custom-input {\n  --border-color: rgba(135, 135, 135, 1);\n  --padding-top: 5px;\n  --highlight-color: rgba(135, 135, 135, 1);\n}\nion-input.custom-input-user {\n  --border-color: #EFEFEF;\n  --padding-top: 5px;\n  --highlight-color: rgba(135, 135, 135, 1);\n}\nion-input.width-full {\n  --border-color: #EFEFEF !important;\n  --padding-top: 5px;\n  --highlight-color: rgb(37, 19, 19);\n}\n.filter-panel {\n  max-width: 100vw !important;\n}\n.date-select-modal-filter {\n  .mdc-text-field {\n    height: 35px;\n  }\n  .mat-mdc-form-field-infix {\n    height: 35px;\n    min-height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .select-year {\n    .mat-mdc-text-field-wrapper {\n      background-color: #f4f4f4;\n      border: 1px solid rgb(189, 188, 188);\n    }\n  }\n\n  .mdc-notched-outline__leading {\n    border: none !important;\n  }\n  .mdc-notched-outline__notch {\n    border: none !important;\n  }\n  .mdc-notched-outline__trailing {\n    border: none !important;\n  }\n}\n\n@media (min-width: 1025px) {\n  .filter-panel {\n    max-height: 33rem !important;\n    min-width: 60vw;\n  }\n\n  .anotation-panel {\n    max-width: 30rem !important;\n    max-height: 30rem !important;\n    min-width: 50vw;\n  }\n\n  .historic-panel {\n    min-width: 49.5rem;\n    min-height: 35.625rem;\n    min-width: 50vw;\n  }\n  .segments-panel {\n    width: 72vw;\n    min-width: 760px;\n    max-width: 1100px !important;\n    max-height: 90vh !important;\n  }\n  .new-highway-modal-panel {\n    min-width: 49.5rem;\n    min-height: 23.625rem;\n    min-width: 50vw;\n  }\n}\n\n@media (max-width: 1024px) {\n  .btn-actions {\n    margin-right: 15px;\n  }\n  .filter-panel {\n    min-height: 30rem;\n    max-width: 100vw !important;\n    min-width: 90vw;\n  }\n\n  .historic-panel {\n    max-width: 49.5rem;\n    min-width: 90vw !important;\n  }\n  .segments-panel {\n    max-width: 90vw !important;\n    min-width: 90vw !important;\n    max-height: 90vh !important;\n  }\n    .new-highway-modal-panel {\n  max-width: 49.5rem;\n    min-width: 90vw !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .anotation-panel {\n    width: 90%;\n  }\n}\n\n.mdc-text-field--filled:not(.mdc-text-field--disabled) {\n  background-color: transparent !important;\n}\n\n@media (max-width: 1024px) {\n  .mat-mdc-form-field-label {\n    font-size: 0.8rem;\n    /* Tamanho de fonte para dispositivos móveis */\n  }\n}\n\n.button_cad {\n  background-color: map-get($primary-color, 500);\n  padding: 0.5rem 2rem;\n  border-radius: 0.5rem;\n  color: #fff;\n  font-style: none;\n  text-decoration: none;\n\n  mat-icon {\n    color: #fff !important;\n  }\n}\n\n::ng-deep.mat-mdc-card-header-text {\n  display: none !important;\n}\n.input-error {\n  border: 1px solid red; /* Ajuste o estilo conforme necessário */\n}\n.card-mobile {\n  min-height: 10rem;\n  margin: 1rem auto;\n  border: 1px solid #cdcdcd;\n\n  .mat-mdc-card-header {\n    width: 90%;\n    display: flex;\n    margin: auto;\n    // align-items: center;\n    justify-content: space-between;\n    padding: 0rem;\n\n    p {\n      font-weight: bolder;\n      font-size: 1.2rem;\n      text-transform: uppercase;\n    }\n\n    span,\n    .subtitle {\n      font-size: 1rem;\n      font-weight: normal;\n      color: #cdcdcd;\n    }\n    @media (max-width: 1024px) {\n      width: 100%;\n      margin: 0 16px;\n    }\n  }\n\n  .mat-mdc-card-footer {\n    margin: 1rem 0rem;\n    border-top: 1px solid black;\n    display: flex;\n    align-items: center;\n\n    button {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n    }\n  }\n\n  .extension {\n    font-weight: bold;\n    color: map-get($primary-color, 500);\n  }\n  .formatAnotation {\n    @media (max-width: 1024px) {\n      padding: 0 16px;\n    }\n  }\n\n  .content-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .content-status {\n    width: 40%;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n\n    p {\n      font-weight: bold;\n    }\n  }\n}\n\n.card-mobile-empty {\n  border: 1px solid #cdcdcd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nion-button.more-filters-btn {\n  --background: rgba(174, 15, 10, 1);\n  --color: white;\n  --border-radius: 10px;\n  width: 100%;\n  max-width: 15rem;\n  text-transform: capitalize;\n  font-size: 0.9rem;\n  height: 100%;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n}\n\nion-item.fast-filters {\n  padding: 0.25rem 0rem;\n}\n\nion-chip.fast-filter-active-primary {\n  background-color: map-get($success-color, 700);\n  color: white;\n}\n\nion-chip.fast-filter-active-secondary {\n  background-color: map-get($danger-color, 500);\n  color: white;\n}\nion-chip.fast-filter-active-primary-contract {\n\n  color: #AE0F0A;\n  border: 1px solid #AE0F0A;\n  background: #E4ADB5;\n\n}\n\nion-chip.fast-filter-active-secondary-contract {\n  color: #AE0F0A;\n  border: 1px solid #AE0F0A;\n  background: #E4ADB5;\n}\n.more-filters-btn-row {\n  justify-content: center;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n\n  button {\n    margin: 5px;\n  }\n\n  @media (max-width: 767px) {\n    button {\n      margin: 5px 0;\n    }\n  }\n}\n\n.status-container {\n  display: flex;\n  align-items: center;\n\n  .mat-icon {\n    width: 1rem;\n  }\n\n  .status-icon {\n    font-size: 8px;\n    align-content: center;\n    text-align: center;\n  }\n\n  .active {\n    color: map-get($success-color, 700);\n  }\n\n  .inactive {\n    color: map-get($danger-color, 500);\n  }\n}\n\nion-textarea,\nion-input {\n  --border-color: rgba(87, 87, 86, 1);\n  --padding-top: 5px !important;\n  --highlight-color: rgba(135, 135, 135, 1);\n  --highlight-color-focused: rgba(135, 135, 135, 1) !important;\n  --highlight-color-valid: rgba(135, 135, 135, 1) !important;\n  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;\n}\n\nion-alert.custom-alert {\n  --backdrop-opacity: 0.7;\n}\n\nion-list.filtered-list {\n  display: flex;\n  flex-wrap: wrap;\n\n  span {\n    padding: 0.75rem 0;\n    margin: 0 0.75rem;\n    border-bottom: 1px solid map-get($light-color, 700);\n    width: 100%;\n  }\n}\n\nion-item.no-padding {\n  --padding-end: 0;\n  --padding-start: 0;\n}\n\n// Toast\nion-toast.snackbar-toast {\n  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);\n  --width: fit-content;\n  --border-radius: 0.75rem;\n  --white-space: pre-line;\n}\n\nion-toast.snackbar-toast {\n  &::part(container) {\n    background: #fff;\n    color: rgba(34, 36, 40, 1);\n    width: fit-content;\n    border-radius: 0.75rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-success {\n  &::part(container) {\n    border: 1px solid rgba(45, 211, 111, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(45, 211, 111, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-error {\n  &::part(container) {\n    border: 1px solid rgba(235, 68, 90, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(235, 68, 90, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-right {\n  --start: right;\n  --box-shadow: none;\n  --background: none;\n\n  &::part(container) {\n    transform: translateY(72px) !important;\n    box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);\n  }\n}\n\n::ng-deep.mat-tab-label {\n  min-width: 25px !important;\n  padding: 5px;\n  background-color: transparent;\n  color: red !important;\n  font-weight: 700;\n}\n\n/* Styles for the active tab label */\n::ng-deep.mat-tab-label.mat-tab-label-active {\n  min-width: 25px !important;\n  padding: 5px;\n  background-color: transparent;\n  color: red !important;\n  font-weight: 700;\n}\n\n::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab\n  .mdc-tab-indicator__content--underline {\n  border-color: #2b2b2b;\n}\n\n// .mat-mdc-tab .mdc-tab-indicator__content--underline {\n//   border-color: #2b2b2b;\n// }\n\n::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active\n  .mdc-tab__text-label {\n  color: #2b2b2b;\n}\n\n.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {\n      box-shadow: none !important;\n}\n.g-bubble {\n  box-shadow: none !important;\n}\napp-modal-historic-segment {\n  display: block;\n  width: 100%;\n  height: 45em;\n}\n\n.column-flex {\n  display: flex;\n  flex-flow: column;\n}\n\n.master-icon {\n  background-color: map-get($warning-color, 300);\n  color: map-get($dark-color, 500);\n  border-radius: 10px;\n  align-self: flex-start;\n  font-size: 10px;\n  padding: 0px 9px;\n  margin: 6px 0;\n  line-height: 17px;\n  font-weight: 600;\n\n  &.center-horizontal {\n    place-self: center;\n  }\n}\n\nion-popover {\n  --min-width: 375px;\n  --max-width: 500px;\n}\n.custom-tooltip-menu {\n  padding: 8px;\n  \n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n\n  .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {\n    background: none;\n  }\n  .mdc-evolution-chip__text-label {\n    color: #c00;\n  }\n}\n\n.custom-tooltip-menu .filter-title {\n  font-size: 12px;\n  font-weight: bold;\n  color: #333;\n  display: block;\n  margin-bottom: 4px;\n  border-bottom: 1px solid grey;\n}\n\n.custom-tooltip-menu .tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.custom-tooltip-menu mat-chip {\n  border: 1px solid #c00;\n  height: 20px;\n}\n\n.custom-tooltip-menu mat-chip mat-icon {\n  color: #c00 !important;\n  cursor: pointer;\n  font-size: 14px !important;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 0px !important;\n}\n.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {\n  color: #c00 !important;\n  cursor: pointer;\n  font-size: 12px !important;\n  opacity: 1;\n}\n::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline  {\n  border: 1px solid #c00 !important;\n}\n::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {\n  color: #c00 !important;\n}\nion-toggle {\n  --handle-background-checked: rgba(174, 15, 10, 1);\n  --track-background-checked: rgba(174, 15, 10, 0.38);\n}\napp-list-contracts {\n  thead{\n    background: #F4F4F4 !important;\n  }\n}\napp-table-default{\n  thead{\n    background: #F4F4F4 !important;\n  }\n}\n.mat-expansion-panel-body{\n  padding: 0px !important;\n}\n.mat-mdc-paginator-range-actions {\n \n  overflow-wrap: anywhere !important;\n  flex-grow: 1;\n  justify-content: center !important;\n  position: relative !important;\n}\n.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {\n  position: absolute !important;\n  left: 0 !important;\n}\n.mat-mdc-tab{\n  background-color: #F4F4F4 !important;\n}\n.mdc-tab--active{\n  background-color: white !important;\n}\n#paginator{\n  @media(max-width: 1025px){\n    width: 100%;\n  }\n\n}\nion-icon.search-icon-absolute {\n  position: absolute;\n  left: 16px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  z-index: 3;\n}\n\nion-input.search-input {\n  label.input-wrapper {\n    --padding-start: 55px;\n  }\n\n  &.has-focus,\n  &.has-value {\n    .input-wrapper {\n      .label-text-wrapper {\n      }\n    }\n  }\n}\n.mat-mdc-icon-button[disabled] {\n    cursor: default;\n        pointer-events: auto;\n    opacity: .38;\n}\n.mat-mdc-unelevated-button[disabled] {\n    cursor: default;\n      pointer-events: auto;\n    opacity: .38;\n}\n\n.item-inner{\n  padding-right: 0 !important;\n}\n\n.mat-mdc-paginator-page-size-label {\n  @media (max-width: 496px) {\n    display: none !important;\n  }\n}\n.comentarios .mdc-text-field--outlined {\n  --mdc-outlined-text-field-outline-width: 1px;\n  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */\n  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */\n  --mdc-outlined-text-field-container-shape: 4px;\n}\n// Gaps gerais\n.g-0 { gap: 0 !important; }\n.g-1 { gap: 0.25rem !important; }\n.g-2 { gap: 0.5rem !important; }\n.g-3 { gap: 1rem !important; }\n.g-4 { gap: 1.5rem !important; }\n.g-5 { gap: 3rem !important; }\n\n// Gaps horizontais\n.gx-0 { column-gap: 0 !important; }\n.gx-1 { column-gap: 0.25rem !important; }\n.gx-2 { column-gap: 0.5rem !important; }\n.gx-3 { column-gap: 1rem !important; }\n.gx-4 { column-gap: 1.5rem !important; }\n.gx-5 { column-gap: 3rem !important; }\n\n// Gaps verticais\n.gy-0 { row-gap: 0 !important; }\n.gy-1 { row-gap: 0.25rem !important; }\n.gy-2 { row-gap: 0.5rem !important; }\n.gy-3 { row-gap: 1rem !important; }\n.gy-4 { row-gap: 1.5rem !important; }\n.gy-5 { row-gap: 3rem !important; }\n.col {\n  flex: 1 0 0%;\n  max-width: 100%;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.col-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n.col-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n.col-3 { flex: 0 0 23%; max-width: 23%; }\n.col-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n.col-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n.col-6 { flex: 0 0 48%; max-width: 48%; }\n.col-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n.col-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n.col-9 { flex: 0 0 73%; max-width: 73%; }\n.col-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n.col-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n.col-12 { flex: 0 0 98%; max-width: 98%; }\n\n/* Colunas responsivas */\n@media (min-width: 576px) { /* sm */\n  .col-sm-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-sm-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-sm-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-sm-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-sm-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-sm-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-sm-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-sm-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-sm-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-sm-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-sm-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-sm-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 768px) { /* md */\n  .col-md-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-md-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-md-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-md-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-md-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-md-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-md-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-md-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-md-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-md-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-md-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-md-12 { flex: 0 0 100%; max-width: 100%; }\n}\n\n@media (min-width: 992px) { /* lg */\n  .col-lg-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-lg-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-lg-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-lg-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-lg-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-lg-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-lg-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-lg-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-lg-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-lg-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-lg-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-lg-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 1200px) { /* xl */\n  .col-xl-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-xl-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-xl-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-xl-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-xl-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-xl-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-xl-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-xl-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-xl-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-xl-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-xl-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-xl-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 1400px) { /* xxl */\n  .col-xxl-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-xxl-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-xxl-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-xxl-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-xxl-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-xxl-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-xxl-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-xxl-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-xxl-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-xxl-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-xxl-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-xxl-12 { flex: 0 0 98%; max-width: 98%; }\n}\n.ampliacao-panel{\n  max-width: 60vw !important;\n}\n.popover-content{\n  max-height: 150px;\n}\napp-form-projetos thead tr th{\n    font-family: \"Barlow\", sans-serif !important;\n    font-weight: 500 !important;\n    font-size: 18px !important;\n    line-height: 100% !important;\n  \n}\napp-form-projetos .mat-mdc-header-cell{\n    border: none !important;\n  \n}\napp-form-projetos .mat-mdc-form-field-subscript-wrapper {\n    display: none;\n}\n\n.mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background\n {\n    border-color: #AE0F0A !important;\n    background-color: #AE0F0A !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
